
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire78e9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire78e9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lVHOI", function(module, exports) {
$parcel$export(module.exports, "default", () => $b34bb29c7f07556d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("BbIhg")).CLIENT_VERSION);

var $hzcPW = parcelRequire("hzcPW");

var $BbIhg = parcelRequire("BbIhg");



var $42xfx = parcelRequire("42xfx");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $b34bb29c7f07556d$var$FeatureGates {
    static{
        this.client = new (0, $hzcPW.Client)();
    }
    static{
        this.hasCheckGateErrorOccurred = false;
    }
    static{
        this.hasGetExperimentValueErrorOccurred = false;
    }
    static{
        this.checkGate = (gateName, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                    // Attempt to retrieve an override value for the feature gate
                    const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                    // If an override value is found, return it immediately
                    if (overrideValue !== undefined) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$b34bb29c7f07556d$var$FeatureGates.hasCheckGateErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                        gateName: gateName,
                        error: error
                    });
                    $b34bb29c7f07556d$var$FeatureGates.hasCheckGateErrorOccurred = true;
                }
            }
            // Proceed with the main logic if no override is found
            return this.client.checkGate(gateName, options);
        };
    }
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static{
        this.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
            try {
                // Check if the CRITERION override mechanism is available
                if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                    const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                    if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
                }
            } catch (error) {
                // Log the first occurrence of the error
                if (!$b34bb29c7f07556d$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                    // eslint-disable-next-line no-console
                    console.warn({
                        msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                        experimentName: experimentName,
                        defaultValue: defaultValue,
                        options: options,
                        error: error
                    });
                    this.hasGetExperimentValueErrorOccurred = true;
                }
                return defaultValue;
            }
            // Proceed with the main logic if no override is found
            return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
        };
    }
    static{
        this.initializeCalled = this.client.initializeCalled.bind(this.client);
    }
    static{
        this.initializeCompleted = this.client.initializeCompleted.bind(this.client);
    }
    static{
        this.waitUntilInitializeCompleted = this.client.waitUntilInitializeCompleted.bind(this.client);
    }
    static{
        this.initialize = this.client.initialize.bind(this.client);
    }
    static{
        this.initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    }
    static{
        this.initializeFromValues = this.client.initializeFromValues.bind(this.client);
    }
    static{
        this.manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    }
    static{
        this.getExperiment = this.client.getExperiment.bind(this.client);
    }
    static{
        this.manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    }
    static{
        this.manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    }
    static{
        this.shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    }
    static{
        this.overrideGate = this.client.overrideGate.bind(this.client);
    }
    static{
        this.clearGateOverride = this.client.clearGateOverride.bind(this.client);
    }
    static{
        this.overrideConfig = this.client.overrideConfig.bind(this.client);
    }
    static{
        this.clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    }
    static{
        this.setOverrides = this.client.setOverrides.bind(this.client);
    }
    static{
        this.getOverrides = this.client.getOverrides.bind(this.client);
    }
    static{
        this.clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    }
    static{
        this.isCurrentUser = this.client.isCurrentUser.bind(this.client);
    }
    static{
        this.onGateUpdated = this.client.onGateUpdated.bind(this.client);
    }
    static{
        this.onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    }
    static{
        this.onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    }
    static{
        this.updateUser = this.client.updateUser.bind(this.client);
    }
    static{
        this.updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    }
    static{
        this.updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    }
    static{
        this.getPackageVersion = this.client.getPackageVersion.bind(this.client);
    }
    static{
        this.getLayer = this.client.getLayer.bind(this.client);
    }
    static{
        this.getLayerValue = this.client.getLayerValue.bind(this.client);
    }
}
let $b34bb29c7f07556d$var$boundFGJS = $b34bb29c7f07556d$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $b34bb29c7f07556d$var$FeatureGates;
    else {
        $b34bb29c7f07556d$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $b34bb29c7f07556d$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $BbIhg.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $BbIhg.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $b34bb29c7f07556d$export$2e2bcd8739ae039 = $b34bb29c7f07556d$var$boundFGJS;

});
parcelRegister("hzcPW", function(module, exports) {
$parcel$export(module.exports, "Client", () => $f74a8aaba17a4797$export$1f2bb630327ac4b6);

var $j2RLX = parcelRequire("j2RLX");

var $ih3by = parcelRequire("ih3by");

var $fSvdU = parcelRequire("fSvdU");

var $7wf33 = parcelRequire("7wf33");

var $eVuiw = parcelRequire("eVuiw");

var $2znIb = parcelRequire("2znIb");

var $6jMQ7 = parcelRequire("6jMQ7");

var $hDEZe = parcelRequire("hDEZe");

var $42xfx = parcelRequire("42xfx");

var $4ALgQ = parcelRequire("4ALgQ");

var $BbIhg = parcelRequire("BbIhg");
const $f74a8aaba17a4797$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $f74a8aaba17a4797$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $f74a8aaba17a4797$export$1f2bb630327ac4b6 {
    constructor({ localStorageKey: localStorageKey = (0, $hDEZe.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
   * True if an initialize method was called and completed, meaning the client is now usable.
   * However if there was an error during initialization it may have initialized with default
   * values. Use {@link initCompleted} to check for this.
   */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, $ih3by.default)();
        this.dataAdapter = new (0, $6jMQ7.NoFetchDataAdapter)();
        /**
   * Call this if modifying the values being served by the Statsig library since it has its own
   * memoization cache which will not be updated if the values are changed outside of the library.
   */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $hDEZe.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $4ALgQ.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $4ALgQ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $4ALgQ.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $4ALgQ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $BbIhg.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $BbIhg.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $42xfx.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $4ALgQ.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $4ALgQ.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $4ALgQ.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $2znIb.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $fSvdU.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $fSvdU.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $eVuiw.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $4ALgQ.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $4ALgQ.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        if (clientOptions.localMode) {
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            return;
        }
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $2znIb.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $2znIb.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $4ALgQ.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $f74a8aaba17a4797$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $f74a8aaba17a4797$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $42xfx.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        const frontendUser = (0, $4ALgQ.toStatsigUser)(identifiers, customAttributes);
        this.user = (0, $4ALgQ.deepAssign)({}, initializeValues.user, frontendUser);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $j2RLX.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $j2RLX.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $j2RLX.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $j2RLX.StatsigClient)($f74a8aaba17a4797$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            const frontendUser = (0, $4ALgQ.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
            user = (0, $4ALgQ.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $BbIhg.CLIENT_VERSION;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $7wf33.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $7wf33.Layer).fromLayer((0, $j2RLX._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("j2RLX", function(module, exports) {
"use strict";
var $ddd7ea52f3e4bfb0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ddd7ea52f3e4bfb0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ddd7ea52f3e4bfb0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $dm0Dd = parcelRequire("dm0Dd");
module.exports.StatsigClient = $dm0Dd.default;

$ddd7ea52f3e4bfb0$var$__exportStar((parcelRequire("alCOo")), module.exports);
const $ddd7ea52f3e4bfb0$var$__STATSIG__ = Object.assign((0, (parcelRequire("alCOo"))._getStatsigGlobal)(), {
    StatsigClient: $dm0Dd.default
});
module.exports.default = $ddd7ea52f3e4bfb0$var$__STATSIG__;

});
parcelRegister("alCOo", function(module, exports) {
"use strict";
var $7889f8c51911367a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7889f8c51911367a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7889f8c51911367a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("1TTuM")).Diagnostics;
    }
});

var $8vIHs = parcelRequire("8vIHs");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $8vIHs.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("40Zyh")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("1rvxq")).Storage;
    }
});

$7889f8c51911367a$var$__exportStar((parcelRequire("eq24U")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("cGeSD")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("99Tga")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("8FqHg")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("1TTuM")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("8Iuy2")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("813Cq")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("iz1xW")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("euVkL")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("2COhT")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("7hdcX")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("40Zyh")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("cOkw0")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("gQJsm")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("lyoyB")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("dSDmj")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("15QQk")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("c50UJ")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("a046V")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("lxP22")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("fQZMT")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("gNIDT")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("azCZT")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("9fRgZ")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("kKGSP")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("hL3NJ")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("1bRIV")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("kZnRJ")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("8wtQg")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("8r6oH")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("9VZ0X")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("4h8U0")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("1rvxq")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("5s9Kp")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("9pDV4")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("kCuaG")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("lT7qF")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("6SH39")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("3bn8J")), module.exports);

$7889f8c51911367a$var$__exportStar((parcelRequire("5AhNR")), module.exports);
Object.assign((0, (parcelRequire("eq24U"))._getStatsigGlobal)(), {
    Log: (parcelRequire("40Zyh")).Log,
    SDK_VERSION: (parcelRequire("1bRIV")).SDK_VERSION
});

});
parcelRegister("eq24U", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $a7f51b13cee1da1c$var$_a, $a7f51b13cee1da1c$var$_b, $a7f51b13cee1da1c$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $40Zyh = parcelRequire("40Zyh");
const $a7f51b13cee1da1c$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $a7f51b13cee1da1c$var$statsigGlobal;
    } catch (e) {
        return $a7f51b13cee1da1c$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $a7f51b13cee1da1c$var$_getStatsigGlobal;
const $a7f51b13cee1da1c$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $a7f51b13cee1da1c$var$_getStatsigGlobalFlag;
const $a7f51b13cee1da1c$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $40Zyh.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $a7f51b13cee1da1c$var$_getInstance;
const $a7f51b13cee1da1c$var$GLOBAL_KEY = '__STATSIG__';
const $a7f51b13cee1da1c$var$_window = typeof window !== 'undefined' ? window : {};
const $a7f51b13cee1da1c$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $a7f51b13cee1da1c$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $a7f51b13cee1da1c$var$statsigGlobal = ($a7f51b13cee1da1c$var$_c = ($a7f51b13cee1da1c$var$_b = ($a7f51b13cee1da1c$var$_a = $a7f51b13cee1da1c$var$_window[$a7f51b13cee1da1c$var$GLOBAL_KEY]) !== null && $a7f51b13cee1da1c$var$_a !== void 0 ? $a7f51b13cee1da1c$var$_a : $a7f51b13cee1da1c$var$_global[$a7f51b13cee1da1c$var$GLOBAL_KEY]) !== null && $a7f51b13cee1da1c$var$_b !== void 0 ? $a7f51b13cee1da1c$var$_b : $a7f51b13cee1da1c$var$_globalThis[$a7f51b13cee1da1c$var$GLOBAL_KEY]) !== null && $a7f51b13cee1da1c$var$_c !== void 0 ? $a7f51b13cee1da1c$var$_c : {
    instance: module.exports._getInstance
};
$a7f51b13cee1da1c$var$_window[$a7f51b13cee1da1c$var$GLOBAL_KEY] = $a7f51b13cee1da1c$var$statsigGlobal;
$a7f51b13cee1da1c$var$_global[$a7f51b13cee1da1c$var$GLOBAL_KEY] = $a7f51b13cee1da1c$var$statsigGlobal;
$a7f51b13cee1da1c$var$_globalThis[$a7f51b13cee1da1c$var$GLOBAL_KEY] = $a7f51b13cee1da1c$var$statsigGlobal;

});
parcelRegister("40Zyh", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $2ec6e86c882a2164$var$DEBUG = ' DEBUG ';
const $2ec6e86c882a2164$var$_INFO = '  INFO ';
const $2ec6e86c882a2164$var$_WARN = '  WARN ';
const $2ec6e86c882a2164$var$ERROR = ' ERROR ';
function $2ec6e86c882a2164$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $2ec6e86c882a2164$var$Log {
    static info(...args) {
        if ($2ec6e86c882a2164$var$Log.level >= module.exports.LogLevel.Info) console.info($2ec6e86c882a2164$var$_INFO, ...$2ec6e86c882a2164$var$addTag(args));
    }
    static debug(...args) {
        if ($2ec6e86c882a2164$var$Log.level >= module.exports.LogLevel.Debug) console.debug($2ec6e86c882a2164$var$DEBUG, ...$2ec6e86c882a2164$var$addTag(args));
    }
    static warn(...args) {
        if ($2ec6e86c882a2164$var$Log.level >= module.exports.LogLevel.Warn) console.warn($2ec6e86c882a2164$var$_WARN, ...$2ec6e86c882a2164$var$addTag(args));
    }
    static error(...args) {
        if ($2ec6e86c882a2164$var$Log.level >= module.exports.LogLevel.Error) console.error($2ec6e86c882a2164$var$ERROR, ...$2ec6e86c882a2164$var$addTag(args));
    }
}
module.exports.Log = $2ec6e86c882a2164$var$Log;
$2ec6e86c882a2164$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("1TTuM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $1625f9c142231f09$var$MARKER_MAP = new Map();
const $1625f9c142231f09$var$ACT_START = 'start';
const $1625f9c142231f09$var$ACT_END = 'end';
const $1625f9c142231f09$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $1625f9c142231f09$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $1625f9c142231f09$var$_addMarker(sdkKey, $1625f9c142231f09$var$_createMarker({}, $1625f9c142231f09$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $1625f9c142231f09$var$_addMarker(sdkKey, $1625f9c142231f09$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $1625f9c142231f09$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $1625f9c142231f09$var$_addMarker(sdkKey, $1625f9c142231f09$var$_createMarker(data, $1625f9c142231f09$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $1625f9c142231f09$var$_addMarker(sdkKey, $1625f9c142231f09$var$_createMarker(data, $1625f9c142231f09$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $1625f9c142231f09$var$_addMarker(sdkKey, $1625f9c142231f09$var$_createMarker({}, $1625f9c142231f09$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $1625f9c142231f09$var$_addMarker(sdkKey, $1625f9c142231f09$var$_createMarker(data, $1625f9c142231f09$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $1625f9c142231f09$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $1625f9c142231f09$var$_safeGetField(e, 'code'),
            name: $1625f9c142231f09$var$_safeGetField(e, 'name'),
            message: $1625f9c142231f09$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $1625f9c142231f09$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $1625f9c142231f09$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $1625f9c142231f09$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $1625f9c142231f09$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $1625f9c142231f09$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $1625f9c142231f09$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $1625f9c142231f09$var$MARKER_MAP.set(sdkKey, markers);
}
function $1625f9c142231f09$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("8vIHs", function(module, exports) {
"use strict";
var $6323e47a7372c79c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $cGeSD = parcelRequire("cGeSD");

var $2COhT = parcelRequire("2COhT");

var $40Zyh = parcelRequire("40Zyh");

var $gQJsm = parcelRequire("gQJsm");

var $c50UJ = parcelRequire("c50UJ");

var $hL3NJ = parcelRequire("hL3NJ");

var $kZnRJ = parcelRequire("kZnRJ");

var $1rvxq = parcelRequire("1rvxq");

var $kCuaG = parcelRequire("kCuaG");

var $6SH39 = parcelRequire("6SH39");
const $6323e47a7372c79c$var$DEFAULT_QUEUE_SIZE = 100;
const $6323e47a7372c79c$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $6323e47a7372c79c$var$MAX_DEDUPER_KEYS = 1000;
const $6323e47a7372c79c$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $6323e47a7372c79c$var$MAX_FAILED_LOGS = 500;
const $6323e47a7372c79c$var$QUICK_FLUSH_WINDOW_MS = 200;
const $6323e47a7372c79c$var$EVENT_LOGGER_MAP = {};
class $6323e47a7372c79c$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $6323e47a7372c79c$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $6323e47a7372c79c$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $kZnRJ.LoggingEnabledOption.disabled : $kZnRJ.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $40Zyh.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $6323e47a7372c79c$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $kCuaG.UrlConfiguration($gQJsm.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $1rvxq._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $1rvxq.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $6323e47a7372c79c$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $c50UJ._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $6323e47a7372c79c$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $6SH39._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $6323e47a7372c79c$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $6323e47a7372c79c$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $6323e47a7372c79c$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $6323e47a7372c79c$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $6323e47a7372c79c$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $6323e47a7372c79c$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$6323e47a7372c79c$var$EventLogger._safeFlushAndForget(this._sdkKey), $6323e47a7372c79c$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $c50UJ._isServerEnv)()) return false;
        if (!(0, $hL3NJ._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $cGeSD._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $6323e47a7372c79c$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $6323e47a7372c79c$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $6323e47a7372c79c$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $6SH39._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $40Zyh.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $40Zyh.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $6323e47a7372c79c$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$gQJsm.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $6323e47a7372c79c$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $1rvxq._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $40Zyh.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $1rvxq._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$6323e47a7372c79c$var$__awaiter(this, void 0, void 0, function*() {
                if (!$1rvxq.Storage.isReady()) yield $1rvxq.Storage.isReadyResolver();
                const events = (0, $1rvxq._getObjectFromStorage)(storageKey);
                if (!events) return;
                $1rvxq.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $40Zyh.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $2COhT._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $40Zyh.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $c50UJ._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $6323e47a7372c79c$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $6323e47a7372c79c$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $6323e47a7372c79c$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $6323e47a7372c79c$var$EventLogger;

});
parcelRegister("cGeSD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $2COhT = parcelRequire("2COhT");
function $93b4f3295bb58f46$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $2COhT._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $93b4f3295bb58f46$var$_getUserStorageKey;
function $93b4f3295bb58f46$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $93b4f3295bb58f46$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $2COhT._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $93b4f3295bb58f46$var$_getStorageKey;

});
parcelRegister("2COhT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $9pDV4 = parcelRequire("9pDV4");
const $1e9623703eebe0a7$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $1e9623703eebe0a7$var$_DJB2;
const $1e9623703eebe0a7$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $1e9623703eebe0a7$var$_DJB2Object;
const $1e9623703eebe0a7$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $9pDV4._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $1e9623703eebe0a7$var$_getSortedObject;

});
parcelRegister("9pDV4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $6da56a0dd7bfcc18$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $6da56a0dd7bfcc18$var$_typeOf;
function $6da56a0dd7bfcc18$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $6da56a0dd7bfcc18$var$_isTypeMatch;

});



parcelRegister("gQJsm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("c50UJ", function(module, exports) {

var $hcSxw = parcelRequire("hcSxw");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $8cb6a92d68461293$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $8cb6a92d68461293$var$_getWindowSafe;
const $8cb6a92d68461293$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $8cb6a92d68461293$var$_getDocumentSafe;
const $8cb6a92d68461293$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $hcSxw !== 'undefined' && $hcSxw.versions != null && $hcSxw.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $8cb6a92d68461293$var$_isServerEnv;
const $8cb6a92d68461293$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $8cb6a92d68461293$var$_addWindowEventListenerSafe;
const $8cb6a92d68461293$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $8cb6a92d68461293$var$_addDocumentEventListenerSafe;
const $8cb6a92d68461293$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $8cb6a92d68461293$var$_getCurrentPageUrlSafe;
const $8cb6a92d68461293$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $8cb6a92d68461293$var$_getUnloadEvent;

});

parcelRegister("hL3NJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $ced9c64bac7b4b36$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $ced9c64bac7b4b36$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $ced9c64bac7b4b36$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $ced9c64bac7b4b36$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $ced9c64bac7b4b36$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $ced9c64bac7b4b36$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $ced9c64bac7b4b36$var$GATE_EXPOSURE_NAME || eventName === $ced9c64bac7b4b36$var$CONFIG_EXPOSURE_NAME || eventName === $ced9c64bac7b4b36$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $ced9c64bac7b4b36$var$_isExposureEvent;
const $ced9c64bac7b4b36$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $ced9c64bac7b4b36$var$_createExposure($ced9c64bac7b4b36$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $ced9c64bac7b4b36$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $ced9c64bac7b4b36$var$_createGateExposure;
function $ced9c64bac7b4b36$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $ced9c64bac7b4b36$var$_mapExposures;
const $ced9c64bac7b4b36$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $ced9c64bac7b4b36$var$_createExposure($ced9c64bac7b4b36$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $ced9c64bac7b4b36$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $ced9c64bac7b4b36$var$_createConfigExposure;
const $ced9c64bac7b4b36$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $ced9c64bac7b4b36$var$_createExposure($ced9c64bac7b4b36$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $ced9c64bac7b4b36$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $ced9c64bac7b4b36$var$_createLayerParameterExposure;
const $ced9c64bac7b4b36$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("kZnRJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("1rvxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $40Zyh = parcelRequire("40Zyh");

var $c50UJ = parcelRequire("c50UJ");
const $10d0c6e184d64b25$var$inMemoryStore = {};
const $10d0c6e184d64b25$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$10d0c6e184d64b25$var$inMemoryStore[key] ? $10d0c6e184d64b25$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $10d0c6e184d64b25$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $10d0c6e184d64b25$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($10d0c6e184d64b25$var$inMemoryStore)
};
let $10d0c6e184d64b25$var$_localStorageProvider = null;
try {
    const win = (0, $c50UJ._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $10d0c6e184d64b25$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $40Zyh.Log.warn('Failed to setup localStorageProvider.');
}
let $10d0c6e184d64b25$var$_main = $10d0c6e184d64b25$var$_localStorageProvider !== null && $10d0c6e184d64b25$var$_localStorageProvider !== void 0 ? $10d0c6e184d64b25$var$_localStorageProvider : $10d0c6e184d64b25$var$_inMemoryProvider;
let $10d0c6e184d64b25$var$_current = $10d0c6e184d64b25$var$_main;
function $10d0c6e184d64b25$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($10d0c6e184d64b25$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$10d0c6e184d64b25$var$_current.isReady(),
    isReadyResolver: ()=>$10d0c6e184d64b25$var$_current.isReadyResolver(),
    getProviderName: ()=>$10d0c6e184d64b25$var$_current.getProviderName(),
    getItem: (key)=>$10d0c6e184d64b25$var$_inMemoryBreaker(()=>$10d0c6e184d64b25$var$_current.getItem(key)),
    setItem: (key, value)=>$10d0c6e184d64b25$var$_inMemoryBreaker(()=>$10d0c6e184d64b25$var$_current.setItem(key, value)),
    removeItem: (key)=>$10d0c6e184d64b25$var$_current.removeItem(key),
    getAllKeys: ()=>$10d0c6e184d64b25$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $10d0c6e184d64b25$var$_main = newProvider;
        $10d0c6e184d64b25$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $10d0c6e184d64b25$var$_current = $10d0c6e184d64b25$var$_inMemoryProvider;
        else $10d0c6e184d64b25$var$_current = $10d0c6e184d64b25$var$_main;
    }
};
function $10d0c6e184d64b25$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $40Zyh.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $10d0c6e184d64b25$var$_getObjectFromStorage;
function $10d0c6e184d64b25$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $10d0c6e184d64b25$var$_setObjectInStorage;

});

parcelRegister("kCuaG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $2COhT = parcelRequire("2COhT");

var $gQJsm = parcelRequire("gQJsm");
const $f02ec2ad5534fde8$var$ENDPOINT_DNS_KEY_MAP = {
    [$gQJsm.Endpoint._initialize]: 'i',
    [$gQJsm.Endpoint._rgstr]: 'e',
    [$gQJsm.Endpoint._download_config_specs]: 'd'
};
class $f02ec2ad5534fde8$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $f02ec2ad5534fde8$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $gQJsm.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $2COhT._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $f02ec2ad5534fde8$var$UrlConfiguration;

});

parcelRegister("6SH39", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $c50UJ = parcelRequire("c50UJ");
const $50292e048dfeecf2$var$FOREGROUND = 'foreground';
const $50292e048dfeecf2$var$BACKGROUND = 'background';
const $50292e048dfeecf2$var$LISTENERS = [];
let $50292e048dfeecf2$var$current = $50292e048dfeecf2$var$FOREGROUND;
let $50292e048dfeecf2$var$isUnloading = false;
const $50292e048dfeecf2$var$_isCurrentlyVisible = ()=>{
    return $50292e048dfeecf2$var$current === $50292e048dfeecf2$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $50292e048dfeecf2$var$_isCurrentlyVisible;
const $50292e048dfeecf2$var$_isUnloading = ()=>$50292e048dfeecf2$var$isUnloading;
module.exports._isUnloading = $50292e048dfeecf2$var$_isUnloading;
const $50292e048dfeecf2$var$_subscribeToVisiblityChanged = (listener)=>{
    $50292e048dfeecf2$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $50292e048dfeecf2$var$_subscribeToVisiblityChanged;
const $50292e048dfeecf2$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $50292e048dfeecf2$var$current) return;
    $50292e048dfeecf2$var$current = visibility;
    $50292e048dfeecf2$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $50292e048dfeecf2$var$_notifyVisibilityChanged;
(0, $c50UJ._addWindowEventListenerSafe)('focus', ()=>{
    $50292e048dfeecf2$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($50292e048dfeecf2$var$FOREGROUND);
});
(0, $c50UJ._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($50292e048dfeecf2$var$BACKGROUND));
(0, $c50UJ._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $50292e048dfeecf2$var$FOREGROUND : $50292e048dfeecf2$var$BACKGROUND);
});
(0, $c50UJ._addWindowEventListenerSafe)((0, $c50UJ._getUnloadEvent)(), ()=>{
    $50292e048dfeecf2$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($50292e048dfeecf2$var$BACKGROUND);
});

});


parcelRegister("1bRIV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $0de07de6cea9bc8e$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$0de07de6cea9bc8e$var$metadata,
    add: (additions)=>{
        $0de07de6cea9bc8e$var$metadata = Object.assign(Object.assign({}, $0de07de6cea9bc8e$var$metadata), additions);
    }
};

});

parcelRegister("99Tga", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8FqHg", function(module, exports) {
"use strict";
var $64f6dc7dd5da13e1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $40Zyh = parcelRequire("40Zyh");

var $gNIDT = parcelRequire("gNIDT");

var $4h8U0 = parcelRequire("4h8U0");

var $1rvxq = parcelRequire("1rvxq");

var $5s9Kp = parcelRequire("5s9Kp");
const $64f6dc7dd5da13e1$var$CACHE_LIMIT = 10;
const $64f6dc7dd5da13e1$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $64f6dc7dd5da13e1$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $64f6dc7dd5da13e1$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $64f6dc7dd5da13e1$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $4h8U0._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $4h8U0._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $64f6dc7dd5da13e1$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $gNIDT.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $64f6dc7dd5da13e1$var$__awaiter(this, void 0, void 0, function*() {
            if (!$1rvxq.Storage.isReady()) yield $1rvxq.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $40Zyh.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $64f6dc7dd5da13e1$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $4h8U0._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $64f6dc7dd5da13e1$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $40Zyh.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $5s9Kp._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $gNIDT.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $64f6dc7dd5da13e1$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $64f6dc7dd5da13e1$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $40Zyh.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $1rvxq.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($1rvxq.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $5s9Kp._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $64f6dc7dd5da13e1$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $1rvxq.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $1rvxq._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $64f6dc7dd5da13e1$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $1rvxq.Storage.removeItem(evictable);
        }
        (0, $1rvxq._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $64f6dc7dd5da13e1$var$DataAdapterCore;
function $64f6dc7dd5da13e1$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $4h8U0._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $64f6dc7dd5da13e1$var$_makeDataAdapterResult;
class $64f6dc7dd5da13e1$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $40Zyh.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $64f6dc7dd5da13e1$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $64f6dc7dd5da13e1$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("gNIDT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $cGeSD = parcelRequire("cGeSD");

var $40Zyh = parcelRequire("40Zyh");

var $c50UJ = parcelRequire("c50UJ");

var $1rvxq = parcelRequire("1rvxq");

var $lT7qF = parcelRequire("lT7qF");
const $c3b3da011883d7be$var$PROMISE_MAP = {};
const $c3b3da011883d7be$var$COOKIE_ENABLED_MAP = {};
const $c3b3da011883d7be$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($c3b3da011883d7be$var$DISABLED_MAP[sdkKey]) return null;
        if ($c3b3da011883d7be$var$PROMISE_MAP[sdkKey] != null) return $c3b3da011883d7be$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $c3b3da011883d7be$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $c3b3da011883d7be$var$PROMISE_MAP[sdkKey] = stableID;
            $c3b3da011883d7be$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $c3b3da011883d7be$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $lT7qF.getUUID)();
        $c3b3da011883d7be$var$_persistToStorage(stableID, sdkKey);
        $c3b3da011883d7be$var$_persistToCookie(stableID, sdkKey);
        $c3b3da011883d7be$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $c3b3da011883d7be$var$PROMISE_MAP[sdkKey] = override;
        $c3b3da011883d7be$var$_persistToStorage(override, sdkKey);
        $c3b3da011883d7be$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $c3b3da011883d7be$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $c3b3da011883d7be$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $c3b3da011883d7be$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $cGeSD._getStorageKey)(sdkKey)}`;
}
function $c3b3da011883d7be$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $c3b3da011883d7be$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $1rvxq._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $40Zyh.Log.warn('Failed to save StableID to storage');
    }
}
function $c3b3da011883d7be$var$_loadFromStorage(sdkKey) {
    const storageKey = $c3b3da011883d7be$var$_getStableIDStorageKey(sdkKey);
    return (0, $1rvxq._getObjectFromStorage)(storageKey);
}
function $c3b3da011883d7be$var$_loadFromCookie(sdkKey) {
    if (!$c3b3da011883d7be$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $c50UJ._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $c3b3da011883d7be$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $c3b3da011883d7be$var$_persistToCookie(stableID, sdkKey) {
    if (!$c3b3da011883d7be$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $c50UJ._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$c3b3da011883d7be$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $c3b3da011883d7be$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $cGeSD._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $c3b3da011883d7be$var$getCookieName;

});
parcelRegister("lT7qF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $041cb7bb1315bd44$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $041cb7bb1315bd44$var$getUUID;

});


parcelRegister("4h8U0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $2COhT = parcelRequire("2COhT");

var $40Zyh = parcelRequire("40Zyh");
function $31cfa7c7b1a5fa5c$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $40Zyh.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $31cfa7c7b1a5fa5c$var$_normalizeUser;
function $31cfa7c7b1a5fa5c$var$_getFullUserHash(user) {
    return user ? (0, $2COhT._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $31cfa7c7b1a5fa5c$var$_getFullUserHash;

});

parcelRegister("5s9Kp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $40Zyh = parcelRequire("40Zyh");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $3f8720ed3f845d05$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $40Zyh.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $3f8720ed3f845d05$var$_typedJsonParse;

});


parcelRegister("8Iuy2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("813Cq", function(module, exports) {
"use strict";
var $5d613956512235aa$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $40Zyh = parcelRequire("40Zyh");

var $a046V = parcelRequire("a046V");

var $1bRIV = parcelRequire("1bRIV");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $5d613956512235aa$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $5d613956512235aa$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $5d613956512235aa$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $5d613956512235aa$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $40Zyh.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$5d613956512235aa$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($5d613956512235aa$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $5d613956512235aa$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $a046V.SDKType._get(this._sdkKey);
                    const statsigMetadata = $1bRIV.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $5d613956512235aa$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $5d613956512235aa$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $5d613956512235aa$var$ErrorBoundary;
function $5d613956512235aa$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $5d613956512235aa$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $5d613956512235aa$var$UNKNOWN_ERROR;
    }
}
function $5d613956512235aa$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $5d613956512235aa$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("a046V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $747d17be44d59361$var$SDK_CLIENT = {};
let $747d17be44d59361$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $747d17be44d59361$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($747d17be44d59361$var$suffix !== null && $747d17be44d59361$var$suffix !== void 0 ? $747d17be44d59361$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $747d17be44d59361$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$747d17be44d59361$var$suffix || $747d17be44d59361$var$suffix === '-react') $747d17be44d59361$var$suffix = '-' + binding;
    }
};

});


parcelRegister("iz1xW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("euVkL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7hdcX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cOkw0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $953a116e8c783578$var$EXIST_KEYS = new Set([]);
const $953a116e8c783578$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $953a116e8c783578$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($953a116e8c783578$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($953a116e8c783578$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $953a116e8c783578$var$createMemoKey;

});

parcelRegister("lyoyB", function(module, exports) {
"use strict";
var $fb0fd27a75b2968e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $eq24U = parcelRequire("eq24U");

var $eq24U = parcelRequire("eq24U");

var $1TTuM = parcelRequire("1TTuM");

var $40Zyh = parcelRequire("40Zyh");

var $gQJsm = parcelRequire("gQJsm");

var $g30XT = parcelRequire("g30XT");

var $5AhNR = parcelRequire("5AhNR");

var $a046V = parcelRequire("a046V");

var $c50UJ = parcelRequire("c50UJ");

var $lxP22 = parcelRequire("lxP22");

var $gNIDT = parcelRequire("gNIDT");

var $9fRgZ = parcelRequire("9fRgZ");

var $1bRIV = parcelRequire("1bRIV");

var $kZnRJ = parcelRequire("kZnRJ");

var $6SH39 = parcelRequire("6SH39");
const $fb0fd27a75b2968e$var$DEFAULT_TIMEOUT_MS = 10000;
const $fb0fd27a75b2968e$var$BACKOFF_BASE_MS = 500;
const $fb0fd27a75b2968e$var$BACKOFF_MAX_MS = 30000;
const $fb0fd27a75b2968e$var$RATE_LIMIT_WINDOW_MS = 1000;
const $fb0fd27a75b2968e$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $fb0fd27a75b2968e$var$LEAK_RATE = $fb0fd27a75b2968e$var$RATE_LIMIT_MAX_REQ_COUNT / $fb0fd27a75b2968e$var$RATE_LIMIT_WINDOW_MS;
const $fb0fd27a75b2968e$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $fb0fd27a75b2968e$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $fb0fd27a75b2968e$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $g30XT.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$fb0fd27a75b2968e$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $fb0fd27a75b2968e$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $fb0fd27a75b2968e$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$fb0fd27a75b2968e$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $40Zyh.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $6SH39._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $fb0fd27a75b2968e$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $fb0fd27a75b2968e$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $fb0fd27a75b2968e$var$_getErrorMessage(error);
                const timedOut = $fb0fd27a75b2968e$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $fb0fd27a75b2968e$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$fb0fd27a75b2968e$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $9fRgZ.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $40Zyh.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $fb0fd27a75b2968e$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $kZnRJ.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $kZnRJ.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $fb0fd27a75b2968e$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $fb0fd27a75b2968e$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $gQJsm.Endpoint._initialize || args.urlConfig.endpoint === $gQJsm.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$gQJsm.NetworkParam.SdkKey]: args.sdkKey,
            [$gQJsm.NetworkParam.SdkType]: $a046V.SDKType._get(args.sdkKey),
            [$gQJsm.NetworkParam.SdkVersion]: $1bRIV.SDK_VERSION,
            [$gQJsm.NetworkParam.Time]: String(Date.now()),
            [$gQJsm.NetworkParam.SessionID]: $lxP22.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $c50UJ._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $eq24U._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$gQJsm.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $40Zyh.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $fb0fd27a75b2968e$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$fb0fd27a75b2968e$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($40Zyh.Log.error);
                writer.close().catch($40Zyh.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$gQJsm.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $40Zyh.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $fb0fd27a75b2968e$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $fb0fd27a75b2968e$var$NetworkCore;
const $fb0fd27a75b2968e$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $40Zyh.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $fb0fd27a75b2968e$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $gNIDT.StableID.get(sdkKey);
    const sessionID = $lxP22.SessionID.get(sdkKey);
    const sdkType = $a046V.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $1bRIV.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $fb0fd27a75b2968e$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $eq24U._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $5AhNR.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $kZnRJ.LogEventCompressionMode.Disabled:
            return false;
        case $kZnRJ.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $kZnRJ.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $fb0fd27a75b2968e$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $fb0fd27a75b2968e$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $fb0fd27a75b2968e$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $gQJsm.Endpoint._initialize) return;
    $1TTuM.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $fb0fd27a75b2968e$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $gQJsm.Endpoint._initialize) return;
    $1TTuM.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $1TTuM.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $fb0fd27a75b2968e$var$_exponentialBackoff(attempt) {
    return $fb0fd27a75b2968e$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($fb0fd27a75b2968e$var$BACKOFF_BASE_MS * (attempt * attempt), $fb0fd27a75b2968e$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("g30XT", function(module, exports) {
"use strict";
var $baedaccc4238c96b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $a1uCc = parcelRequire("a1uCc");

var $2COhT = parcelRequire("2COhT");

var $40Zyh = parcelRequire("40Zyh");

var $1rvxq = parcelRequire("1rvxq");
const $baedaccc4238c96b$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $baedaccc4238c96b$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $baedaccc4238c96b$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $baedaccc4238c96b$var$DEFAULT_TTL_MS;
        $baedaccc4238c96b$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $baedaccc4238c96b$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $baedaccc4238c96b$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $baedaccc4238c96b$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$baedaccc4238c96b$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $baedaccc4238c96b$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $baedaccc4238c96b$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $baedaccc4238c96b$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $baedaccc4238c96b$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $a1uCc._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $baedaccc4238c96b$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $baedaccc4238c96b$var$NetworkFallbackResolver;
function $baedaccc4238c96b$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $baedaccc4238c96b$var$_isDomainFailure;
function $baedaccc4238c96b$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $2COhT._DJB2)(sdkKey)}`;
}
function $baedaccc4238c96b$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $baedaccc4238c96b$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $1rvxq.Storage.removeItem(hashKey);
        return;
    }
    $1rvxq.Storage.setItem(hashKey, JSON.stringify(info));
}
function $baedaccc4238c96b$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $baedaccc4238c96b$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $1rvxq.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $40Zyh.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $baedaccc4238c96b$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("a1uCc", function(module, exports) {
"use strict";
var $74c1bee5ec1da208$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $74c1bee5ec1da208$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $74c1bee5ec1da208$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $74c1bee5ec1da208$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $74c1bee5ec1da208$var$MAX_START_LOOKUP = 200;
function $74c1bee5ec1da208$var$_fetchTxtRecords(networkFunc) {
    return $74c1bee5ec1da208$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($74c1bee5ec1da208$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $74c1bee5ec1da208$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $74c1bee5ec1da208$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $74c1bee5ec1da208$var$_fetchTxtRecords;
function $74c1bee5ec1da208$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $74c1bee5ec1da208$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $74c1bee5ec1da208$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("5AhNR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $410e1fe15640bde3$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $410e1fe15640bde3$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $410e1fe15640bde3$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("lxP22", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $eq24U = parcelRequire("eq24U");

var $cGeSD = parcelRequire("cGeSD");

var $40Zyh = parcelRequire("40Zyh");

var $1rvxq = parcelRequire("1rvxq");

var $lT7qF = parcelRequire("lT7qF");
const $faf443e33605bacc$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $faf443e33605bacc$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $faf443e33605bacc$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($faf443e33605bacc$var$PROMISE_MAP[sdkKey] == null) $faf443e33605bacc$var$PROMISE_MAP[sdkKey] = $faf443e33605bacc$var$_loadSession(sdkKey);
        const session = $faf443e33605bacc$var$PROMISE_MAP[sdkKey];
        return $faf443e33605bacc$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $faf443e33605bacc$var$PROMISE_MAP[sdkKey] = $faf443e33605bacc$var$_overrideSessionId(override, sdkKey);
    }
};
function $faf443e33605bacc$var$_loadSession(sdkKey) {
    let data = $faf443e33605bacc$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $lT7qF.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $faf443e33605bacc$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $faf443e33605bacc$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($faf443e33605bacc$var$_isIdle(data) || $faf443e33605bacc$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $lT7qF.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $faf443e33605bacc$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $faf443e33605bacc$var$_createSessionTimeout(sdkKey, $faf443e33605bacc$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $faf443e33605bacc$var$_createSessionTimeout(sdkKey, $faf443e33605bacc$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $faf443e33605bacc$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $eq24U._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $faf443e33605bacc$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $faf443e33605bacc$var$MAX_SESSION_IDLE_TIME;
}
function $faf443e33605bacc$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $faf443e33605bacc$var$MAX_SESSION_AGE;
}
function $faf443e33605bacc$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $cGeSD._getStorageKey)(sdkKey)}`;
}
function $faf443e33605bacc$var$_persistToStorage(session, sdkKey) {
    const storageKey = $faf443e33605bacc$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $1rvxq._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $40Zyh.Log.warn('Failed to save SessionID');
    }
}
function $faf443e33605bacc$var$_loadFromStorage(sdkKey) {
    const storageKey = $faf443e33605bacc$var$_getSessionIDStorageKey(sdkKey);
    return (0, $1rvxq._getObjectFromStorage)(storageKey);
}

});

parcelRegister("9fRgZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("dSDmj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("15QQk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fQZMT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $b8aba412223f6182$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $b8aba412223f6182$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $b8aba412223f6182$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $b8aba412223f6182$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $b8aba412223f6182$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $b8aba412223f6182$var$_fastApproxSizeOf;

});

parcelRegister("azCZT", function(module, exports) {
"use strict";
var $7b2b6c5393c30c8a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $eq24U = parcelRequire("eq24U");

var $eq24U = parcelRequire("eq24U");

var $813Cq = parcelRequire("813Cq");

var $8vIHs = parcelRequire("8vIHs");

var $40Zyh = parcelRequire("40Zyh");

var $cOkw0 = parcelRequire("cOkw0");

var $c50UJ = parcelRequire("c50UJ");

var $lxP22 = parcelRequire("lxP22");

var $gNIDT = parcelRequire("gNIDT");

var $kZnRJ = parcelRequire("kZnRJ");

var $1rvxq = parcelRequire("1rvxq");
const $7b2b6c5393c30c8a$var$MAX_MEMO_CACHE_SIZE = 3000;
class $7b2b6c5393c30c8a$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($40Zyh.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $1rvxq.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $lxP22.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $1rvxq.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $gNIDT.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $gNIDT.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $8vIHs.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $813Cq.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $1rvxq.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $7b2b6c5393c30c8a$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $1rvxq.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $gNIDT.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($kZnRJ.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $7b2b6c5393c30c8a$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $40Zyh.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $cOkw0.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $7b2b6c5393c30c8a$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $7b2b6c5393c30c8a$var$StatsigClientBase;
function $7b2b6c5393c30c8a$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $c50UJ._isServerEnv)()) return;
    const statsigGlobal = (0, $eq24U._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $40Zyh.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("kKGSP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("8wtQg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8r6oH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $40Zyh = parcelRequire("40Zyh");

var $9pDV4 = parcelRequire("9pDV4");
function $6245ceb83b69a841$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $6245ceb83b69a841$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $6245ceb83b69a841$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $6245ceb83b69a841$var$_makeFeatureGate;
function $6245ceb83b69a841$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $6245ceb83b69a841$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $6245ceb83b69a841$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $6245ceb83b69a841$var$_makeDynamicConfig;
function $6245ceb83b69a841$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $6245ceb83b69a841$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $6245ceb83b69a841$var$_makeExperiment;
function $6245ceb83b69a841$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $6245ceb83b69a841$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $6245ceb83b69a841$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $6245ceb83b69a841$var$_makeLayer;
function $6245ceb83b69a841$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $6245ceb83b69a841$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $6245ceb83b69a841$var$_mergeOverride;
function $6245ceb83b69a841$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $9pDV4._isTypeMatch)(found, fallback)) {
            $40Zyh.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $6245ceb83b69a841$var$_makeTypedGet;

});

parcelRegister("9VZ0X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3bn8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $251459463837643f$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $251459463837643f$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("dm0Dd", function(module, exports) {
"use strict";
var $9b8dd1d7f78f18f0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $alCOo = parcelRequire("alCOo");

var $asYcD = parcelRequire("asYcD");

var $dYAsx = parcelRequire("dYAsx");

var $gcNbH = parcelRequire("gcNbH");

var $cwYxD = parcelRequire("cwYxD");
class $9b8dd1d7f78f18f0$var$StatsigClient extends $alCOo.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $alCOo._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $9b8dd1d7f78f18f0$var$StatsigClient) return instance;
        $alCOo.Log.warn((0, $alCOo._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $9b8dd1d7f78f18f0$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $alCOo.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $dYAsx.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $cwYxD.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($alCOo.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($alCOo.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($alCOo.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($alCOo.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($alCOo.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($alCOo.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $asYcD.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $alCOo.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $alCOo.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $9b8dd1d7f78f18f0$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $alCOo.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $alCOo.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $9b8dd1d7f78f18f0$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $9b8dd1d7f78f18f0$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $alCOo.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $alCOo.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $alCOo.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $alCOo.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($alCOo.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $alCOo.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $alCOo.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $alCOo.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $alCOo.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $alCOo.StatsigSession.get(this._sdkKey),
            stableID: $alCOo.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $9b8dd1d7f78f18f0$var$__awaiter(this, void 0, void 0, function*() {
            if (!$alCOo.Storage.isReady()) yield $alCOo.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $alCOo.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $alCOo.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $alCOo._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$alCOo.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$alCOo.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $alCOo.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $alCOo._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $alCOo._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $alCOo._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $alCOo._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $alCOo._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $alCOo._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $alCOo._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $alCOo._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $alCOo._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $alCOo._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $gcNbH._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $gcNbH._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $9b8dd1d7f78f18f0$var$StatsigClient;

});
parcelRegister("asYcD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $alCOo = parcelRequire("alCOo");

var $0gnaQ = parcelRequire("0gnaQ");

var $32U49 = parcelRequire("32U49");
class $79eb37f0b6a62a8e$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $alCOo._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $alCOo._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $32U49.V2InitializeContainer(values);
        else this._values = new $0gnaQ.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $alCOo.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $alCOo.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $alCOo._getFullUserHash)(userForComparison) !== (0, $alCOo._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $79eb37f0b6a62a8e$var$EvaluationStore;

});
parcelRegister("0gnaQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $alCOo = parcelRequire("alCOo");
class $000cb37e3c874939$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $alCOo._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $000cb37e3c874939$var$V1InitializeContainer;

});

parcelRegister("32U49", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $alCOo = parcelRequire("alCOo");
class $237d0c8878f197ca$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $alCOo._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $237d0c8878f197ca$var$V2InitializeContainer;

});


parcelRegister("dYAsx", function(module, exports) {
"use strict";
var $a2cd2901dba668b4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $alCOo = parcelRequire("alCOo");

var $M5lY5 = parcelRequire("M5lY5");
class $a2cd2901dba668b4$var$StatsigNetwork extends $alCOo.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $alCOo.UrlConfiguration($alCOo.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $a2cd2901dba668b4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $alCOo._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $a2cd2901dba668b4$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $M5lY5._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $a2cd2901dba668b4$var$StatsigNetwork;

});
parcelRegister("M5lY5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $alCOo = parcelRequire("alCOo");
const $0908a2de60d6cf70$var$MAX_DELTAS_SORT_DEPTH = 2;
function $0908a2de60d6cf70$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $alCOo._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $0908a2de60d6cf70$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $0908a2de60d6cf70$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $alCOo._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $0908a2de60d6cf70$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $0908a2de60d6cf70$var$_resolveDeltasResponse;
function $0908a2de60d6cf70$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $0908a2de60d6cf70$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $0908a2de60d6cf70$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $0908a2de60d6cf70$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $0908a2de60d6cf70$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $0908a2de60d6cf70$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("gcNbH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $alCOo = parcelRequire("alCOo");
const $bcc3ec013c07ca8e$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $bcc3ec013c07ca8e$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $bcc3ec013c07ca8e$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $alCOo._isTypeMatch)(value, fallback);
}
function $bcc3ec013c07ca8e$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $bcc3ec013c07ca8e$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $bcc3ec013c07ca8e$var$_shouldLogExposure(options) ? undefined : $bcc3ec013c07ca8e$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $bcc3ec013c07ca8e$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $bcc3ec013c07ca8e$var$_shouldLogExposure(options) ? undefined : $bcc3ec013c07ca8e$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($bcc3ec013c07ca8e$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $bcc3ec013c07ca8e$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $bcc3ec013c07ca8e$var$_shouldLogExposure(options) ? undefined : $bcc3ec013c07ca8e$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($bcc3ec013c07ca8e$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $bcc3ec013c07ca8e$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $bcc3ec013c07ca8e$var$_shouldLogExposure(options) ? undefined : $bcc3ec013c07ca8e$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($bcc3ec013c07ca8e$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $bcc3ec013c07ca8e$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $alCOo._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $bcc3ec013c07ca8e$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $bcc3ec013c07ca8e$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $bcc3ec013c07ca8e$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $bcc3ec013c07ca8e$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $bcc3ec013c07ca8e$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $bcc3ec013c07ca8e$var$_makeParamStoreGetter;

});

parcelRegister("cwYxD", function(module, exports) {
"use strict";
var $91f76f790f929acf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $alCOo = parcelRequire("alCOo");

var $dYAsx = parcelRequire("dYAsx");
class $91f76f790f929acf$var$StatsigEvaluationsDataAdapter extends $alCOo.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $dYAsx.default) this._network = network;
        else this._network = new $dYAsx.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $alCOo._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $alCOo._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $alCOo.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $91f76f790f929acf$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $alCOo._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$alCOo.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $alCOo._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $91f76f790f929acf$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("ih3by", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2e52271e89a4dcd$export$2e2bcd8739ae039);

var $laisU = parcelRequire("laisU");
const $a2e52271e89a4dcd$export$a66cbd9b2289cd78 = '@all-features';
class $a2e52271e89a4dcd$export$2e2bcd8739ae039 {
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($laisU)))();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($a2e52271e89a4dcd$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($a2e52271e89a4dcd$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($a2e52271e89a4dcd$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $a2e52271e89a4dcd$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});

parcelRegister("fSvdU", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $c6864eefb98c4e55$export$6dc24881a3d96325);

var $4ALgQ = parcelRequire("4ALgQ");
class $c6864eefb98c4e55$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $c6864eefb98c4e55$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $4ALgQ.migrateEvaluationDetails)(experiment.details), (0, $4ALgQ.migrateSecondaryExposures)(experiment.__evaluation?.secondary_exposures ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("4ALgQ", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $600adb8e03d083b0$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $600adb8e03d083b0$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $600adb8e03d083b0$export$3dad1db244472f32);
$parcel$export(module.exports, "deepAssign", () => $600adb8e03d083b0$export$1148cb79ceecd5fa);
$parcel$export(module.exports, "migrateInitializationOptions", () => $600adb8e03d083b0$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $600adb8e03d083b0$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $600adb8e03d083b0$export$55fd683752d01e67);

var $9APme = parcelRequire("9APme");

var $eVuiw = parcelRequire("eVuiw");

var $42xfx = parcelRequire("42xfx");
const $600adb8e03d083b0$export$d119b37e5f788b43 = (options)=>({
        /**
   * If more federal PerimeterTypes are added in the future, this should be updated so
   * that isFedRamp() === true always returns the strictest perimeter.
   */ perimeter: (0, $9APme.isFedRamp)() ? (0, $42xfx.PerimeterType).FEDRAMP_MODERATE : (0, $42xfx.PerimeterType).COMMERCIAL,
        ...options
    });
const $600adb8e03d083b0$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const $600adb8e03d083b0$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    const user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $600adb8e03d083b0$export$1148cb79ceecd5fa(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (source === undefined || source === null) return $600adb8e03d083b0$export$1148cb79ceecd5fa(target, ...sources);
    for (const [key, src] of Object.entries(source)){
        const dst = target[key];
        const srcIsObj = src && typeof src === 'object' && !Array.isArray(src);
        const dstIsObj = dst && typeof dst === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $600adb8e03d083b0$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $600adb8e03d083b0$export$1148cb79ceecd5fa(target, ...sources);
}
const $600adb8e03d083b0$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};
const $600adb8e03d083b0$var$evaluationReasonMappings = Object.entries((0, $eVuiw.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $600adb8e03d083b0$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $600adb8e03d083b0$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $eVuiw.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};
const $600adb8e03d083b0$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("eVuiw", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $e4811a061b22532e$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
const $e4811a061b22532e$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
};

});

parcelRegister("42xfx", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $5fa8bf1d0ffe68a4$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $5fa8bf1d0ffe68a4$export$c42b7bbc5e7ba555);
const $5fa8bf1d0ffe68a4$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
const $5fa8bf1d0ffe68a4$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
const $5fa8bf1d0ffe68a4$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("7wf33", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $acbc6db341891630$export$936d0764594b6eb3);

var $4ALgQ = parcelRequire("4ALgQ");
class $acbc6db341891630$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $acbc6db341891630$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $4ALgQ.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $4ALgQ.migrateSecondaryExposures)(layer.__evaluation?.secondary_exposures ?? []), (0, $4ALgQ.migrateSecondaryExposures)(layer.__evaluation?.undelegated_secondary_exposures ?? []), layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
}

});

parcelRegister("2znIb", function(module, exports) {
$parcel$export(module.exports, "default", () => $57d9b51d96022f36$export$2e2bcd8739ae039);

var $42xfx = parcelRequire("42xfx");

var $BbIhg = parcelRequire("BbIhg");

var $4vBht = parcelRequire("4vBht");
const $57d9b51d96022f36$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $57d9b51d96022f36$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $57d9b51d96022f36$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $57d9b51d96022f36$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $57d9b51d96022f36$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $57d9b51d96022f36$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $57d9b51d96022f36$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $57d9b51d96022f36$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $57d9b51d96022f36$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $57d9b51d96022f36$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $57d9b51d96022f36$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $4vBht.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $4vBht.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $57d9b51d96022f36$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $42xfx.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $42xfx.FeatureGateEnvironment).Production:
                return $57d9b51d96022f36$export$18c93900db9358a4;
            case (0, $42xfx.FeatureGateEnvironment).Staging:
                return $57d9b51d96022f36$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $42xfx.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $42xfx.FeatureGateEnvironment).Development:
                return $57d9b51d96022f36$export$f058dbf75c3bc647;
            case (0, $42xfx.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $57d9b51d96022f36$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $57d9b51d96022f36$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $57d9b51d96022f36$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $57d9b51d96022f36$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $BbIhg.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $57d9b51d96022f36$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$57d9b51d96022f36$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$57d9b51d96022f36$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

});
parcelRegister("BbIhg", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $2e3be0d6d1ceddad$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $2e3be0d6d1ceddad$export$a59f8d67326bd1cb = undefined;

});

parcelRegister("4vBht", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $5ae53e29fc8e22ad$export$286baf652d0b1206);
class $5ae53e29fc8e22ad$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("6jMQ7", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $566b1eeed2c63896$export$55fffef3474104af);

var $j2RLX = parcelRequire("j2RLX");
class $566b1eeed2c63896$export$55fffef3474104af extends (0, $j2RLX.DataAdapterCore) {
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $j2RLX.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $j2RLX._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $j2RLX._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $j2RLX._getStorageKey)(this._getSdkKey(), user);
        return `${0, $j2RLX.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("hDEZe", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $5362e1796fa40d47$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $5362e1796fa40d47$export$bcb28fbac1def494);

var $alCOo = parcelRequire("alCOo");
const $5362e1796fa40d47$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $5362e1796fa40d47$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $5362e1796fa40d47$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $5362e1796fa40d47$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $5362e1796fa40d47$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $5362e1796fa40d47$export$bcb28fbac1def494 {
    constructor(localStorageKey){
        this._overrides = $5362e1796fa40d47$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $5362e1796fa40d47$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $5362e1796fa40d47$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $5362e1796fa40d47$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($5362e1796fa40d47$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            window.localStorage.removeItem($5362e1796fa40d47$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $alCOo._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$5362e1796fa40d47$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($5362e1796fa40d47$var$djb2MapKey((0, $alCOo._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($5362e1796fa40d47$var$djb2MapKey((0, $alCOo._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($5362e1796fa40d47$var$djb2MapKey((0, $alCOo._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($5362e1796fa40d47$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $5362e1796fa40d47$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($5362e1796fa40d47$var$djb2MapKey((0, $alCOo._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($5362e1796fa40d47$var$djb2MapKey((0, $alCOo._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($5362e1796fa40d47$var$djb2MapKey((0, $alCOo._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($5362e1796fa40d47$var$djb2MapKey((0, $alCOo._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($5362e1796fa40d47$var$djb2MapKey((0, $alCOo._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($5362e1796fa40d47$var$djb2MapKey((0, $alCOo._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $5362e1796fa40d47$var$makeEmptyStore();
        try {
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($5362e1796fa40d47$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $alCOo._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $5362e1796fa40d47$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($5362e1796fa40d47$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $alCOo._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $5362e1796fa40d47$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});



parcelRegister("cDSkE", function(module, exports) {
$parcel$export(module.exports, "default", () => $0be9fcda2634a139$export$2e2bcd8739ae039);

var $4tluv = parcelRequire("4tluv");
const $0be9fcda2634a139$var$interactionContext = (0, $4tluv.createContext)(null);
var $0be9fcda2634a139$export$2e2bcd8739ae039 = $0be9fcda2634a139$var$interactionContext;

});

parcelRegister("k3zcO", function(module, exports) {
$parcel$export(module.exports, "PersistQueryClientProvider", () => $e99f658fa2743d47$export$9d736f54481e482f);

var $j3wcq = parcelRequire("j3wcq");

var $4tluv = parcelRequire("4tluv");

var $8oECW = parcelRequire("8oECW");

var $gEvBY = parcelRequire("gEvBY");
var $4cZqh = parcelRequire("4cZqh");
'use client';
const $e99f658fa2743d47$export$9d736f54481e482f = ({ client: client, children: children, persistOptions: persistOptions, onSuccess: onSuccess, ...props })=>{
    const [isRestoring, setIsRestoring] = $4tluv.useState(true);
    const refs = $4tluv.useRef({
        persistOptions: persistOptions,
        onSuccess: onSuccess
    });
    const didRestore = $4tluv.useRef(false);
    $4tluv.useEffect(()=>{
        refs.current = {
            persistOptions: persistOptions,
            onSuccess: onSuccess
        };
    });
    $4tluv.useEffect(()=>{
        const options = {
            ...refs.current.persistOptions,
            queryClient: client
        };
        if (!didRestore.current) {
            didRestore.current = true;
            setIsRestoring(true);
            (0, $8oECW.persistQueryClientRestore)(options).then(async ()=>{
                try {
                    await (refs.current.onSuccess == null ? void 0 : refs.current.onSuccess());
                } finally{
                    setIsRestoring(false);
                }
            });
        }
        return isRestoring ? undefined : (0, $8oECW.persistQueryClientSubscribe)(options);
    }, [
        client,
        isRestoring
    ]);
    return /*#__PURE__*/ $4tluv.createElement((0, $4cZqh.QueryClientProvider), (0, $j3wcq.extends)({
        client: client
    }, props), /*#__PURE__*/ $4tluv.createElement((0, $gEvBY.IsRestoringProvider), {
        value: isRestoring
    }, children));
};

});
parcelRegister("j3wcq", function(module, exports) {
$parcel$export(module.exports, "extends", () => $ddf74646b49ab670$export$e092ad3ec43b55ee);
function $ddf74646b49ab670$export$e092ad3ec43b55ee() {
    $ddf74646b49ab670$export$e092ad3ec43b55ee = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ddf74646b49ab670$export$e092ad3ec43b55ee.apply(this, arguments);
}

});

parcelRegister("8oECW", function(module, exports) {
$parcel$export(module.exports, "persistQueryClientRestore", () => $61d014508850b4b5$export$781eb0ebad7272a1);
$parcel$export(module.exports, "persistQueryClientSubscribe", () => $61d014508850b4b5$export$9fe01d80627be88c);

var $2fFPo = parcelRequire("2fFPo");
/**
 * Checks if emitted event is about cache change and not about observers.
 * Useful for persist, where we only want to trigger save when cache is changed.
 */ const $61d014508850b4b5$var$cacheableEventTypes = [
    'added',
    'removed',
    'updated'
];
function $61d014508850b4b5$var$isCacheableEventType(eventType) {
    return $61d014508850b4b5$var$cacheableEventTypes.includes(eventType);
}
/**
 * Restores persisted data to the QueryCache
 *  - data obtained from persister.restoreClient
 *  - data is hydrated using hydrateOptions
 * If data is expired, busted, empty, or throws, it runs persister.removeClient
 */ async function $61d014508850b4b5$export$781eb0ebad7272a1({ queryClient: queryClient, persister: persister, maxAge: maxAge = 86400000, buster: buster = '', hydrateOptions: hydrateOptions }) {
    try {
        const persistedClient = await persister.restoreClient();
        if (persistedClient) {
            if (persistedClient.timestamp) {
                const expired = Date.now() - persistedClient.timestamp > maxAge;
                const busted = persistedClient.buster !== buster;
                if (expired || busted) persister.removeClient();
                else (0, $2fFPo.hydrate)(queryClient, persistedClient.clientState, hydrateOptions);
            } else persister.removeClient();
        }
    } catch (err) {
        persister.removeClient();
    }
}
/**
 * Persists data from the QueryCache
 *  - data dehydrated using dehydrateOptions
 *  - data is persisted using persister.persistClient
 */ async function $61d014508850b4b5$export$8a3b4786a14f2528({ queryClient: queryClient, persister: persister, buster: buster = '', dehydrateOptions: dehydrateOptions }) {
    const persistClient = {
        buster: buster,
        timestamp: Date.now(),
        clientState: (0, $2fFPo.dehydrate)(queryClient, dehydrateOptions)
    };
    await persister.persistClient(persistClient);
}
/**
 * Subscribe to QueryCache and MutationCache updates (for persisting)
 * @returns an unsubscribe function (to discontinue monitoring)
 */ function $61d014508850b4b5$export$9fe01d80627be88c(props) {
    const unsubscribeQueryCache = props.queryClient.getQueryCache().subscribe((event)=>{
        if ($61d014508850b4b5$var$isCacheableEventType(event.type)) $61d014508850b4b5$export$8a3b4786a14f2528(props);
    });
    const unusbscribeMutationCache = props.queryClient.getMutationCache().subscribe((event)=>{
        if ($61d014508850b4b5$var$isCacheableEventType(event.type)) $61d014508850b4b5$export$8a3b4786a14f2528(props);
    });
    return ()=>{
        unsubscribeQueryCache();
        unusbscribeMutationCache();
    };
}
/**
 * Restores persisted data to QueryCache and persists further changes.
 */ function $61d014508850b4b5$export$217ab42a80f50b3b(props) {
    let hasUnsubscribed = false;
    let persistQueryClientUnsubscribe;
    const unsubscribe = ()=>{
        hasUnsubscribed = true;
        persistQueryClientUnsubscribe == null || persistQueryClientUnsubscribe();
    }; // Attempt restore
    const restorePromise = $61d014508850b4b5$export$781eb0ebad7272a1(props).then(()=>{
        if (!hasUnsubscribed) // Subscribe to changes in the query cache to trigger the save
        persistQueryClientUnsubscribe = $61d014508850b4b5$export$9fe01d80627be88c(props);
    });
    return [
        unsubscribe,
        restorePromise
    ];
}

});
parcelRegister("2fFPo", function(module, exports) {
$parcel$export(module.exports, "dehydrate", () => $1a3d6d9e5d93c256$export$12aee8bb597e7dfe);
$parcel$export(module.exports, "hydrate", () => $1a3d6d9e5d93c256$export$fa8d919ba61d84db);
// TYPES
// FUNCTIONS
function $1a3d6d9e5d93c256$var$dehydrateMutation(mutation) {
    return {
        mutationKey: mutation.options.mutationKey,
        state: mutation.state
    };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.
function $1a3d6d9e5d93c256$var$dehydrateQuery(query) {
    return {
        state: query.state,
        queryKey: query.queryKey,
        queryHash: query.queryHash
    };
}
function $1a3d6d9e5d93c256$export$3aa4c2840e01e53(mutation) {
    return mutation.state.isPaused;
}
function $1a3d6d9e5d93c256$export$e71bc20295698fa1(query) {
    return query.state.status === 'success';
}
function $1a3d6d9e5d93c256$export$12aee8bb597e7dfe(client, options = {}) {
    const mutations = [];
    const queries = [];
    if (options.dehydrateMutations !== false) {
        const shouldDehydrateMutation = options.shouldDehydrateMutation || $1a3d6d9e5d93c256$export$3aa4c2840e01e53;
        client.getMutationCache().getAll().forEach((mutation)=>{
            if (shouldDehydrateMutation(mutation)) mutations.push($1a3d6d9e5d93c256$var$dehydrateMutation(mutation));
        });
    }
    if (options.dehydrateQueries !== false) {
        const shouldDehydrateQuery = options.shouldDehydrateQuery || $1a3d6d9e5d93c256$export$e71bc20295698fa1;
        client.getQueryCache().getAll().forEach((query)=>{
            if (shouldDehydrateQuery(query)) queries.push($1a3d6d9e5d93c256$var$dehydrateQuery(query));
        });
    }
    return {
        mutations: mutations,
        queries: queries
    };
}
function $1a3d6d9e5d93c256$export$fa8d919ba61d84db(client, dehydratedState, options) {
    if (typeof dehydratedState !== 'object' || dehydratedState === null) return;
    const mutationCache = client.getMutationCache();
    const queryCache = client.getQueryCache(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const mutations = dehydratedState.mutations || []; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const queries = dehydratedState.queries || [];
    mutations.forEach((dehydratedMutation)=>{
        var _options$defaultOptio;
        mutationCache.build(client, {
            ...options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations,
            mutationKey: dehydratedMutation.mutationKey
        }, dehydratedMutation.state);
    });
    queries.forEach(({ queryKey: queryKey, state: state, queryHash: queryHash })=>{
        var _options$defaultOptio2;
        const query = queryCache.get(queryHash); // Do not hydrate if an existing query exists with newer data
        if (query) {
            if (query.state.dataUpdatedAt < state.dataUpdatedAt) {
                // omit fetchStatus from dehydrated state
                // so that query stays in its current fetchStatus
                const { fetchStatus: _ignored, ...dehydratedQueryState } = state;
                query.setState(dehydratedQueryState);
            }
            return;
        } // Restore query
        queryCache.build(client, {
            ...options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries,
            queryKey: queryKey,
            queryHash: queryHash
        }, // query being stuck in fetching state upon hydration
        {
            ...state,
            fetchStatus: 'idle'
        });
    });
}

});


parcelRegister("gEvBY", function(module, exports) {
$parcel$export(module.exports, "useIsRestoring", () => $c1f8e7204c376eb4$export$4da0178d6b5f553);
$parcel$export(module.exports, "IsRestoringProvider", () => $c1f8e7204c376eb4$export$593807d4e94f9621);

var $4tluv = parcelRequire("4tluv");
"use client";
var $c1f8e7204c376eb4$var$IsRestoringContext = $4tluv.createContext(false);
var $c1f8e7204c376eb4$export$4da0178d6b5f553 = ()=>$4tluv.useContext($c1f8e7204c376eb4$var$IsRestoringContext);
var $c1f8e7204c376eb4$export$593807d4e94f9621 = $c1f8e7204c376eb4$var$IsRestoringContext.Provider;

});

parcelRegister("4cZqh", function(module, exports) {
$parcel$export(module.exports, "useQueryClient", () => $3107edb2585bc477$export$22e77b9572c4fded);
$parcel$export(module.exports, "QueryClientProvider", () => $3107edb2585bc477$export$45604f0cc8ae667b);

var $4tluv = parcelRequire("4tluv");

var $2iln5 = parcelRequire("2iln5");
"use client";
var $3107edb2585bc477$export$da112d31b0149f31 = $4tluv.createContext(void 0);
var $3107edb2585bc477$export$22e77b9572c4fded = (queryClient)=>{
    const client = $4tluv.useContext($3107edb2585bc477$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $3107edb2585bc477$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $4tluv.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $2iln5.jsx)($3107edb2585bc477$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};

});


parcelRegister("cn7A7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $b6kAF = parcelRequire("b6kAF");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $b6kAF.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $b6kAF.isFeatureEnabled;
    }
});

});
parcelRegister("b6kAF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $kDPHl = parcelRequire("kDPHl");

var $lRikj = parcelRequire("lRikj");

var $aMgk9 = parcelRequire("aMgk9");
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $81503a0ec5d0b8af$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $81503a0ec5d0b8af$var$getBoundaryKey();
    return (0, $lRikj.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $81503a0ec5d0b8af$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param offeringPredicates Optional map of boundary keys to predicate functions. When a predicate
 *   is provided for the current boundary, the feature is only considered enabled if both
 *   the AEM state and the predicate return true.
 * @returns if the feature is available in the current cloud environment
 */ function $81503a0ec5d0b8af$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $aMgk9.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $81503a0ec5d0b8af$var$getBoundaryKey();
    const aemResult = (0, $lRikj.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    if (!aemResult) return false;
    const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
    return predicate ? predicate() : true;
}
module.exports.isFeatureEnabled = $81503a0ec5d0b8af$var$isFeatureEnabled;
function $81503a0ec5d0b8af$var$getBoundaryKey() {
    if ((0, $kDPHl.isFedrampModerate)()) return $lRikj.FED_MOD_KEY;
    if ((0, $kDPHl.isIsolatedCloud)()) return $lRikj.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $lRikj.COMMERCIAL_KEY;
}
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $81503a0ec5d0b8af$var$isFeatureEnabled,
    overrideFeature: $aMgk9.overrideFeature,
    clearFeatureOverride: $aMgk9.clearFeatureOverride,
    clearAllOverrides: $aMgk9.clearAllOverrides
};

});
parcelRegister("lRikj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $iu5x3 = parcelRequire("iu5x3");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $iu5x3.isEnvironmentBlockEnabledForBoundary;
    }
});

var $iu5x3 = parcelRequire("iu5x3");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $iu5x3.isFeatureEnabledForBoundary;
    }
});

var $iu5x3 = parcelRequire("iu5x3");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $iu5x3.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $dUoVy = parcelRequire("dUoVy");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $dUoVy.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $dUoVy.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $dUoVy.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $dUoVy.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $dUoVy.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});
parcelRegister("iu5x3", function(module, exports) {
"use strict";
var $d74f51e80d931914$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $d74f51e80d931914$var$sdk_data_json_1 = $d74f51e80d931914$var$__importDefault((parcelRequire("lJHTi")));
const $d74f51e80d931914$var$aemEnvironmentBlockData = $d74f51e80d931914$var$sdk_data_json_1.default;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $d74f51e80d931914$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $d74f51e80d931914$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $d74f51e80d931914$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $d74f51e80d931914$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($d74f51e80d931914$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $d74f51e80d931914$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[boundaryKey] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $d74f51e80d931914$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $d74f51e80d931914$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $d74f51e80d931914$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[boundaryKey];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $d74f51e80d931914$var$getFeatureAvailabilityMetadataForBoundary;
function $d74f51e80d931914$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $d74f51e80d931914$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[boundaryKey] === true;
}

});
parcelRegister("lJHTi", function(module, exports) {
module.exports = JSON.parse("{\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-add-product\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-api-token-controls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-app-requests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-app-updates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-audit-log\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-backup-and-restore\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-billing-console\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-byok\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-contacts\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-management\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-residency\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-help\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-llm\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-org-create\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-product-insights\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-product-links\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-saml-sso\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-sandbox\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-site-rename\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-site-transfer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-system-health\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-use-available-apps\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-user-counts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"assets\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"assets-data-manager\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"assets-recent-items\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"assets-reports\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"atlassian-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"bitbucket\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"bitbucket-slack-app\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"pipelines\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"chat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"compass\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ccma\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-anonymous-access\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-company-hub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-content-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-content-manager\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-databases\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-editing-experience\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-editor-offline-storage\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-employee-directory\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-invitations\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-loom-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-mission-control\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-mobile-app\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-ms-teams-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-page-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-presenter-mode\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-public-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-questions-native-experience\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-questions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-search\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-server\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-slack-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-slides\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-smart-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-space-analytics\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-team-calendars\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"confluence-whiteboards\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"customer-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"dx\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"focus\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"goals\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"guard-standard\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"home\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"home-status-backend\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"jira\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"jcma-x2c\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jcma\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-apps-menu\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-audit-log\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-backlogs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-boards-and-views\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-calendar-view\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-components\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-development-tab\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-forms\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-github-for-jira\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-github-workflows\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-in-product-help\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-insights\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-issue\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-loom-banner\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-mobile-app\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-oasis-reports\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-opsgenie\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-plans\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-project-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-project-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-quickstart-pages\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jira-releases\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-share\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-site-optimiser\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-slack\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-smart-links\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-team-managed-projects\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-workflow-configuration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"jira-align\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"jira-service-management-help-center\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-ai-ops\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-ai-services\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-approvals\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-automation-playbook\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-boysenberry\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-canned-responses\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-change-calendar\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-change-risk-assessment\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-chat-ops\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-chat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-cloud-megatron\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-csat\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-email-requests\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-entity-migration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-forms\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-help-center-change-password\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center-password-login\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-help-center\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-incident-conference-calls\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-issue\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-journey-builder\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-multi-language-support\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-queues\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-related-issues\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-reports-operations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-request-intake\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-services\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-shield\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-sla-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-surveys\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"opsgenie\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"loom\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"projects\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{\"rovo-ai-app-availability\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-projects\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"rovo-dev\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"statuspage\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"studio\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"talent\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"teams\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"teams-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"teams-third-party-invites\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"trello\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"anti-abuse-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"application-tunnels\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"atlassian-cli\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"central-ai\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ai-3p-connections\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"ai-safety\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"collaboration-graph\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"gen-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"knowledge-ai\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"knowledge-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"machine-learning-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"user-recommendations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"collaboration-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"commerce-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"commerce-platform-self-serve\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"customer-data-lake\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"ecosystem-forge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ecosystem-oauth\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"forge-cli\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-remote-capabilities\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-system-apps\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":false,\"fedramp-moderate\":false}}}},\"editor-collaboration-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"block-service\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"real-time-presence\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"experience-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"growth-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"bxp-signup\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"identity\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"identity-mail-proxy\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"identity-virality\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"marketplace\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"marketplace-app-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"data-center-to-agc\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"migration-link-fixing\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"migrations-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"brie\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"media-migration\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"navigation\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"navigation-home-entry-mode\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":false,\"fedramp-moderate\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"notification-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"notifications-fpn-link\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"post-office\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"product-integrations-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"search\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"search-townsquare-tab\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"smartlinks\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"user-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"atlassian-graphql-gateway\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"atlassian-platform-deployer\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"automation-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"automation-platform-actions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-branches\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"automation-platform-conditions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"automation-platform-event-processing\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-frontend\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-templates\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"automation-platform-triggers\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"aws-cloud-management\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"bifrost\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"cell-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"cloud-security\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"compliance-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"consent-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"consenthub\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}}}},\"core-network-automation\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"core-network-automation-cna-theia\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"cross-gateway\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-classification-governance-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-exchange-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"aqui\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false}},\"eureka\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"kamino\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"shipyard\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"topic-osb\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"data-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"ers-import\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"ers\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}},\"sql\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"data-platform-services\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-telemetry-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"decisions-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"detection-and-response-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"edge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"edge-cloudfront\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"encryption-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"cryptor\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"environment-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"flight-deck-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"golden-ami\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"infrastructure\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"internal-data-lake\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"internal-edge\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"internal-edge-httpbin\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"job-execution-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"kitt-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"media-cdn-delivery\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"messaging-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"observability-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"pollinator\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"provisioning\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"secrets\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"security-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"service-to-service-fabric\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"sliver\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":false},\"features\":{}},\"staff-authentication-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"streamhub\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"targeting-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{\"flock\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true}}}},\"tenant-platform\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"tenant-platform-tenant-data-destroyer\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"vdi\":{\"compositions\":{\"isolated-cloud-commercial\":false,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}},\"workplace-technology-solutions\":{\"compositions\":{\"isolated-cloud-commercial\":true,\"commercial-cloud\":true,\"fedramp-moderate\":true},\"features\":{}}}}");

});


parcelRegister("dUoVy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];
var $a203d761f8a69da3$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($a203d761f8a69da3$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $a203d761f8a69da3$var$UnderAuditPhase = {}));

});


parcelRegister("aMgk9", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $7d8b0cb55e3e00e5$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $7d8b0cb55e3e00e5$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $7d8b0cb55e3e00e5$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $7d8b0cb55e3e00e5$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $7d8b0cb55e3e00e5$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$7d8b0cb55e3e00e5$var$isBrowserEnvironment()) return null;
    const map = $7d8b0cb55e3e00e5$var$getOverridesMap();
    const key = $7d8b0cb55e3e00e5$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $7d8b0cb55e3e00e5$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $7d8b0cb55e3e00e5$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$7d8b0cb55e3e00e5$var$isBrowserEnvironment()) return;
    const map = $7d8b0cb55e3e00e5$var$getOverridesMap();
    map[$7d8b0cb55e3e00e5$var$buildKey(environmentBlockName, featureName)] = value;
    $7d8b0cb55e3e00e5$var$setOverridesMap(map);
}
module.exports.overrideFeature = $7d8b0cb55e3e00e5$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $7d8b0cb55e3e00e5$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$7d8b0cb55e3e00e5$var$isBrowserEnvironment()) return;
    const map = $7d8b0cb55e3e00e5$var$getOverridesMap();
    delete map[$7d8b0cb55e3e00e5$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $7d8b0cb55e3e00e5$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $7d8b0cb55e3e00e5$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $7d8b0cb55e3e00e5$var$clearAllOverrides() {
    if (!$7d8b0cb55e3e00e5$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $7d8b0cb55e3e00e5$var$clearAllOverrides;

});



parcelRegister("dD8yb", function(module, exports) {
$parcel$export(module.exports, "useQuery", () => $9ec58ccc26e3eb88$export$dd0a697e1782aedd);

var $djflQ = parcelRequire("djflQ");

var $ctX0Q = parcelRequire("ctX0Q");
"use client";
function $9ec58ccc26e3eb88$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $ctX0Q.useBaseQuery)(options, (0, $djflQ.QueryObserver), queryClient);
}

});
parcelRegister("djflQ", function(module, exports) {
$parcel$export(module.exports, "QueryObserver", () => $9b08f53094393f1c$export$a06cf8c0066f0d4c);
// src/queryObserver.ts

var $8qv0d = parcelRequire("8qv0d");

var $cnq4V = parcelRequire("cnq4V");

var $2Uo4O = parcelRequire("2Uo4O");

var $6MLVK = parcelRequire("6MLVK");

var $fcsMR = parcelRequire("fcsMR");

var $1j5lT = parcelRequire("1j5lT");
var $9b08f53094393f1c$export$a06cf8c0066f0d4c = class extends (0, $6MLVK.Subscribable) {
    constructor(client, options){
        super();
        this.options = options;
        this.#client = client;
        this.#selectError = null;
        this.#currentThenable = (0, $fcsMR.pendingThenable)();
        if (!this.options.experimental_prefetchInRender) this.#currentThenable.reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
        this.bindMethods();
        this.setOptions(options);
    }
    #client;
    #currentQuery = void 0;
    #currentQueryInitialState = void 0;
    #currentResult = void 0;
    #currentResultState;
    #currentResultOptions;
    #currentThenable;
    #selectError;
    #selectFn;
    #selectResult;
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    #lastQueryWithDefinedData;
    #staleTimeoutId;
    #refetchIntervalId;
    #currentRefetchInterval;
    #trackedProps = /* @__PURE__ */ new Set();
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.#currentQuery.addObserver(this);
            if ($9b08f53094393f1c$var$shouldFetchOnMount(this.#currentQuery, this.options)) this.#executeFetch();
            else this.updateResult();
            this.#updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $9b08f53094393f1c$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $9b08f53094393f1c$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#clearStaleTimeout();
        this.#clearRefetchInterval();
        this.#currentQuery.removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = this.#currentQuery;
        this.options = this.#client.defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $1j5lT.resolveEnabled)(this.options.enabled, this.#currentQuery) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        this.#updateQuery();
        this.#currentQuery.setOptions(this.options);
        if (prevOptions._defaulted && !(0, $1j5lT.shallowEqualObjects)(this.options, prevOptions)) this.#client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.#currentQuery,
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $9b08f53094393f1c$var$shouldFetchOptionally(this.#currentQuery, prevQuery, this.options, prevOptions)) this.#executeFetch();
        this.updateResult();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $1j5lT.resolveEnabled)(this.options.enabled, this.#currentQuery) !== (0, $1j5lT.resolveEnabled)(prevOptions.enabled, this.#currentQuery) || (0, $1j5lT.resolveStaleTime)(this.options.staleTime, this.#currentQuery) !== (0, $1j5lT.resolveStaleTime)(prevOptions.staleTime, this.#currentQuery))) this.#updateStaleTimeout();
        const nextRefetchInterval = this.#computeRefetchInterval();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $1j5lT.resolveEnabled)(this.options.enabled, this.#currentQuery) !== (0, $1j5lT.resolveEnabled)(prevOptions.enabled, this.#currentQuery) || nextRefetchInterval !== this.#currentRefetchInterval)) this.#updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.#client.getQueryCache().build(this.#client, options);
        const result = this.createResult(query, options);
        if ($9b08f53094393f1c$var$shouldAssignObserverCurrentProperties(this, result)) {
            this.#currentResult = result;
            this.#currentResultOptions = this.options;
            this.#currentResultState = this.#currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked?.(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        this.#trackedProps.add(key);
    }
    getCurrentQuery() {
        return this.#currentQuery;
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.#client.defaultQueryOptions(options);
        const query = this.#client.getQueryCache().build(this.#client, defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return this.#executeFetch({
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return this.#currentResult;
        });
    }
    #executeFetch(fetchOptions) {
        this.#updateQuery();
        let promise = this.#currentQuery.fetch(this.options, fetchOptions);
        if (!fetchOptions?.throwOnError) promise = promise.catch((0, $1j5lT.noop));
        return promise;
    }
    #updateStaleTimeout() {
        this.#clearStaleTimeout();
        const staleTime = (0, $1j5lT.resolveStaleTime)(this.options.staleTime, this.#currentQuery);
        if ((0, $1j5lT.isServer) || this.#currentResult.isStale || !(0, $1j5lT.isValidTimeout)(staleTime)) return;
        const time = (0, $1j5lT.timeUntilStale)(this.#currentResult.dataUpdatedAt, staleTime);
        const timeout = time + 1;
        this.#staleTimeoutId = setTimeout(()=>{
            if (!this.#currentResult.isStale) this.updateResult();
        }, timeout);
    }
    #computeRefetchInterval() {
        return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.#currentQuery) : this.options.refetchInterval) ?? false;
    }
    #updateRefetchInterval(nextInterval) {
        this.#clearRefetchInterval();
        this.#currentRefetchInterval = nextInterval;
        if ((0, $1j5lT.isServer) || (0, $1j5lT.resolveEnabled)(this.options.enabled, this.#currentQuery) === false || !(0, $1j5lT.isValidTimeout)(this.#currentRefetchInterval) || this.#currentRefetchInterval === 0) return;
        this.#refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $8qv0d.focusManager).isFocused()) this.#executeFetch();
        }, this.#currentRefetchInterval);
    }
    #updateTimers() {
        this.#updateStaleTimeout();
        this.#updateRefetchInterval(this.#computeRefetchInterval());
    }
    #clearStaleTimeout() {
        if (this.#staleTimeoutId) {
            clearTimeout(this.#staleTimeoutId);
            this.#staleTimeoutId = void 0;
        }
    }
    #clearRefetchInterval() {
        if (this.#refetchIntervalId) {
            clearInterval(this.#refetchIntervalId);
            this.#refetchIntervalId = void 0;
        }
    }
    createResult(query, options) {
        const prevQuery = this.#currentQuery;
        const prevOptions = this.options;
        const prevResult = this.#currentResult;
        const prevResultState = this.#currentResultState;
        const prevResultOptions = this.#currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.#currentQueryInitialState;
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $9b08f53094393f1c$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $9b08f53094393f1c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $2Uo4O.fetchState)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === prevResultState?.data && options.select === this.#selectFn) data = this.#selectResult;
            else try {
                this.#selectFn = options.select;
                data = options.select(newState.data);
                data = (0, $1j5lT.replaceData)(prevResult?.data, data, options);
                this.#selectResult = data;
                this.#selectError = null;
            } catch (selectError) {
                this.#selectError = selectError;
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if (prevResult?.isPlaceholderData && options.placeholderData === prevResultOptions?.placeholderData) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(this.#lastQueryWithDefinedData?.state.data, this.#lastQueryWithDefinedData) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    this.#selectError = null;
                } catch (selectError) {
                    this.#selectError = selectError;
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $1j5lT.replaceData)(prevResult?.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.#selectError) {
            error = this.#selectError;
            data = this.#selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $9b08f53094393f1c$var$isStale(query, options),
            refetch: this.refetch,
            promise: this.#currentThenable
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = this.#currentThenable = nextResult.promise = (0, $fcsMR.pendingThenable)();
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = this.#currentThenable;
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = this.#currentResult;
        const nextResult = this.createResult(this.#currentQuery, this.options);
        this.#currentResultState = this.#currentQuery.state;
        this.#currentResultOptions = this.options;
        if (this.#currentResultState.data !== void 0) this.#lastQueryWithDefinedData = this.#currentQuery;
        if ((0, $1j5lT.shallowEqualObjects)(nextResult, prevResult)) return;
        this.#currentResult = nextResult;
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.#trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? this.#trackedProps);
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys(this.#currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.#currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        this.#notify({
            listeners: shouldNotifyListeners()
        });
    }
    #updateQuery() {
        const query = this.#client.getQueryCache().build(this.#client, this.options);
        if (query === this.#currentQuery) return;
        const prevQuery = this.#currentQuery;
        this.#currentQuery = query;
        this.#currentQueryInitialState = query.state;
        if (this.hasListeners()) {
            prevQuery?.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) this.#updateTimers();
    }
    #notify(notifyOptions) {
        (0, $cnq4V.notifyManager).batch(()=>{
            if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
            this.#client.getQueryCache().notify({
                query: this.#currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
};
function $9b08f53094393f1c$var$shouldLoadOnMount(query, options) {
    return (0, $1j5lT.resolveEnabled)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $9b08f53094393f1c$var$shouldFetchOnMount(query, options) {
    return $9b08f53094393f1c$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $9b08f53094393f1c$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $9b08f53094393f1c$var$shouldFetchOn(query, options, field) {
    if ((0, $1j5lT.resolveEnabled)(options.enabled, query) !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $9b08f53094393f1c$var$isStale(query, options);
    }
    return false;
}
function $9b08f53094393f1c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $1j5lT.resolveEnabled)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $9b08f53094393f1c$var$isStale(query, options);
}
function $9b08f53094393f1c$var$isStale(query, options) {
    return (0, $1j5lT.resolveEnabled)(options.enabled, query) !== false && query.isStaleByTime((0, $1j5lT.resolveStaleTime)(options.staleTime, query));
}
function $9b08f53094393f1c$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $1j5lT.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}

});
parcelRegister("8qv0d", function(module, exports) {
$parcel$export(module.exports, "focusManager", () => $6228cce07cc25939$export$6bf54661be5b02cf);
// src/focusManager.ts

var $6MLVK = parcelRequire("6MLVK");

var $1j5lT = parcelRequire("1j5lT");
var $6228cce07cc25939$export$86f1af424b2ca4de = class extends (0, $6MLVK.Subscribable) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (!(0, $1j5lT.isServer) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var $6228cce07cc25939$export$6bf54661be5b02cf = new $6228cce07cc25939$export$86f1af424b2ca4de();

});
parcelRegister("6MLVK", function(module, exports) {
$parcel$export(module.exports, "Subscribable", () => $4f0c67ba76e844e8$export$d26086b469ecdbcc);
// src/subscribable.ts
var $4f0c67ba76e844e8$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};

});

parcelRegister("1j5lT", function(module, exports) {
$parcel$export(module.exports, "isServer", () => $0f3bb79e70128b6b$export$6acf61af03e62db);
$parcel$export(module.exports, "noop", () => $0f3bb79e70128b6b$export$8793edee2d425525);
$parcel$export(module.exports, "functionalUpdate", () => $0f3bb79e70128b6b$export$7f095f455ad5af3f);
$parcel$export(module.exports, "isValidTimeout", () => $0f3bb79e70128b6b$export$e539f754e934e270);
$parcel$export(module.exports, "timeUntilStale", () => $0f3bb79e70128b6b$export$811b83d62bcf47f0);
$parcel$export(module.exports, "resolveStaleTime", () => $0f3bb79e70128b6b$export$cb3145f011bda3ac);
$parcel$export(module.exports, "resolveEnabled", () => $0f3bb79e70128b6b$export$8c88ee6f2357230d);
$parcel$export(module.exports, "matchQuery", () => $0f3bb79e70128b6b$export$c5d1efe363797780);
$parcel$export(module.exports, "hashQueryKeyByOptions", () => $0f3bb79e70128b6b$export$cc90ca97bc0d73fd);
$parcel$export(module.exports, "partialMatchKey", () => $0f3bb79e70128b6b$export$2f07189bb9fa26a7);
$parcel$export(module.exports, "matchMutation", () => $0f3bb79e70128b6b$export$a1ea5fb559f63ae3);
$parcel$export(module.exports, "hashKey", () => $0f3bb79e70128b6b$export$1e87d19d4aab5805);
$parcel$export(module.exports, "replaceEqualDeep", () => $0f3bb79e70128b6b$export$77a71fc411098696);
$parcel$export(module.exports, "shallowEqualObjects", () => $0f3bb79e70128b6b$export$3e67810a3f0e9f1c);
$parcel$export(module.exports, "sleep", () => $0f3bb79e70128b6b$export$e772c8ff12451969);
$parcel$export(module.exports, "replaceData", () => $0f3bb79e70128b6b$export$17619bac5b909b23);
$parcel$export(module.exports, "addToEnd", () => $0f3bb79e70128b6b$export$ccce65a22a26f2bc);
$parcel$export(module.exports, "addToStart", () => $0f3bb79e70128b6b$export$8c6246b73dd61f4a);
$parcel$export(module.exports, "skipToken", () => $0f3bb79e70128b6b$export$1aa5a89531b7670d);
$parcel$export(module.exports, "ensureQueryFn", () => $0f3bb79e70128b6b$export$c71c44209368a3bc);
// src/utils.ts
var $0f3bb79e70128b6b$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $0f3bb79e70128b6b$export$8793edee2d425525() {}
function $0f3bb79e70128b6b$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $0f3bb79e70128b6b$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $0f3bb79e70128b6b$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $0f3bb79e70128b6b$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $0f3bb79e70128b6b$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $0f3bb79e70128b6b$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $0f3bb79e70128b6b$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$0f3bb79e70128b6b$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $0f3bb79e70128b6b$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($0f3bb79e70128b6b$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $0f3bb79e70128b6b$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$0f3bb79e70128b6b$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $0f3bb79e70128b6b$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || $0f3bb79e70128b6b$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $0f3bb79e70128b6b$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$0f3bb79e70128b6b$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $0f3bb79e70128b6b$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$0f3bb79e70128b6b$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $0f3bb79e70128b6b$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $0f3bb79e70128b6b$export$7a8558113332b71e(a) && $0f3bb79e70128b6b$export$7a8558113332b71e(b);
    if (array || $0f3bb79e70128b6b$export$53b83ca8eaab0383(a) && $0f3bb79e70128b6b$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $0f3bb79e70128b6b$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $0f3bb79e70128b6b$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $0f3bb79e70128b6b$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $0f3bb79e70128b6b$export$53b83ca8eaab0383(o) {
    if (!$0f3bb79e70128b6b$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$0f3bb79e70128b6b$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $0f3bb79e70128b6b$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $0f3bb79e70128b6b$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $0f3bb79e70128b6b$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $0f3bb79e70128b6b$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $0f3bb79e70128b6b$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $0f3bb79e70128b6b$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $0f3bb79e70128b6b$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $0f3bb79e70128b6b$export$1aa5a89531b7670d = Symbol();
function $0f3bb79e70128b6b$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $0f3bb79e70128b6b$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}

});


parcelRegister("cnq4V", function(module, exports) {
$parcel$export(module.exports, "notifyManager", () => $902bdcac652c18bb$export$520687f44db6e1ab);
// src/notifyManager.ts
var $902bdcac652c18bb$export$7c76da44185e6090 = (cb)=>setTimeout(cb, 0);
function $902bdcac652c18bb$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $902bdcac652c18bb$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $902bdcac652c18bb$export$520687f44db6e1ab = $902bdcac652c18bb$export$316a8efd03cd1458();

});

parcelRegister("2Uo4O", function(module, exports) {
$parcel$export(module.exports, "Query", () => $21e37cd9187a37c3$export$62297b13309008b2);
$parcel$export(module.exports, "fetchState", () => $21e37cd9187a37c3$export$f3df9013f2b58bce);
// src/query.ts

var $1j5lT = parcelRequire("1j5lT");

var $cnq4V = parcelRequire("cnq4V");

var $a0qqk = parcelRequire("a0qqk");

var $7EMy9 = parcelRequire("7EMy9");
var $21e37cd9187a37c3$export$62297b13309008b2 = class extends (0, $7EMy9.Removable) {
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = $21e37cd9187a37c3$var$getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        return this.#retryer?.promise;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $1j5lT.replaceData)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.#dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $1j5lT.noop)).catch((0, $1j5lT.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.#initialState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $1j5lT.resolveEnabled)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $1j5lT.skipToken) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $1j5lT.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $1j5lT.ensureQueryFn)(this.options, fetchOptions);
            const queryFnContext = {
                client: this.#client,
                queryKey: this.queryKey,
                meta: this.meta
            };
            addSignalProperty(queryFnContext);
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            client: this.#client,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        this.options.behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        const onError = (error)=>{
            if (!((0, $a0qqk.isCancelledError)(error) && error.silent)) this.#dispatch({
                type: "error",
                error: error
            });
            if (!(0, $a0qqk.isCancelledError)(error)) {
                this.#cache.config.onError?.(error, this);
                this.#cache.config.onSettled?.(this.state.data, error, this);
            }
            this.scheduleGc();
        };
        this.#retryer = (0, $a0qqk.createRetryer)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(data);
                } catch (error) {
                    onError(error);
                    return;
                }
                this.#cache.config.onSuccess?.(data, this);
                this.#cache.config.onSettled?.(data, this.state.error, this);
                this.scheduleGc();
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        return this.#retryer.start();
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$21e37cd9187a37c3$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $a0qqk.isCancelledError)(error) && error.revert && this.#revertState) return {
                        ...this.#revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $cnq4V.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $21e37cd9187a37c3$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $a0qqk.canFetch)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $21e37cd9187a37c3$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}

});
parcelRegister("a0qqk", function(module, exports) {
$parcel$export(module.exports, "canFetch", () => $748e66a9a7b0592e$export$61b92f63f30245cf);
$parcel$export(module.exports, "isCancelledError", () => $748e66a9a7b0592e$export$986cc6445c1d323);
$parcel$export(module.exports, "createRetryer", () => $748e66a9a7b0592e$export$2cbd00fe8a2c8d85);
// src/retryer.ts

var $8qv0d = parcelRequire("8qv0d");

var $lzTt6 = parcelRequire("lzTt6");

var $fcsMR = parcelRequire("fcsMR");

var $1j5lT = parcelRequire("1j5lT");
function $748e66a9a7b0592e$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $748e66a9a7b0592e$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $lzTt6.onlineManager).isOnline() : true;
}
var $748e66a9a7b0592e$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function $748e66a9a7b0592e$export$986cc6445c1d323(value) {
    return value instanceof $748e66a9a7b0592e$export$a8430ed4188f35a9;
}
function $748e66a9a7b0592e$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    const thenable = (0, $fcsMR.pendingThenable)();
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $748e66a9a7b0592e$export$a8430ed4188f35a9(cancelOptions));
            config.abort?.();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $8qv0d.focusManager).isFocused() && (config.networkMode === "always" || (0, $lzTt6.onlineManager).isOnline()) && config.canRun();
    const canStart = ()=>$748e66a9a7b0592e$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess?.(value);
            continueFn?.();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError?.(value);
            continueFn?.();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved) return;
            const retry = config.retry ?? ((0, $1j5lT.isServer) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $748e66a9a7b0592e$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $1j5lT.sleep)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}

});
parcelRegister("lzTt6", function(module, exports) {
$parcel$export(module.exports, "onlineManager", () => $fb57e4b7702e32bd$export$b113e788b2dd3fdc);
// src/onlineManager.ts

var $6MLVK = parcelRequire("6MLVK");

var $1j5lT = parcelRequire("1j5lT");
var $fb57e4b7702e32bd$export$58774fb55d5ff7fc = class extends (0, $6MLVK.Subscribable) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (!(0, $1j5lT.isServer) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var $fb57e4b7702e32bd$export$b113e788b2dd3fdc = new $fb57e4b7702e32bd$export$58774fb55d5ff7fc();

});

parcelRegister("fcsMR", function(module, exports) {
$parcel$export(module.exports, "pendingThenable", () => $b10e4e8525071b43$export$d54630db02a12b72);
// src/thenable.ts
function $b10e4e8525071b43$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}

});


parcelRegister("7EMy9", function(module, exports) {
$parcel$export(module.exports, "Removable", () => $5931edcd45d741e6$export$e09608847fcc8c59);
// src/removable.ts

var $1j5lT = parcelRequire("1j5lT");
var $5931edcd45d741e6$export$e09608847fcc8c59 = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $1j5lT.isValidTimeout)(this.gcTime)) this.#gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $1j5lT.isServer) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout) {
            clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};

});



parcelRegister("ctX0Q", function(module, exports) {
$parcel$export(module.exports, "useBaseQuery", () => $9165f820224afebe$export$fff0865807e996c5);

var $4tluv = parcelRequire("4tluv");

var $1j5lT = parcelRequire("1j5lT");
var $cnq4V = parcelRequire("cnq4V");

var $4cZqh = parcelRequire("4cZqh");

var $3SsW6 = parcelRequire("3SsW6");

var $44O1u = parcelRequire("44O1u");

var $gEvBY = parcelRequire("gEvBY");

var $6RauK = parcelRequire("6RauK");

var $M8kp4 = parcelRequire("M8kp4");
"use client";
function $9165f820224afebe$export$fff0865807e996c5(options, Observer, queryClient) {
    const client = (0, $4cZqh.useQueryClient)(queryClient);
    const isRestoring = (0, $gEvBY.useIsRestoring)();
    const errorResetBoundary = (0, $3SsW6.useQueryErrorResetBoundary)();
    const defaultedOptions = client.defaultQueryOptions(options);
    client.getDefaultOptions().queries?._experimental_beforeQuery?.(defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $6RauK.ensureSuspenseTimers)(defaultedOptions);
    (0, $44O1u.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $44O1u.useClearResetErrorBoundary)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $4tluv.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $4tluv.useSyncExternalStore($4tluv.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $cnq4V.notifyManager).batchCalls(onStoreChange)) : (0, $M8kp4.noop);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $4tluv.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $6RauK.shouldSuspend)(defaultedOptions, result)) throw (0, $6RauK.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $44O1u.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash),
        suspense: defaultedOptions.suspense
    })) throw result.error;
    client.getDefaultOptions().queries?._experimental_afterQuery?.(defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $1j5lT.isServer) && (0, $6RauK.willFetch)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $6RauK.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        client.getQueryCache().get(defaultedOptions.queryHash)?.promise;
        promise?.catch((0, $M8kp4.noop)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("3SsW6", function(module, exports) {
$parcel$export(module.exports, "useQueryErrorResetBoundary", () => $2d2cdc5fcebbc287$export$50dfac555130cafd);

var $4tluv = parcelRequire("4tluv");

var $2iln5 = parcelRequire("2iln5");
"use client";
function $2d2cdc5fcebbc287$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $2d2cdc5fcebbc287$var$QueryErrorResetBoundaryContext = $4tluv.createContext($2d2cdc5fcebbc287$var$createValue());
var $2d2cdc5fcebbc287$export$50dfac555130cafd = ()=>$4tluv.useContext($2d2cdc5fcebbc287$var$QueryErrorResetBoundaryContext);
var $2d2cdc5fcebbc287$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $4tluv.useState(()=>$2d2cdc5fcebbc287$var$createValue());
    return /* @__PURE__ */ (0, $2iln5.jsx)($2d2cdc5fcebbc287$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};

});

parcelRegister("44O1u", function(module, exports) {
$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", () => $2f7e56b043478f78$export$ae8adb3de3d77633);
$parcel$export(module.exports, "useClearResetErrorBoundary", () => $2f7e56b043478f78$export$b2b17ca3a1fb0229);
$parcel$export(module.exports, "getHasError", () => $2f7e56b043478f78$export$1fbcf724762d607);

var $4tluv = parcelRequire("4tluv");

var $M8kp4 = parcelRequire("M8kp4");
"use client";
var $2f7e56b043478f78$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $2f7e56b043478f78$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $4tluv.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $2f7e56b043478f78$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $M8kp4.shouldThrowError)(throwOnError, [
        result.error,
        query
    ]));
};

});
parcelRegister("M8kp4", function(module, exports) {
$parcel$export(module.exports, "shouldThrowError", () => $090af1981d06c0ac$export$2072f68e6c3507cf);
$parcel$export(module.exports, "noop", () => $090af1981d06c0ac$export$8793edee2d425525);
// src/utils.ts
function $090af1981d06c0ac$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $090af1981d06c0ac$export$8793edee2d425525() {}

});


parcelRegister("6RauK", function(module, exports) {
$parcel$export(module.exports, "defaultThrowOnError", () => $4fdfd56496ec18ed$export$8bed2f8d02206063);
$parcel$export(module.exports, "ensureSuspenseTimers", () => $4fdfd56496ec18ed$export$274d2a1db5a20c09);
$parcel$export(module.exports, "willFetch", () => $4fdfd56496ec18ed$export$e0a3f29513afe430);
$parcel$export(module.exports, "shouldSuspend", () => $4fdfd56496ec18ed$export$88d3586dfed64df9);
$parcel$export(module.exports, "fetchOptimistic", () => $4fdfd56496ec18ed$export$defdc11a9c9acfcf);
// src/suspense.ts
var $4fdfd56496ec18ed$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $4fdfd56496ec18ed$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    const originalStaleTime = defaultedOptions.staleTime;
    if (defaultedOptions.suspense) {
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>Math.max(originalStaleTime(...args), 1e3) : Math.max(originalStaleTime ?? 1e3, 1e3);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
};
var $4fdfd56496ec18ed$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $4fdfd56496ec18ed$export$88d3586dfed64df9 = (defaultedOptions, result)=>defaultedOptions?.suspense && result.isPending;
var $4fdfd56496ec18ed$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });

});



parcelRegister("8n7En", function(module, exports) {
$parcel$export(module.exports, "Main", () => $618667e381ce97ed$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $3X3Vo = parcelRequire("3X3Vo");

var $9H0BF = parcelRequire("9H0BF");


var $fDJaB = parcelRequire("fDJaB");

var $jXiqK = parcelRequire("jXiqK");
var $618667e381ce97ed$var$mainElementStyles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    fixedContentArea: "_1reo1wug _18m91wug _152timx3 _165teqxy _13wn1if8"
};
function $618667e381ce97ed$export$861edd1ccea2f746(_ref) {
    var children = _ref.children, isFixedProp = _ref.isFixed, xcss = _ref.xcss, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? 'Main Content' : _ref$skipLinkLabel, testId = _ref.testId, providedId = _ref.id;
    var id = (0, $fDJaB.useLayoutId)({
        providedId: providedId
    });
    var isFixed = (0, $3X3Vo.fg)('platform_dst_nav4_disable_is_fixed_prop') ? true : isFixedProp;
    (0, $9H0BF.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ $4tluv.createElement((0, $4tluv.Fragment), null, /*#__PURE__*/ $4tluv.createElement("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $jAkMr.default)([
            $618667e381ce97ed$var$mainElementStyles.root,
            isFixed && $618667e381ce97ed$var$mainElementStyles.fixedContentArea,
            xcss
        ]),
        role: "main",
        "data-testid": testId
    }, /*#__PURE__*/ $4tluv.createElement((0, $jXiqK.MainStickyContext).Provider, {
        value: Boolean(isFixed)
    }, children)));
}

});
parcelRegister("9H0BF", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", () => $70e899abf9c0d030$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinkInternal", () => $70e899abf9c0d030$export$707b94c26b8b75aa);
$parcel$export(module.exports, "useSkipLink", () => $70e899abf9c0d030$export$89d9323301efc7d6);

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");
var $70e899abf9c0d030$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $4tluv.createContext)({
    registerSkipLink: (0, $ccErM.default),
    unregisterSkipLink: (0, $ccErM.default)
});
var $70e899abf9c0d030$var$useSkipLinks = function useSkipLinks() {
    return (0, $4tluv.useContext)($70e899abf9c0d030$export$4c5cc3b14c7678a);
};
var $70e899abf9c0d030$export$707b94c26b8b75aa = function useSkipLinkInternal(_ref) {
    var id = _ref.id, label = _ref.label, listIndex = _ref.listIndex, onBeforeNavigate = _ref.onBeforeNavigate, isHidden = _ref.isHidden;
    var _useSkipLinks = $70e899abf9c0d030$var$useSkipLinks(), registerSkipLink = _useSkipLinks.registerSkipLink, unregisterSkipLink = _useSkipLinks.unregisterSkipLink;
    (0, $4tluv.useEffect)(function() {
        if (isHidden) /**
       * Skip links are hidden for slots with 0 height or width.
       * They should not be registered.
       */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return function() {
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
var $70e899abf9c0d030$export$89d9323301efc7d6 = function useSkipLink(id, label, listIndex) {
    $70e899abf9c0d030$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("fDJaB", function(module, exports) {
$parcel$export(module.exports, "useLayoutId", () => $b62d895d96e7ae55$export$110c3550c7c1c9aa);

var $fEY94 = parcelRequire("fEY94");
function $b62d895d96e7ae55$export$fa3cfac0c8e29c5c() {
    var uniqueId = (0, $fEY94.useId)();
    return uniqueId;
}
function $b62d895d96e7ae55$export$110c3550c7c1c9aa() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, providedId = _ref.providedId;
    var uniqueId = $b62d895d96e7ae55$export$fa3cfac0c8e29c5c();
    var id = providedId ? providedId : uniqueId;
    return id;
}

});

parcelRegister("jXiqK", function(module, exports) {
$parcel$export(module.exports, "MainStickyContext", () => $e871d2e7c6f114e1$export$3b369e2c6c1ec840);

var $4tluv = parcelRequire("4tluv");
var $e871d2e7c6f114e1$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $4tluv.createContext)(false);

});


parcelRegister("f9HkP", function(module, exports) {
$parcel$export(module.exports, "gridRootId", () => $b0894fb5aeda7e08$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $b0894fb5aeda7e08$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $apJa9 = parcelRequire("apJa9");

var $bV05s = parcelRequire("bV05s");

var $a8tlb = parcelRequire("a8tlb");

var $krZrz = parcelRequire("krZrz");

var $4eU0H = parcelRequire("4eU0H");

var $clYje = parcelRequire("clYje");

var $bd8YS = parcelRequire("bd8YS");

var $5zq0c = parcelRequire("5zq0c");
var $b0894fb5aeda7e08$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
var $b0894fb5aeda7e08$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $b0894fb5aeda7e08$export$be92b6f5f03c0fe9(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$UNSAFE_dangerous = _ref.UNSAFE_dangerouslyHoistSlotSizes, UNSAFE_dangerouslyHoistSlotSizes = _ref$UNSAFE_dangerous === void 0 ? false : _ref$UNSAFE_dangerous, _ref$skipLinksLabel = _ref.skipLinksLabel, skipLinksLabel = _ref$skipLinksLabel === void 0 ? 'Skip to:' : _ref$skipLinksLabel, testId = _ref.testId;
    var ref = (0, $4tluv.useRef)(null);
    (0, $4tluv.useEffect)(function() {
        var IGNORED_ELEMENTS;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $5zq0c.SideNavVisibilityProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bd8YS.SideNavToggleButtonProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $clYje.SideNavElementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $krZrz.TopNavStartProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $apJa9.OpenLayerObserver), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $4eU0H.DangerouslyHoistSlotSizes).Provider, {
        value: UNSAFE_dangerouslyHoistSlotSizes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $a8tlb.SkipLinksProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $bV05s.SkipLinksContainer), {
        label: skipLinksLabel,
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("div", {
        ref: ref,
        className: (0, $jAkMr.default)([
            $b0894fb5aeda7e08$var$styles.root,
            xcss
        ]),
        id: $b0894fb5aeda7e08$export$a6d827031bcb31d1,
        "data-testid": testId
    }, children))))))));
}

});
parcelRegister("bV05s", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContainer", () => $8ad515df8150e630$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $cYEgx = parcelRequire("cYEgx");

var $27umU = parcelRequire("27umU");

var $5GRvo = parcelRequire("5GRvo");
var $8ad515df8150e630$var$styles = {
    root: "_zulp1b66 _2rkoglpi _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    skipLinkList: "_zulp1b66 _1e0c1txw _2lx21bp4 _1x8w11lx _2mzuglyw _1pfhze3t _bozgze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them if you press TAB it will reopen the list and move to the next one...
 */ var $8ad515df8150e630$var$closeOnEscape = function closeOnEscape(event) {
    if (event.key !== 'Escape') return;
    var activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
var $8ad515df8150e630$var$isOnlyWhitespaceRegex = /^\s*$/;
var $8ad515df8150e630$export$fce25a0c32fbc1e1 = function SkipLinksContainer(_ref) {
    var label = _ref.label, testId = _ref.testId;
    var sortedSkipLinks = (0, $27umU.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    var isEmptyLabel = $8ad515df8150e630$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ $4tluv.createElement("div", {
        onKeyDown: $8ad515df8150e630$var$closeOnEscape,
        "data-testid": testId ? "".concat(testId, "--skip-links-container") : undefined,
        className: (0, $jAkMr.default)([
            $8ad515df8150e630$var$styles.root
        ])
    }, !isEmptyLabel && /*#__PURE__*/ $4tluv.createElement((0, $cYEgx.default), {
        weight: "bold",
        testId: testId ? "".concat(testId, "--skip-links-container--label") : undefined
    }, label), /*#__PURE__*/ $4tluv.createElement("ol", {
        className: (0, $jAkMr.default)([
            $8ad515df8150e630$var$styles.skipLinkList
        ])
    }, sortedSkipLinks.map(function(_ref2) {
        var id = _ref2.id, label = _ref2.label, onBeforeNavigate = _ref2.onBeforeNavigate;
        return /*#__PURE__*/ $4tluv.createElement((0, $5GRvo.SkipLink), {
            key: id,
            id: id,
            onBeforeNavigate: onBeforeNavigate
        }, label);
    })));
};

});
parcelRegister("27umU", function(module, exports) {
$parcel$export(module.exports, "SkipLinksDataContext", () => $18b3cac4502e1e5e$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $18b3cac4502e1e5e$export$b0b0d4fc1b356759);

var $iXWBi = parcelRequire("iXWBi");

var $hh01j = parcelRequire("hh01j");

var $4tluv = parcelRequire("4tluv");
function $18b3cac4502e1e5e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $18b3cac4502e1e5e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $18b3cac4502e1e5e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hh01j.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $18b3cac4502e1e5e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $18b3cac4502e1e5e$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $4tluv.createContext)([]);
var $18b3cac4502e1e5e$var$_assignIndex = function assignIndex(num, arr) {
    if (!arr.includes(num)) return num;
    return $18b3cac4502e1e5e$var$_assignIndex(num + 1, arr);
};
var $18b3cac4502e1e5e$var$sortSkipLinks = function sortSkipLinks(arr) {
    var customLinks = arr.filter(function(link) {
        return Number.isInteger(link.listIndex);
    });
    if (customLinks.length === 0) return arr;
    var usedIndexes = customLinks.map(function(a) {
        return a.listIndex;
    });
    var regularLinksWithIdx = arr.filter(function(link) {
        return link.listIndex === undefined;
    }).map(function(link, idx) {
        var listIndex = $18b3cac4502e1e5e$var$_assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return $18b3cac4502e1e5e$var$_objectSpread($18b3cac4502e1e5e$var$_objectSpread({}, link), {}, {
            listIndex: listIndex
        });
    });
    return [].concat((0, $iXWBi.default)(customLinks), (0, $iXWBi.default)(regularLinksWithIdx)).sort(function(a, b) {
        return a.listIndex - b.listIndex;
    });
};
var $18b3cac4502e1e5e$export$b0b0d4fc1b356759 = function useSortedSkipLinks() {
    var skipLinksData = (0, $4tluv.useContext)($18b3cac4502e1e5e$export$e9ab38ce6147d3d2);
    return (0, $4tluv.useMemo)(function() {
        return $18b3cac4502e1e5e$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("5GRvo", function(module, exports) {
$parcel$export(module.exports, "SkipLink", () => $424a610fa4c75951$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $Hyfcf = parcelRequire("Hyfcf");

var $2X3dI = parcelRequire("2X3dI");
var $424a610fa4c75951$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $424a610fa4c75951$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   *
   * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
   *
   * - mess with click events
   * - potentially cause a focus ring to be always visible
   */ (0, $Hyfcf.bind)(element, {
        type: 'blur',
        listener: function listener() {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
var $424a610fa4c75951$export$ef95c37428582a65 = function SkipLink(_ref) {
    var id = _ref.id, children = _ref.children, onBeforeNavigate = _ref.onBeforeNavigate;
    var href = "#".concat(id);
    var onClick = (0, $4tluv.useCallback)(function(event) {
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        var target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate === null || onBeforeNavigate === void 0 || onBeforeNavigate();
        $424a610fa4c75951$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("li", {
        className: (0, $jAkMr.default)([
            $424a610fa4c75951$var$styles.skipLinkListItem
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $2X3dI.default), {
        tabIndex: 0,
        href: href,
        onClick: onClick
    }, children));
};

});


parcelRegister("a8tlb", function(module, exports) {
$parcel$export(module.exports, "SkipLinksProvider", () => $76116931b262fa88$export$fe514f9f7b03d46f);

var $iXWBi = parcelRequire("iXWBi");

var $9DNBn = parcelRequire("9DNBn");

var $4tluv = parcelRequire("4tluv");

var $9H0BF = parcelRequire("9H0BF");

var $27umU = parcelRequire("27umU");
var $76116931b262fa88$var$getByDomOrderSortFunction = function getByDomOrderSortFunction() {
    var layoutSlots = Array.from(document.querySelectorAll("[data-layout-slot]"));
    return function(a, b) {
        var _a$listIndex, _b$listIndex;
        var indexA = (_a$listIndex = a.listIndex) !== null && _a$listIndex !== void 0 ? _a$listIndex : layoutSlots.indexOf(document.getElementById(a.id));
        var indexB = (_b$listIndex = b.listIndex) !== null && _b$listIndex !== void 0 ? _b$listIndex : layoutSlots.indexOf(document.getElementById(b.id));
        /**
     * If they are tied it is because one (or both) is
     * a custom skiplink with a set index.
     *
     * Give the custom skiplink priority.
     */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
var $76116931b262fa88$export$fe514f9f7b03d46f = function SkipLinksProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $4tluv.useState)([]), _useState2 = (0, $9DNBn.default)(_useState, 2), links = _useState2[0], setLinks = _useState2[1];
    var registerSkipLink = (0, $4tluv.useCallback)(function(skipLinkData) {
        // Don't add duplicate skip links
        setLinks(function(oldLinks) {
            if (oldLinks.some(function(_ref2) {
                var id = _ref2.id;
                return id === skipLinkData.id;
            })) return oldLinks;
            return [].concat((0, $iXWBi.default)(oldLinks), [
                skipLinkData
            ]).sort($76116931b262fa88$var$getByDomOrderSortFunction());
        });
    }, []);
    var unregisterSkipLink = (0, $4tluv.useCallback)(function(id) {
        setLinks(function(links) {
            return links.filter(function(link) {
                return link.id !== id;
            });
        });
    }, []);
    var contextValue = (0, $4tluv.useMemo)(function() {
        var data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $9H0BF.SkipLinksContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $27umU.SkipLinksDataContext).Provider, {
        value: links
    }, children));
};

});

parcelRegister("krZrz", function(module, exports) {
$parcel$export(module.exports, "TopNavStartProvider", () => $ee35fdb8613df3ad$export$bc9d0ad0bce43e75);

var $9DNBn = parcelRequire("9DNBn");

var $4tluv = parcelRequire("4tluv");

var $962Xd = parcelRequire("962Xd");
var $ee35fdb8613df3ad$export$bc9d0ad0bce43e75 = function TopNavStartProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $4tluv.useState)(null), _useState2 = (0, $9DNBn.default)(_useState, 2), element = _useState2[0], setElement = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $962Xd.TopNavStartElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $962Xd.TopNavStartAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("962Xd", function(module, exports) {
$parcel$export(module.exports, "TopNavStartElement", () => $69f6f73b3ac5404a$export$e9e5087bd319cc8c);
$parcel$export(module.exports, "TopNavStartAttachRef", () => $69f6f73b3ac5404a$export$55f0a642b785fb1f);

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");
var $69f6f73b3ac5404a$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $4tluv.createContext)(null);
var $69f6f73b3ac5404a$export$55f0a642b785fb1f = /*#__PURE__*/ (0, $4tluv.createContext)((0, $ccErM.default));

});


parcelRegister("4eU0H", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $3163eab1558dd894$export$66e2c1a0115af861);

var $4tluv = parcelRequire("4tluv");
var $3163eab1558dd894$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $4tluv.createContext)(false);

});

parcelRegister("clYje", function(module, exports) {
$parcel$export(module.exports, "SideNavElementProvider", () => $8fe63a5d5abd4aae$export$85c1ff84bbf6e6dc);

var $4tluv = parcelRequire("4tluv");
var $8fe63a5d5abd4aae$var$SideNavRefContext = /*#__PURE__*/ (0, $4tluv.createContext)({
    current: null
});
function $8fe63a5d5abd4aae$export$85c1ff84bbf6e6dc(_ref) {
    var children = _ref.children;
    var sideNavRef = (0, $4tluv.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($8fe63a5d5abd4aae$var$SideNavRefContext.Provider, {
        value: sideNavRef
    }, children);
}
function $8fe63a5d5abd4aae$export$fa4d0cff03b1ea4f() {
    return (0, $4tluv.useContext)($8fe63a5d5abd4aae$var$SideNavRefContext);
}

});

parcelRegister("bd8YS", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $8297e002848c01de$export$ceb8e60e9790fc0f);

var $9DNBn = parcelRequire("9DNBn");

var $4tluv = parcelRequire("4tluv");

var $kXNtH = parcelRequire("kXNtH");
var $8297e002848c01de$export$ceb8e60e9790fc0f = function SideNavToggleButtonProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $4tluv.useState)(null), _useState2 = (0, $9DNBn.default)(_useState, 2), element = _useState2[0], setElement = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kXNtH.SideNavToggleButtonElement).Provider, {
        value: element
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $kXNtH.SideNavToggleButtonAttachRef).Provider, {
        value: setElement
    }, children));
};

});
parcelRegister("kXNtH", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonElement", () => $f42fb2a30d088c5c$export$9c1768094bef896);
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $f42fb2a30d088c5c$export$fb8fa9a80240785e);

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");
var $f42fb2a30d088c5c$export$9c1768094bef896 = /*#__PURE__*/ (0, $4tluv.createContext)(null);
var $f42fb2a30d088c5c$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $4tluv.createContext)((0, $ccErM.default));

});


parcelRegister("5zq0c", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityProvider", () => $40e4641eb74635f2$export$aac8e996360f6ad9);

var $9DNBn = parcelRequire("9DNBn");

var $4tluv = parcelRequire("4tluv");

var $6lAmj = parcelRequire("6lAmj");
var $40e4641eb74635f2$export$aac8e996360f6ad9 = function SideNavVisibilityProvider(_ref) {
    var children = _ref.children;
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    var _useState = (0, $4tluv.useState)(null), _useState2 = (0, $9DNBn.default)(_useState, 2), sideNavState = _useState2[0], setSideNavState = _useState2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $6lAmj.SideNavVisibilityState).Provider, {
        value: sideNavState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $6lAmj.SetSideNavVisibilityState).Provider, {
        value: setSideNavState
    }, children));
};

});
parcelRegister("6lAmj", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityState", () => $49f0e85ba1e760fd$export$eb04201bb6dd1e4e);
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $49f0e85ba1e760fd$export$f6b496b07d1ea493);

var $4tluv = parcelRequire("4tluv");

var $ccErM = parcelRequire("ccErM");
var $49f0e85ba1e760fd$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $4tluv.createContext)(null);
var $49f0e85ba1e760fd$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $4tluv.createContext)((0, $ccErM.default));

});



parcelRegister("1CC9j", function(module, exports) {
$parcel$export(module.exports, "TopNav", () => $12e6eeb6d36379c4$export$41d0d88a6b0e456f);
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $3X3Vo = parcelRequire("3X3Vo");

var $9H0BF = parcelRequire("9H0BF");

var $6wyCz = parcelRequire("6wyCz");

var $dK00j = parcelRequire("dK00j");

var $a4rov = parcelRequire("a4rov");

var $4eU0H = parcelRequire("4eU0H");

var $er86a = parcelRequire("er86a");

var $fDJaB = parcelRequire("fDJaB");
var $12e6eeb6d36379c4$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i1dgc _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi",
    oldLayoutStyles: "_1rqtc57g",
    newLayoutStyles: "_1j8b18ax"
};
function $12e6eeb6d36379c4$export$41d0d88a6b0e456f(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$height = _ref.height, height = _ref$height === void 0 ? 48 : _ref$height, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? 'Top Bar' : _ref$skipLinkLabel, testId = _ref.testId, providedId = _ref.id, UNSAFE_theme = _ref.UNSAFE_theme;
    var dangerouslyHoistSlotSizes = (0, $4tluv.useContext)((0, $4eU0H.DangerouslyHoistSlotSizes));
    var id = (0, $fDJaB.useLayoutId)({
        providedId: providedId
    });
    (0, $9H0BF.useSkipLink)(id, skipLinkLabel);
    var customTheme = (0, $dK00j.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ $4tluv.createElement((0, $6wyCz.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled
    }, /*#__PURE__*/ $4tluv.createElement("header", {
        id: id,
        "data-layout-slot": true,
        className: (0, $jAkMr.default)([
            $12e6eeb6d36379c4$var$styles.root,
            (0, $3X3Vo.fg)('platform_design_system_nav4_top_nav_columns') ? $12e6eeb6d36379c4$var$styles.newLayoutStyles : $12e6eeb6d36379c4$var$styles.oldLayoutStyles,
            xcss
        ]),
        "data-testid": testId,
        style: customTheme.isEnabled ? customTheme.style : undefined
    }, /*#__PURE__*/ $4tluv.createElement((0, $er86a.HoistCssVarToLocalGrid), {
        variableName: (0, $a4rov.topNavMountedVar),
        value: height
    }), dangerouslyHoistSlotSizes && /*#__PURE__*/ // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    $4tluv.createElement((0, $er86a.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $a4rov.UNSAFE_topNavVar),
        value: height
    }), children));
}

});
parcelRegister("6wyCz", function(module, exports) {
$parcel$export(module.exports, "HasCustomThemeContext", () => $4c00964660af068d$export$d158fa15757a1890);
$parcel$export(module.exports, "useHasCustomTheme", () => $4c00964660af068d$export$abfcaeeca4ae7a55);

var $4tluv = parcelRequire("4tluv");
var $4c00964660af068d$export$d158fa15757a1890 = /*#__PURE__*/ (0, $4tluv.createContext)(false);
function $4c00964660af068d$export$abfcaeeca4ae7a55() {
    return (0, $4tluv.useContext)($4c00964660af068d$export$d158fa15757a1890);
}

});

parcelRegister("dK00j", function(module, exports) {
$parcel$export(module.exports, "useCustomTheme", () => $a00f930d0b7e1904$export$c0c5f5b297b77726);

var $4tluv = parcelRequire("4tluv");

var $81AgY = parcelRequire("81AgY");
function $a00f930d0b7e1904$export$c0c5f5b297b77726(theme) {
    var value = (0, $4tluv.useMemo)(function() {
        if (!(theme !== null && theme !== void 0 && theme.backgroundColor) || !(theme !== null && theme !== void 0 && theme.highlightColor)) return {
            isEnabled: false
        };
        /**
     * Re-creating the `theme` object from it's pieces.
     *
     * _Technically_ we could just use `theme`, but that would involve an eslint opt out
     * as we would be leveraging a value (`theme`) not in the dependency array.
     *
     * The current approach is the most correct™️ and avoids foot guns.
     * We are only using values in the effect that are defined in the dependency array 🙌
     */ var value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        var style = (0, $81AgY.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme === null || theme === void 0 ? void 0 : theme.backgroundColor,
        theme === null || theme === void 0 ? void 0 : theme.highlightColor
    ]);
    return value;
}

});
parcelRegister("81AgY", function(module, exports) {
$parcel$export(module.exports, "getCustomThemeStyles", () => $5d7a8dbdd30067e1$export$3986d75fe2da3239);

var $hh01j = parcelRequire("hh01j");

var $2VaCp = parcelRequire("2VaCp");

var $bVWjb = parcelRequire("bVWjb");

var $jDJlP = parcelRequire("jDJlP");

var $3sakR = parcelRequire("3sakR");

var $jU7Gv = parcelRequire("jU7Gv");

var $gGwyE = parcelRequire("gGwyE");
function $5d7a8dbdd30067e1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d7a8dbdd30067e1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d7a8dbdd30067e1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hh01j.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d7a8dbdd30067e1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Expects colors to be passed as `RGB` objects.
 *
 * Allows `string` for hex strings only, for backwards compatibility.
 * This will likely be removed in the future.
 *
 * Allows `null` for ergonomic reasons, because our color parsing utilities can return
 * `null` if they cannot parse a color string.
 */ function $5d7a8dbdd30067e1$var$toRGBString(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
}
function $5d7a8dbdd30067e1$var$toRGBAString(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b, a = _ref2.a;
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
var $5d7a8dbdd30067e1$var$buttonStyles = {
    light: (0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)({}, (0, $bVWjb.themedButtonBackground), 'transparent'), (0, $bVWjb.themedButtonBackgroundHovered), (0, $jU7Gv.palette).Neutral200A), (0, $bVWjb.themedButtonBackgroundPressed), (0, $jU7Gv.palette).Neutral300A), (0, $bVWjb.themedButtonBorder), (0, $jU7Gv.palette).Neutral300A), (0, $bVWjb.themedButtonSelectedBackground), (0, $jU7Gv.palette).Neutral300A), (0, $bVWjb.themedButtonSelectedBackgroundHovered), (0, $jU7Gv.palette).Neutral400A), (0, $bVWjb.themedButtonSelectedBackgroundPressed), (0, $jU7Gv.palette).Neutral500A), (0, $bVWjb.themedButtonDisabledText), (0, $jU7Gv.palette).Neutral400A), (0, $bVWjb.themedButtonDisabledBackground), (0, $jU7Gv.palette).Neutral100A),
    dark: (0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)({}, (0, $bVWjb.themedButtonBackground), 'transparent'), (0, $bVWjb.themedButtonBackgroundHovered), (0, $jU7Gv.palette).DarkNeutral200A), (0, $bVWjb.themedButtonBackgroundPressed), (0, $jU7Gv.palette).DarkNeutral300A), (0, $bVWjb.themedButtonBorder), (0, $jU7Gv.palette).DarkNeutral300A), (0, $bVWjb.themedButtonSelectedBackground), (0, $jU7Gv.palette).DarkNeutral300A), (0, $bVWjb.themedButtonSelectedBackgroundHovered), (0, $jU7Gv.palette).DarkNeutral400A), (0, $bVWjb.themedButtonSelectedBackgroundPressed), (0, $jU7Gv.palette).DarkNeutral500A), (0, $bVWjb.themedButtonDisabledText), (0, $jU7Gv.palette).DarkNeutral400A), (0, $bVWjb.themedButtonDisabledBackground), (0, $jU7Gv.palette).DarkNeutral100A)
};
var $5d7a8dbdd30067e1$var$logoStyles = {
    light: (0, $hh01j.default)((0, $hh01j.default)({}, (0, $2VaCp.themedLogoIcon), (0, $jU7Gv.palette).DarkNeutral0), (0, $2VaCp.themedLogoText), (0, $jU7Gv.palette).DarkNeutral0),
    dark: (0, $hh01j.default)((0, $hh01j.default)({}, (0, $2VaCp.themedLogoIcon), (0, $jU7Gv.palette).Neutral0), (0, $2VaCp.themedLogoText), (0, $jU7Gv.palette).Neutral0)
};
function $5d7a8dbdd30067e1$export$3986d75fe2da3239(_ref3) {
    var backgroundColor = _ref3.backgroundColor, highlightColor = _ref3.highlightColor;
    var backgroundRgb = typeof backgroundColor === 'string' ? (0, $3sakR.parseHex)(backgroundColor) : backgroundColor;
    var highlightRgb = typeof highlightColor === 'string' ? (0, $3sakR.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    var textColor = (0, $jDJlP.getTextColor)(backgroundRgb);
    var colorMode = (0, $jDJlP.getColorMode)(backgroundRgb);
    var highlightTextColor = (0, $jDJlP.getTextColor)(highlightRgb);
    return $5d7a8dbdd30067e1$var$_objectSpread($5d7a8dbdd30067e1$var$_objectSpread($5d7a8dbdd30067e1$var$_objectSpread($5d7a8dbdd30067e1$var$_objectSpread({
        backgroundColor: $5d7a8dbdd30067e1$var$toRGBString(backgroundRgb),
        color: textColor.hex
    }, $5d7a8dbdd30067e1$var$buttonStyles[colorMode]), $5d7a8dbdd30067e1$var$logoStyles[colorMode]), $5d7a8dbdd30067e1$var$getSelectedStyles({
        backgroundColor: backgroundRgb,
        colorMode: colorMode
    })), {}, (0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)((0, $hh01j.default)({}, (0, $gGwyE.themedSearchBorder), $5d7a8dbdd30067e1$var$toRGBAString($5d7a8dbdd30067e1$var$_objectSpread($5d7a8dbdd30067e1$var$_objectSpread({}, textColor.rgb), {}, {
        a: 0.5
    }))), (0, $gGwyE.themedSearchBorderFocused), $5d7a8dbdd30067e1$var$toRGBAString($5d7a8dbdd30067e1$var$_objectSpread($5d7a8dbdd30067e1$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.8
    }))), (0, $bVWjb.themedButtonPrimaryBackground), $5d7a8dbdd30067e1$var$toRGBString(highlightRgb)), (0, $bVWjb.themedButtonPrimaryBackgroundHovered), $5d7a8dbdd30067e1$var$toRGBAString($5d7a8dbdd30067e1$var$_objectSpread($5d7a8dbdd30067e1$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.8
    }))), (0, $bVWjb.themedButtonPrimaryBackgroundPressed), $5d7a8dbdd30067e1$var$toRGBAString($5d7a8dbdd30067e1$var$_objectSpread($5d7a8dbdd30067e1$var$_objectSpread({}, highlightRgb), {}, {
        a: 0.65
    }))), (0, $bVWjb.themedButtonPrimaryText), highlightTextColor.hex));
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ var $5d7a8dbdd30067e1$var$selectedBackgroundRGBA = {
    light: (0, $jU7Gv.paletteRgba).Neutral300A,
    dark: (0, $jU7Gv.paletteRgba).DarkNeutral300A
};
function $5d7a8dbdd30067e1$var$getSelectedStyles(_ref4) {
    var backgroundColor = _ref4.backgroundColor, colorMode = _ref4.colorMode;
    /**
   * The background color of the selected button in its default state.
   *
   * We are referring to this as a foreground color because it is semi-transparent,
   * so is not the actual color displayed when the button is on top of a background color.
   */ var foregroundColor = $5d7a8dbdd30067e1$var$selectedBackgroundRGBA[colorMode];
    /**
   * The blended color seen when the selected background is over the top bar.
   */ var blendedBackground = (0, $jDJlP.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return (0, $hh01j.default)((0, $hh01j.default)({}, (0, $bVWjb.themedButtonSelectedText), (0, $jDJlP.getTextColor)(blendedBackground).hex), (0, $bVWjb.themedButtonSelectedBorder), (0, $jDJlP.isLight)(blendedBackground) ? (0, $jU7Gv.palette).Neutral1100 : (0, $jU7Gv.palette).DarkNeutral1100);
}

});
parcelRegister("2VaCp", function(module, exports) {
$parcel$export(module.exports, "themedLogoIcon", () => $22092447c0ba96b8$export$24328117f1132113);
$parcel$export(module.exports, "themedLogoText", () => $22092447c0ba96b8$export$91b0830f8f4ab279);
$parcel$export(module.exports, "NavLogo", () => $22092447c0ba96b8$export$b6394419753329e);
/* nav-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $3yCbE = parcelRequire("3yCbE");

var $3X3Vo = parcelRequire("3X3Vo");

var $2X3dI = parcelRequire("2X3dI");

var $6wyCz = parcelRequire("6wyCz");
var $22092447c0ba96b8$export$24328117f1132113 = '--ds-top-bar-logo-icon';
var $22092447c0ba96b8$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
var $22092447c0ba96b8$var$anchorStyles = {
    root: "_2rkoiti9 _1e0c1txw _4cvr1h6o _4t3izwfg",
    newBorderRadius: "_2rkoftgi",
    newMargin: "_ahbq1b66",
    newInteractionStates: "_irr3166n _1di61wwy",
    newInteractionStatesCustomTheming: "_irr31rps _1di6yhlj"
};
var $22092447c0ba96b8$var$sharedIconOrLogoContainerStyles = {
    root: "_1reo15vq _18m915vq _bna71tcg _rtys1kw7 _1jpx1f51",
    appIconTilePaddingFlagged: "_18zr1b66"
};
var $22092447c0ba96b8$var$iconContainerStyles = {
    root: "_18zr1b66 _1e0c1txw _p12f1tcg _vchh1ntv _10y4glyw"
};
var $22092447c0ba96b8$var$logoContainerStyles = {
    root: "_18zru2gc _1e0cglyw _p12fnklw _vchh1ntv _10y41txw"
};
var $22092447c0ba96b8$export$b6394419753329e = function NavLogo(_ref) {
    var href = _ref.href, logo = _ref.logo, icon = _ref.icon, onClick = _ref.onClick, label = _ref.label;
    var ref = (0, $4tluv.useRef)(null);
    (0, $4tluv.useEffect)(function() {
        var _img$parentElement, _img$parentElement2;
        var img, hasExpectedStructure, isOnlyChild;
        return;
    }, []);
    var hasCustomTheme = (0, $6wyCz.useHasCustomTheme)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $2X3dI.default), {
        ref: ref,
        "aria-label": label,
        href: href,
        xcss: (0, $3yCbE.cx)($22092447c0ba96b8$var$anchorStyles.root, (0, $3X3Vo.fg)('platform_design_system_nav_logo_interaction_states') && $22092447c0ba96b8$var$anchorStyles.newMargin, (0, $3X3Vo.fg)('platform_design_system_nav_logo_interaction_states') && $22092447c0ba96b8$var$anchorStyles.newBorderRadius, (0, $3X3Vo.fg)('platform_design_system_nav_logo_interaction_states') && (hasCustomTheme ? $22092447c0ba96b8$var$anchorStyles.newInteractionStatesCustomTheming : $22092447c0ba96b8$var$anchorStyles.newInteractionStates)),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("div", {
        className: (0, $jAkMr.default)([
            $22092447c0ba96b8$var$sharedIconOrLogoContainerStyles.root,
            $22092447c0ba96b8$var$iconContainerStyles.root,
            (0, $3X3Vo.fg)('platform-team25-app-icon-tiles') && $22092447c0ba96b8$var$sharedIconOrLogoContainerStyles.appIconTilePaddingFlagged
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($22092447c0ba96b8$var$NavLogoRenderer, {
        logoOrIcon: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("div", {
        className: (0, $jAkMr.default)([
            $22092447c0ba96b8$var$sharedIconOrLogoContainerStyles.root,
            $22092447c0ba96b8$var$logoContainerStyles.root,
            (0, $3X3Vo.fg)('platform-team25-app-icon-tiles') && $22092447c0ba96b8$var$sharedIconOrLogoContainerStyles.appIconTilePaddingFlagged
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($22092447c0ba96b8$var$NavLogoRenderer, {
        logoOrIcon: logo
    })));
};
function $22092447c0ba96b8$var$NavLogoRenderer(_ref2) {
    var logoOrIcon = _ref2.logoOrIcon;
    return (0, $3X3Vo.fg)('jiv-20710-fix-nav-rerender') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($22092447c0ba96b8$var$NavLogoRendererMemo, {
        logoOrIcon: logoOrIcon
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($22092447c0ba96b8$var$NavLogoRendererNoMemo, {
        logoOrIcon: logoOrIcon
    });
}
var $22092447c0ba96b8$var$NavLogoRendererMemo = /*#__PURE__*/ (0, $4tluv.memo)($22092447c0ba96b8$var$NavLogoRendererNoMemo);
function $22092447c0ba96b8$var$NavLogoRendererNoMemo(_ref3) {
    var LogoOrIcon = _ref3.logoOrIcon;
    var hasCustomTheme = (0, $6wyCz.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(LogoOrIcon, {
        size: "small",
        label: "",
        iconColor: "var(".concat($22092447c0ba96b8$export$24328117f1132113, ")"),
        textColor: "var(".concat($22092447c0ba96b8$export$91b0830f8f4ab279, ")")
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}

});

parcelRegister("bVWjb", function(module, exports) {
$parcel$export(module.exports, "themedButtonBackground", () => $8b023f6850540111$export$b93b81aa41a8061a);
$parcel$export(module.exports, "themedButtonBackgroundHovered", () => $8b023f6850540111$export$96a2312c81489aa1);
$parcel$export(module.exports, "themedButtonBackgroundPressed", () => $8b023f6850540111$export$9db7a918ddfed23e);
$parcel$export(module.exports, "themedButtonBorder", () => $8b023f6850540111$export$2b00bded80635cbb);
$parcel$export(module.exports, "themedButtonPrimaryText", () => $8b023f6850540111$export$eca746d7c1a9cd6e);
$parcel$export(module.exports, "themedButtonPrimaryBackground", () => $8b023f6850540111$export$2c2bc298cddb8aca);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundHovered", () => $8b023f6850540111$export$6b28e650669cd3c7);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundPressed", () => $8b023f6850540111$export$1656be06aad539b9);
$parcel$export(module.exports, "themedButtonSelectedText", () => $8b023f6850540111$export$c26a897d419ef487);
$parcel$export(module.exports, "themedButtonSelectedBackground", () => $8b023f6850540111$export$4e50e625ccffdb13);
$parcel$export(module.exports, "themedButtonSelectedBackgroundHovered", () => $8b023f6850540111$export$55c84c90f36bda4d);
$parcel$export(module.exports, "themedButtonSelectedBackgroundPressed", () => $8b023f6850540111$export$c5c0213472126c08);
$parcel$export(module.exports, "themedButtonSelectedBorder", () => $8b023f6850540111$export$22928007ff541429);
$parcel$export(module.exports, "themedButtonDisabledText", () => $8b023f6850540111$export$787ad93d0f2276af);
$parcel$export(module.exports, "themedButtonDisabledBackground", () => $8b023f6850540111$export$5e774f44b77335d6);
$parcel$export(module.exports, "ThemedButton", () => $8b023f6850540111$export$f67fb575035cc7d0);
$parcel$export(module.exports, "ThemedLinkButton", () => $8b023f6850540111$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedIconButton", () => $8b023f6850540111$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $8b023f6850540111$export$a1ab08e79d264ec8);
/* button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iXMid = parcelRequire("iXMid");

var $bRlc1 = parcelRequire("bRlc1");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $3yCbE = parcelRequire("3yCbE");

var $hHj16 = parcelRequire("hHj16");

var $eb3Wn = parcelRequire("eb3Wn");
var $dgwv0 = parcelRequire("dgwv0");

var $eCj8S = parcelRequire("eCj8S");

var $k7gbB = parcelRequire("k7gbB");

var $kFU9g = parcelRequire("kFU9g");
var $8b023f6850540111$var$_excluded = [
    "style",
    "xcss",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd"
], $8b023f6850540111$var$_excluded2 = [
    "appearance",
    "shape",
    "isSelected",
    "isDisabled"
], $8b023f6850540111$var$_excluded3 = [
    "appearance",
    "shape",
    "isSelected",
    "isDisabled"
], $8b023f6850540111$var$_excluded4 = [
    "iconBefore",
    "children"
], $8b023f6850540111$var$_excluded5 = [
    "iconBefore",
    "children"
], $8b023f6850540111$var$_excluded6 = [
    "icon",
    "label",
    "tooltip"
], $8b023f6850540111$var$_excluded7 = [
    "icon",
    "label",
    "tooltip"
];
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ /**
 * Returns the spread props to pass through to underlying primitive components.
 *
 * It removes the props which apply styles.
 */ function $8b023f6850540111$var$getPrimitiveSpreadProps(_ref) {
    var style = _ref.style, xcss = _ref.xcss, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, props = (0, $bRlc1.default)(_ref, $8b023f6850540111$var$_excluded);
    return props;
}
var $8b023f6850540111$export$b93b81aa41a8061a = '--ds-top-bar-button-background';
var $8b023f6850540111$export$96a2312c81489aa1 = '--ds-top-bar-button-background-hovered';
var $8b023f6850540111$export$9db7a918ddfed23e = '--ds-top-bar-button-background-pressed';
var $8b023f6850540111$export$2b00bded80635cbb = '--ds-top-bar-button-border';
var $8b023f6850540111$export$eca746d7c1a9cd6e = '--ds-top-bar-button-primary-text';
var $8b023f6850540111$export$2c2bc298cddb8aca = '--ds-top-bar-button-primary-background';
var $8b023f6850540111$export$6b28e650669cd3c7 = '--ds-top-bar-button-primary-background-hovered';
var $8b023f6850540111$export$1656be06aad539b9 = '--ds-top-bar-button-primary-background-pressed';
var $8b023f6850540111$export$c26a897d419ef487 = '--ds-top-bar-button-selected-text';
var $8b023f6850540111$export$4e50e625ccffdb13 = '--ds-top-bar-button-selected-background';
var $8b023f6850540111$export$55c84c90f36bda4d = '--ds-top-bar-button-selected-background-hovered';
var $8b023f6850540111$export$c5c0213472126c08 = '--ds-top-bar-button-selected-background-pressed';
var $8b023f6850540111$export$22928007ff541429 = '--ds-top-bar-button-selected-border';
var $8b023f6850540111$export$787ad93d0f2276af = '--ds-top-bar-button-disabled-text';
var $8b023f6850540111$export$5e774f44b77335d6 = '--ds-top-bar-button-disabled-background';
var $8b023f6850540111$var$styles = {
    root: "_zulp12x7 _11c82smr _2rkosqtm _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
var $8b023f6850540111$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
var $8b023f6850540111$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
};
/**
 * Props shared by `ThemedPressable` and `ThemedAnchor`
 */ /**
 * Intentionally an almost-duplicate of `ThemedAnchor` - make sure to update both.
 *
 * See `ThemedAnchor` for more context.
 */ var $8b023f6850540111$var$ThemedPressable = /*#__PURE__*/ (0, $4tluv.forwardRef)(function ThemedPressable(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? 'default' : _ref2$shape, isSelected = _ref2.isSelected, isDisabled = _ref2.isDisabled, props = (0, $bRlc1.default)(_ref2, $8b023f6850540111$var$_excluded2);
    var hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $dgwv0.default), (0, $iXMid.default)({}, $8b023f6850540111$var$getPrimitiveSpreadProps(props), {
        ref: ref,
        type: "button",
        xcss: (0, $3yCbE.cx)($8b023f6850540111$var$styles.root, $8b023f6850540111$var$shapeStyles[shape], hasBorder && $8b023f6850540111$var$styles.border, $8b023f6850540111$var$appearanceStyles[appearance], isSelected && $8b023f6850540111$var$styles.selected, isDisabled && $8b023f6850540111$var$styles.disabled),
        isDisabled: isDisabled
    }));
});
/**
 * Intentionally an almost-duplicate of `ThemedPressable` - make sure to update both.
 *
 * More 'clever' solutions were tried but I couldn't get them working in an acceptable state.
 *
 * Polymorphism had many typing issues and required sacrificing type safety.
 *
 * Render props had problems passing down styles through `xcss` to the `children` function.
 */ var $8b023f6850540111$var$ThemedAnchor = (0, $kFU9g.forwardRefWithGeneric)(function ThemedAnchor(_ref3, ref) {
    var _ref3$appearance = _ref3.appearance, appearance = _ref3$appearance === void 0 ? 'default' : _ref3$appearance, _ref3$shape = _ref3.shape, shape = _ref3$shape === void 0 ? 'default' : _ref3$shape, isSelected = _ref3.isSelected, isDisabled = _ref3.isDisabled, props = (0, $bRlc1.default)(_ref3, $8b023f6850540111$var$_excluded3);
    var hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eb3Wn.default), (0, $iXMid.default)({}, $8b023f6850540111$var$getPrimitiveSpreadProps(props), {
        ref: ref,
        xcss: (0, $3yCbE.cx)($8b023f6850540111$var$styles.root, $8b023f6850540111$var$shapeStyles[shape], hasBorder && $8b023f6850540111$var$styles.border, $8b023f6850540111$var$appearanceStyles[appearance], isSelected && $8b023f6850540111$var$styles.selected, isDisabled && $8b023f6850540111$var$styles.disabled)
    }));
});
var $8b023f6850540111$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
var $8b023f6850540111$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $4tluv.forwardRef)(function ThemedButton(_ref4, ref) {
    var IconBefore = _ref4.iconBefore, children = _ref4.children, props = (0, $bRlc1.default)(_ref4, $8b023f6850540111$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($8b023f6850540111$var$ThemedPressable, (0, $iXMid.default)({}, props, {
        ref: ref
    }), IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("span", {
        className: (0, $jAkMr.default)([
            $8b023f6850540111$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(IconBefore, {
        label: "",
        color: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("span", {
        className: (0, $jAkMr.default)([
            $8b023f6850540111$var$textButtonStyles.text
        ])
    }, children));
});
var $8b023f6850540111$export$b0b5aeed52623827 = (0, $kFU9g.forwardRefWithGeneric)(function ThemedLinkButton(_ref5, ref) {
    var IconBefore = _ref5.iconBefore, children = _ref5.children, props = (0, $bRlc1.default)(_ref5, $8b023f6850540111$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($8b023f6850540111$var$ThemedAnchor, (0, $iXMid.default)({}, props, {
        ref: ref
    }), IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("span", {
        className: (0, $jAkMr.default)([
            $8b023f6850540111$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(IconBefore, {
        label: "",
        color: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("span", {
        className: (0, $jAkMr.default)([
            $8b023f6850540111$var$textButtonStyles.text
        ])
    }, children));
});
var $8b023f6850540111$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $4tluv.forwardRef)(function ThemedIconButton(_ref6, ref) {
    var _tooltip$content;
    var Icon = _ref6.icon, label = _ref6.label, tooltip = _ref6.tooltip, props = (0, $bRlc1.default)(_ref6, $8b023f6850540111$var$_excluded6);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eCj8S.default), (0, $iXMid.default)({}, tooltip, {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label
    }), function(triggerProps) {
        return(/*#__PURE__*/ /**
       * The `aria-describedby` from `triggerProps` is intentionally not passed down,
       * because it would cause double announcements with the `VisuallyHidden` label.
       *
       * The `@atlaskit/button` IconButton uses the same approach.
       */ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($8b023f6850540111$var$ThemedPressable, (0, $iXMid.default)({}, props, {
            shape: "square",
            ref: (0, $hHj16.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: function onClick(event, analyticsEvent) {
                var _props$onClick, _triggerProps$onClick;
                (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event, analyticsEvent);
                triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _props$onMouseOver;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_props$onMouseOver = props.onMouseOver) === null || _props$onMouseOver === void 0 || _props$onMouseOver.call(props, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _props$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_props$onMouseOut = props.onMouseOut) === null || _props$onMouseOut === void 0 || _props$onMouseOut.call(props, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _props$onMouseMove;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_props$onMouseMove = props.onMouseMove) === null || _props$onMouseMove === void 0 || _props$onMouseMove.call(props, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _props$onMouseDown;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_props$onMouseDown = props.onMouseDown) === null || _props$onMouseDown === void 0 || _props$onMouseDown.call(props, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _props$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _props$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, e);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(Icon, {
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $k7gbB.default), null, label)));
    });
});
var $8b023f6850540111$export$a1ab08e79d264ec8 = (0, $kFU9g.forwardRefWithGeneric)(function ThemedLinkIconButton(_ref7, ref) {
    var _tooltip$content2;
    var Icon = _ref7.icon, label = _ref7.label, tooltip = _ref7.tooltip, props = (0, $bRlc1.default)(_ref7, $8b023f6850540111$var$_excluded7);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eCj8S.default), (0, $iXMid.default)({}, tooltip, {
        content: (_tooltip$content2 = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content2 !== void 0 ? _tooltip$content2 : label
    }), function(triggerProps) {
        return(/*#__PURE__*/ /**
       * The `aria-describedby` from `triggerProps` is intentionally not passed down,
       * because it would cause double announcements with the `VisuallyHidden` label.
       *
       * The `@atlaskit/button` IconButton uses the same approach.
       */ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement($8b023f6850540111$var$ThemedAnchor, (0, $iXMid.default)({}, props, {
            shape: "square",
            ref: (0, $hHj16.default)([
                ref,
                triggerProps.ref
            ]),
            onClick: function onClick(event, analyticsEvent) {
                var _props$onClick2, _triggerProps$onClick2;
                (_props$onClick2 = props.onClick) === null || _props$onClick2 === void 0 || _props$onClick2.call(props, event, analyticsEvent);
                triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick2 = triggerProps.onClick) === null || _triggerProps$onClick2 === void 0 || _triggerProps$onClick2.call(triggerProps, event);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse5, _props$onMouseOver2;
                (_triggerProps$onMouse5 = triggerProps.onMouseOver) === null || _triggerProps$onMouse5 === void 0 || _triggerProps$onMouse5.call(triggerProps, e);
                (_props$onMouseOver2 = props.onMouseOver) === null || _props$onMouseOver2 === void 0 || _props$onMouseOver2.call(props, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse6, _props$onMouseOut2;
                (_triggerProps$onMouse6 = triggerProps.onMouseOut) === null || _triggerProps$onMouse6 === void 0 || _triggerProps$onMouse6.call(triggerProps, e);
                (_props$onMouseOut2 = props.onMouseOut) === null || _props$onMouseOut2 === void 0 || _props$onMouseOut2.call(props, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse7, _props$onMouseMove2;
                (_triggerProps$onMouse7 = triggerProps.onMouseMove) === null || _triggerProps$onMouse7 === void 0 || _triggerProps$onMouse7.call(triggerProps, e);
                (_props$onMouseMove2 = props.onMouseMove) === null || _props$onMouseMove2 === void 0 || _props$onMouseMove2.call(props, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse8, _props$onMouseDown2;
                (_triggerProps$onMouse8 = triggerProps.onMouseDown) === null || _triggerProps$onMouse8 === void 0 || _triggerProps$onMouse8.call(triggerProps, e);
                (_props$onMouseDown2 = props.onMouseDown) === null || _props$onMouseDown2 === void 0 || _props$onMouseDown2.call(props, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus2, _props$onFocus2;
                (_triggerProps$onFocus2 = triggerProps.onFocus) === null || _triggerProps$onFocus2 === void 0 || _triggerProps$onFocus2.call(triggerProps, e);
                (_props$onFocus2 = props.onFocus) === null || _props$onFocus2 === void 0 || _props$onFocus2.call(props, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur2, _props$onBlur2;
                (_triggerProps$onBlur2 = triggerProps.onBlur) === null || _triggerProps$onBlur2 === void 0 || _triggerProps$onBlur2.call(triggerProps, e);
                (_props$onBlur2 = props.onBlur) === null || _props$onBlur2 === void 0 || _props$onBlur2.call(props, e);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(Icon, {
            label: "",
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $k7gbB.default), null, label)));
    });
});

});
parcelRegister("kFU9g", function(module, exports) {
$parcel$export(module.exports, "forwardRefWithGeneric", () => $f0d330e1c26610ef$export$8ab756e06c5d9001);

var $4tluv = parcelRequire("4tluv");
var $f0d330e1c26610ef$export$8ab756e06c5d9001 = (0, $4tluv.forwardRef);

});


parcelRegister("jDJlP", function(module, exports) {
$parcel$export(module.exports, "isLight", () => $e4c4d69d22dbdf01$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $e4c4d69d22dbdf01$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $e4c4d69d22dbdf01$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $e4c4d69d22dbdf01$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $e4c4d69d22dbdf01$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $e4c4d69d22dbdf01$var$relativeLuminanceW3C(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    /**
   * Normalized sRGB - each channel is between 0 and 1
   */ var normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
   * linear RGB - the gamma correction of sRGB is removed and
   * the channels correspond directly to subpixel intensity
   */ var linear = {
        r: $e4c4d69d22dbdf01$var$linearizeRGBChannel(normal.r),
        g: $e4c4d69d22dbdf01$var$linearizeRGBChannel(normal.g),
        b: $e4c4d69d22dbdf01$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    var L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ var $e4c4d69d22dbdf01$var$flipLuminance = 0.179129;
function $e4c4d69d22dbdf01$export$44af652f4cca9039(color) {
    return $e4c4d69d22dbdf01$var$relativeLuminanceW3C(color) >= $e4c4d69d22dbdf01$var$flipLuminance;
}
function $e4c4d69d22dbdf01$export$5573a5bab3e074b5(backgroundColor) {
    if ($e4c4d69d22dbdf01$var$relativeLuminanceW3C(backgroundColor) >= $e4c4d69d22dbdf01$var$flipLuminance) return 'light';
    return 'dark';
}
var $e4c4d69d22dbdf01$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $e4c4d69d22dbdf01$export$5357fe757c335c0d(backgroundColor) {
    var colorMode = $e4c4d69d22dbdf01$export$5573a5bab3e074b5(backgroundColor);
    return $e4c4d69d22dbdf01$var$textColor[colorMode];
}
function $e4c4d69d22dbdf01$export$e5e64c30bee1469b(_ref2) {
    var background = _ref2.background, foreground = _ref2.foreground;
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("3sakR", function(module, exports) {
$parcel$export(module.exports, "parseHex", () => $283c01028418e4d5$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
var $283c01028418e4d5$var$isValidHex = function isValidHex(hex) {
    return(// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex));
};
function $283c01028418e4d5$export$103711ef09c6edec(color) {
    if (!$283c01028418e4d5$var$isValidHex(color)) return null;
    var channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("jU7Gv", function(module, exports) {
$parcel$export(module.exports, "palette", () => $e7d9354245a270e1$export$eaad8caa32d2521d);
$parcel$export(module.exports, "paletteRgba", () => $e7d9354245a270e1$export$c9b84419dae66a82);
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ var $e7d9354245a270e1$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
var $e7d9354245a270e1$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});

parcelRegister("gGwyE", function(module, exports) {
$parcel$export(module.exports, "themedSearchBorder", () => $c259d2ebd41bac6a$export$ae6fbf5ba3a7a784);
$parcel$export(module.exports, "themedSearchBorderFocused", () => $c259d2ebd41bac6a$export$ee42b8430f4c19bd);

var $bVWjb = parcelRequire("bVWjb");

var $6wyCz = parcelRequire("6wyCz");
var $c259d2ebd41bac6a$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
var $c259d2ebd41bac6a$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ var $c259d2ebd41bac6a$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: "var(".concat($c259d2ebd41bac6a$export$ae6fbf5ba3a7a784, ")")
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #172B4D)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: "var(".concat($c259d2ebd41bac6a$export$ee42b8430f4c19bd, ")"),
        boxShadow: "inset 0px 0px 0px 1px var(".concat($c259d2ebd41bac6a$export$ee42b8430f4c19bd, ")")
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: "var(".concat((0, $bVWjb.themedButtonBackgroundHovered), ")")
    }
};
function $c259d2ebd41bac6a$export$18a29b1ed2212823() {
    var hasCustomTheme = (0, $6wyCz.useHasCustomTheme)();
    if (hasCustomTheme) return $c259d2ebd41bac6a$var$legacySearchTheme;
    return undefined;
}

});



parcelRegister("a4rov", function(module, exports) {
$parcel$export(module.exports, "bannerMountedVar", () => $754f8706c9815e17$export$515a0b1baafe906c);
$parcel$export(module.exports, "topNavMountedVar", () => $754f8706c9815e17$export$60ef3a7b1ed42328);
$parcel$export(module.exports, "UNSAFE_topNavVar", () => $754f8706c9815e17$export$855f5a09f5c99ac);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $754f8706c9815e17$export$26354f9814213292);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
var $754f8706c9815e17$export$951bf5156e86d974 = '--n_sNvw';
var $754f8706c9815e17$export$594e6a30db7c057e = '--n_asDw';
var $754f8706c9815e17$export$db0c2e1d744fb281 = '--n_pnlW';
var $754f8706c9815e17$export$515a0b1baafe906c = '--n_bnrM';
var $754f8706c9815e17$export$60ef3a7b1ed42328 = '--n_tNvM';
var $754f8706c9815e17$export$1216dacffd1e9e65 = '--n_sNvlw';
var $754f8706c9815e17$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
var $754f8706c9815e17$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
var $754f8706c9815e17$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
var $754f8706c9815e17$export$2874e68531ce3163 = "calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))";
var $754f8706c9815e17$export$bfabd8c2c572ad29 = "calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))";
var $754f8706c9815e17$export$855f5a09f5c99ac = '--topNavigationHeight';
var $754f8706c9815e17$export$26354f9814213292 = '--bannerHeight';
var $754f8706c9815e17$export$6bfc931a04ec5741 = '--leftSidebarWidth';
var $754f8706c9815e17$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
var $754f8706c9815e17$export$753bf7651b25db91 = '--rightPanelWidth';
var $754f8706c9815e17$export$6460bd6a2446260 = "calc(var(".concat($754f8706c9815e17$export$26354f9814213292, ", 0px) + var(").concat($754f8706c9815e17$export$855f5a09f5c99ac, ", 0px))");
var $754f8706c9815e17$export$3055529fab2b4edf = "var(".concat($754f8706c9815e17$export$6bfc931a04ec5741, ", 0px)");
var $754f8706c9815e17$export$166d8fd766c3eb92 = "calc(var(".concat($754f8706c9815e17$export$bbbace2ff0c7ae1b, ", 0px) + var(").concat($754f8706c9815e17$export$753bf7651b25db91, ", 0px))");
var $754f8706c9815e17$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    sideNav: 2,
    panelSmallViewports: 1
};

});

parcelRegister("er86a", function(module, exports) {
$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $a829de80edea0b46$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $a829de80edea0b46$export$9f45a1325e3cdfb8);

var $4tluv = parcelRequire("4tluv");

var $f9HkP = parcelRequire("f9HkP");
var $a829de80edea0b46$export$cfa3cd08d675e56e = function HoistCssVarToLocalGrid(_ref) {
    var variableName = _ref.variableName, value = _ref.value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("style", null, "#".concat((0, $f9HkP.gridRootId), " { ").concat(variableName, ": ").concat(value, "px }"));
};
var $a829de80edea0b46$var$getCssStringValue = function getCssStringValue(value) {
    return typeof value === 'number' ? "".concat(value, "px") : value;
};
var $a829de80edea0b46$export$9f45a1325e3cdfb8 = function DangerouslyHoistCssVarToDocumentRoot(_ref2) {
    var variableName = _ref2.variableName, value = _ref2.value, mediaQuery = _ref2.mediaQuery, responsiveValue = _ref2.responsiveValue;
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ var style = ":root { ".concat(variableName, ": ").concat($a829de80edea0b46$var$getCssStringValue(value), " }");
    if (mediaQuery && responsiveValue) style += " ".concat(mediaQuery, " { :root { ").concat(variableName, ": ").concat($a829de80edea0b46$var$getCssStringValue(responsiveValue), " } }");
    return(/*#__PURE__*/ // Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("style", null, style));
};

});


parcelRegister("4JbNr", function(module, exports) {
$parcel$export(module.exports, "TopNavEnd", () => $371483f0c680dfda$export$8b7a38b70a3c9839);
/* top-nav-end.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iXMid = parcelRequire("iXMid");

var $9DNBn = parcelRequire("9DNBn");

var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $3yCbE = parcelRequire("3yCbE");

var $1K815 = parcelRequire("1K815");

var $dIQe5 = parcelRequire("dIQe5");

var $3X3Vo = parcelRequire("3X3Vo");

var $cJTli = parcelRequire("cJTli");

var $gu8yK = parcelRequire("gu8yK");

var $dFrcv = parcelRequire("dFrcv");

var $6wyCz = parcelRequire("6wyCz");

var $eYnGi = parcelRequire("eYnGi");
var $371483f0c680dfda$var$containerStyles = {
    root: "_yyhy11wp _1e0c1txw _1bahh9n0 _1ul9zwfg",
    newLayoutStyles: "_1d2y1ris",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi _ndwch9n0"
};
var $371483f0c680dfda$var$listStyles = {
    root: "_zulp1b66 _4cvr1h6o _1e0c1txw",
    hideOnSmallViewport: "_1e0cglyw _181n1txw",
    popupContainer: "_1yt4u2gc"
};
function $371483f0c680dfda$export$8b7a38b70a3c9839(_ref) {
    var children = _ref.children, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Actions' : _ref$label, _ref$showMoreButtonLa = _ref.showMoreButtonLabel, showMoreButtonLabel = _ref$showMoreButtonLa === void 0 ? 'Show more' : _ref$showMoreButtonLa;
    var _useState = (0, $4tluv.useState)(false), _useState2 = (0, $9DNBn.default)(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    // Always setting to `false` for the initial render (will flip in an effect for mobile)
    var _useState3 = (0, $4tluv.useState)(false), _useState4 = (0, $9DNBn.default)(_useState3, 2), isMobile = _useState4[0], setIsMobile = _useState4[1];
    // Note: `query` is a stable value between renders
    var query = (0, $gu8yK.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches);
        // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $1K815.useLayoutEffect)(function() {
        var _query$matches;
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile((_query$matches = query === null || query === void 0 ? void 0 : query.matches) !== null && _query$matches !== void 0 ? _query$matches : false);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("nav", {
        "aria-label": label,
        className: (0, $jAkMr.default)([
            $371483f0c680dfda$var$containerStyles.root,
            (0, $3X3Vo.fg)('platform_design_system_nav4_top_nav_columns') && $371483f0c680dfda$var$containerStyles.newLayoutStyles,
            (0, $3X3Vo.fg)('platform_design_system_nav4_top_nav_min_widths') && $371483f0c680dfda$var$containerStyles.contentMinWidthStyles
        ])
    }, isMobile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $cJTli.default), {
        isOpen: isOpen,
        onClose: function onClose() {
            return setIsOpen(false);
        },
        placement: "bottom-start",
        shouldRenderToParent: true,
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $6wyCz.HasCustomThemeContext).Provider, {
                value: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $dFrcv.List), {
                xcss: (0, $3yCbE.cx)($371483f0c680dfda$var$listStyles.root, $371483f0c680dfda$var$listStyles.popupContainer)
            }, children));
        },
        trigger: function trigger(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $eYnGi.IconButton), (0, $iXMid.default)({}, triggerProps, {
                label: showMoreButtonLabel,
                isSelected: isOpen,
                onClick: function onClick() {
                    return setIsOpen(!isOpen);
                },
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($dIQe5))),
                isTooltipDisabled: false
            }));
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement((0, $dFrcv.List), {
        xcss: (0, $3yCbE.cx)($371483f0c680dfda$var$listStyles.root, $371483f0c680dfda$var$listStyles.hideOnSmallViewport)
    }, children));
}

});
parcelRegister("dFrcv", function(module, exports) {
$parcel$export(module.exports, "List", () => $9f34342cf77bde35$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4tluv = parcelRequire("4tluv");

function $9f34342cf77bde35$var$_List(_ref, forwardedRef) {
    var children = _ref.children, testId = _ref.testId, xcss = _ref.xcss;
    return(/*#__PURE__*/ /**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ $4tluv.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId
    }, children));
}
var $9f34342cf77bde35$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $4tluv.forwardRef)($9f34342cf77bde35$var$_List);

});

parcelRegister("eYnGi", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $ae6909dee59204f2$export$c25acd513dcc8062);

var $iXMid = parcelRequire("iXMid");

var $4tluv = parcelRequire("4tluv");

var $ku0Cg = parcelRequire("ku0Cg");
var $3lyVW = parcelRequire("3lyVW");
var $iS5Jc = parcelRequire("iS5Jc");
var $edM9z = parcelRequire("edM9z");

var $bVWjb = parcelRequire("bVWjb");

var $6wyCz = parcelRequire("6wyCz");
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $ae6909dee59204f2$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $4tluv.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $6wyCz.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $bVWjb.ThemedIconButton) : (0, $3lyVW.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(Component, (0, $iXMid.default)({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $ae6909dee59204f2$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $4tluv.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $6wyCz.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $bVWjb.ThemedLinkIconButton) : (0, $edM9z.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(Component, (0, $iXMid.default)({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $ae6909dee59204f2$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $4tluv.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $6wyCz.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $bVWjb.ThemedButton) : (0, $ku0Cg.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(Component, (0, $iXMid.default)({
        ref: ref
    }, props));
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
var $ae6909dee59204f2$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $4tluv.forwardRef)(function(props, ref) {
    var hasCustomTheme = (0, $6wyCz.useHasCustomTheme)();
    var Component = hasCustomTheme ? (0, $bVWjb.ThemedLinkButton) : (0, $iS5Jc.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement(Component, (0, $iXMid.default)({
        ref: ref
    }, props));
});

});


parcelRegister("cfh8W", function(module, exports) {
$parcel$export(module.exports, "TopNavStart", () => $8ea42f0e803b605c$export$4c15269b98c5129);
/* top-nav-start.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $jAkMr = parcelRequire("jAkMr");

var $4tluv = parcelRequire("4tluv");

var $3X3Vo = parcelRequire("3X3Vo");

var $962Xd = parcelRequire("962Xd");
var $8ea42f0e803b605c$var$styles = {
    root: "_zulp1b66 _yyhykb7n _4t3i1osq _4cvr1h6o _1e0c1txw",
    logoPaddingStyles: "_pwyo12x7",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi"
};
function $8ea42f0e803b605c$export$4c15269b98c5129(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var ref = (0, $4tluv.useContext)((0, $962Xd.TopNavStartAttachRef));
    var elementRef = (0, $4tluv.useRef)(null);
    (0, $4tluv.useEffect)(function() {
        if ((0, $3X3Vo.fg)('platform_fix_component_state_update_for_suspense')) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4tluv))).createElement("div", {
        ref: (0, $3X3Vo.fg)('platform_fix_component_state_update_for_suspense') ? elementRef : ref,
        "data-testid": testId,
        className: (0, $jAkMr.default)([
            $8ea42f0e803b605c$var$styles.root,
            (0, $3X3Vo.fg)('platform_design_system_nav4_top_nav_min_widths') ? $8ea42f0e803b605c$var$styles.contentMinWidthStyles : // Removing the extra logo padding when applying the content min width
            $8ea42f0e803b605c$var$styles.logoPaddingStyles
        ])
    }, children);
}

});

parcelRegister("2kUCE", function(module, exports) {
$parcel$export(module.exports, "useMutation", () => $1b395f14152344fc$export$609860bf8b0084c);

var $4tluv = parcelRequire("4tluv");

var $7dqky = parcelRequire("7dqky");
var $cnq4V = parcelRequire("cnq4V");

var $4cZqh = parcelRequire("4cZqh");

var $M8kp4 = parcelRequire("M8kp4");
"use client";
function $1b395f14152344fc$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $4cZqh.useQueryClient)(queryClient);
    const [observer] = $4tluv.useState(()=>new (0, $7dqky.MutationObserver)(client, options));
    $4tluv.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $4tluv.useSyncExternalStore($4tluv.useCallback((onStoreChange)=>observer.subscribe((0, $cnq4V.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $4tluv.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $M8kp4.noop));
    }, [
        observer
    ]);
    if (result.error && (0, $M8kp4.shouldThrowError)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}

});
parcelRegister("7dqky", function(module, exports) {
$parcel$export(module.exports, "MutationObserver", () => $540e2bfdf286d3f2$export$d3c1860ee66f291a);
// src/mutationObserver.ts

var $h0PTG = parcelRequire("h0PTG");

var $cnq4V = parcelRequire("cnq4V");

var $6MLVK = parcelRequire("6MLVK");

var $1j5lT = parcelRequire("1j5lT");
var $540e2bfdf286d3f2$export$d3c1860ee66f291a = class extends (0, $6MLVK.Subscribable) {
    #client;
    #currentResult = void 0;
    #currentMutation;
    #mutateOptions;
    constructor(client, options){
        super();
        this.#client = client;
        this.setOptions(options);
        this.bindMethods();
        this.#updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        this.options = this.#client.defaultMutationOptions(options);
        if (!(0, $1j5lT.shallowEqualObjects)(this.options, prevOptions)) this.#client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.#currentMutation,
            observer: this
        });
        if (prevOptions?.mutationKey && this.options.mutationKey && (0, $1j5lT.hashKey)(prevOptions.mutationKey) !== (0, $1j5lT.hashKey)(this.options.mutationKey)) this.reset();
        else if (this.#currentMutation?.state.status === "pending") this.#currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.#currentMutation?.removeObserver(this);
    }
    onMutationUpdate(action) {
        this.#updateResult();
        this.#notify(action);
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    reset() {
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = void 0;
        this.#updateResult();
        this.#notify();
    }
    mutate(variables, options) {
        this.#mutateOptions = options;
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
        this.#currentMutation.addObserver(this);
        return this.#currentMutation.execute(variables);
    }
    #updateResult() {
        const state = this.#currentMutation?.state ?? (0, $h0PTG.getDefaultState)();
        this.#currentResult = {
            ...state,
            isPending: state.status === "pending",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
    }
    #notify(action) {
        (0, $cnq4V.notifyManager).batch(()=>{
            if (this.#mutateOptions && this.hasListeners()) {
                const variables = this.#currentResult.variables;
                const context = this.#currentResult.context;
                if (action?.type === "success") {
                    this.#mutateOptions.onSuccess?.(action.data, variables, context);
                    this.#mutateOptions.onSettled?.(action.data, null, variables, context);
                } else if (action?.type === "error") {
                    this.#mutateOptions.onError?.(action.error, variables, context);
                    this.#mutateOptions.onSettled?.(void 0, action.error, variables, context);
                }
            }
            this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
        });
    }
};

});
parcelRegister("h0PTG", function(module, exports) {
$parcel$export(module.exports, "Mutation", () => $c62ab176c17f81d0$export$17b8b19c814bcf56);
$parcel$export(module.exports, "getDefaultState", () => $c62ab176c17f81d0$export$a1659b54bac3252a);
// src/mutation.ts

var $cnq4V = parcelRequire("cnq4V");

var $7EMy9 = parcelRequire("7EMy9");

var $a0qqk = parcelRequire("a0qqk");
var $c62ab176c17f81d0$export$17b8b19c814bcf56 = class extends (0, $7EMy9.Removable) {
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $c62ab176c17f81d0$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        this.#retryer = (0, $a0qqk.createRetryer)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (!restored) {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await this.#mutationCache.config.onMutate?.(variables, this);
                const context = await this.options.onMutate?.(variables);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this);
            await this.options.onSuccess?.(data, variables, this.state.context);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this);
            await this.options.onSettled?.(data, null, variables, this.state.context);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this);
                await this.options.onError?.(error, variables, this.state.context);
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this);
                await this.options.onSettled?.(void 0, error, variables, this.state.context);
                throw error;
            } finally{
                this.#dispatch({
                    type: "error",
                    error: error
                });
            }
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $cnq4V.notifyManager).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $c62ab176c17f81d0$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}

});



parcelRegister("ekfIA", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", () => $28cae2bfc28af86d$export$8489e2f039bfcc4c);

var $jJica = parcelRequire("jJica");
class $28cae2bfc28af86d$export$8489e2f039bfcc4c {
    static async fetch(options) {
        const fetch = options.fetch ?? globalThis.fetch;
        const response = await fetch(`${options.ffsBaseUrl}/api/v2/configurations`, {
            method: 'POST',
            body: JSON.stringify(options.context),
            headers: {
                'content-type': 'application/json',
                'x-api-key': options.ffsApiKey
            }
        });
        if (!response.ok) throw new Error(`Unexpected response ${response.status}: ${await response.text()}`);
        const valuesPayload = await response.text();
        return (0, $jJica.ConfigCollection).fromValues(valuesPayload);
    }
}

});
parcelRegister("jJica", function(module, exports) {
$parcel$export(module.exports, "ConfigCollection", () => $f230f5b245c843a8$export$2be5653e4dada0a3);

var $dFVTG = parcelRequire("dFVTG");
class $f230f5b245c843a8$export$f9c837a54db411d extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
function $f230f5b245c843a8$var$safeParse(json) {
    try {
        return {
            data: (0, $dFVTG.AnyConfigSchema).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $f230f5b245c843a8$export$f9c837a54db411d('An unknown error occurred during parsing', error)
        };
    }
}
class $f230f5b245c843a8$export$2be5653e4dada0a3 {
    static fromValues(values, options) {
        const result = $f230f5b245c843a8$var$safeParse(values);
        if (!result.success) {
            const parseError = new $f230f5b245c843a8$export$f9c837a54db411d('Failed to deserialize config', result.error);
            if (options?.throw) throw parseError;
            // eslint-disable-next-line no-console
            console.error(parseError);
            return $f230f5b245c843a8$export$2be5653e4dada0a3.empty();
        }
        return this.fromData(result.data);
    }
    static fromData(data) {
        return new $f230f5b245c843a8$export$2be5653e4dada0a3(Array.isArray(data) ? (0, $dFVTG.minimalToMap)(data) : (0, $dFVTG.standardToMap)(data));
    }
    static empty() {
        return new $f230f5b245c843a8$export$2be5653e4dada0a3(new Map());
    }
    toJson(format) {
        switch(format){
            case 'standard':
                return JSON.stringify((0, $dFVTG.mapToStandard)(this.config));
            case 'minimal':
                return JSON.stringify((0, $dFVTG.mapToMinimal)(this.config));
        }
    }
    constructor(config){
        this.config = config;
    }
    getBoolean(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $dFVTG.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'boolean') return {
            error: (0, $dFVTG.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getString(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $dFVTG.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'string') return {
            error: (0, $dFVTG.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumber(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $dFVTG.ConfigError).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'number') return {
            error: (0, $dFVTG.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getStringList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $dFVTG.ConfigError).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'string')) return {
            error: (0, $dFVTG.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumberList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $dFVTG.ConfigError).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'number')) return {
            error: (0, $dFVTG.ConfigError).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
}

});
parcelRegister("dFVTG", function(module, exports) {
$parcel$export(module.exports, "ConfigError", () => $86b2c7058cefd732$export$c5fb415882705cf4);
$parcel$export(module.exports, "AnyConfigSchema", () => $86b2c7058cefd732$export$960d45de79bd7d81);
$parcel$export(module.exports, "minimalToMap", () => $86b2c7058cefd732$export$c29ba52779f58587);
$parcel$export(module.exports, "standardToMap", () => $86b2c7058cefd732$export$be5b69ecb011d7cc);
$parcel$export(module.exports, "mapToMinimal", () => $86b2c7058cefd732$export$460f06addafd9f86);
$parcel$export(module.exports, "mapToStandard", () => $86b2c7058cefd732$export$9d0101ad8235e092);

var $jk22y = parcelRequire("jk22y");
const $86b2c7058cefd732$export$c5fb415882705cf4 = {
    NotFound: 'not_found',
    InvalidState: 'state_invalid',
    IncorrectType: 'incorrect_type'
};
const $86b2c7058cefd732$export$e94ee64b2671e155 = (0, $jk22y.z).record((0, $jk22y.z).string(), (0, $jk22y.z).object({
    value: (0, $jk22y.z).union([
        (0, $jk22y.z).boolean(),
        (0, $jk22y.z).string(),
        (0, $jk22y.z).number(),
        (0, $jk22y.z).string().array(),
        (0, $jk22y.z).number().array()
    ])
}));
const $86b2c7058cefd732$export$e38f7b10db0e126a = (0, $jk22y.z).tuple([
    // list of boolean configs which are on
    (0, $jk22y.z).string().array(),
    // list of string config tuples
    (0, $jk22y.z).array((0, $jk22y.z).string()).refine((arr)=>arr.length % 2 === 0),
    // list of number config tuples
    (0, $jk22y.z).array((0, $jk22y.z).union([
        (0, $jk22y.z).string(),
        (0, $jk22y.z).number()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== 'string') return false;
            if (typeof arr[i + 1] !== 'number') return false;
        }
        return true;
    }),
    // list of string list config tuples
    (0, $jk22y.z).array((0, $jk22y.z).union([
        (0, $jk22y.z).string(),
        (0, $jk22y.z).string().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'string')) return false;
        }
        return true;
    }),
    // list of number list config tuples
    (0, $jk22y.z).array((0, $jk22y.z).union([
        (0, $jk22y.z).string(),
        (0, $jk22y.z).number().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'number')) return false;
        }
        return true;
    })
]);
const $86b2c7058cefd732$export$960d45de79bd7d81 = (0, $jk22y.z).union([
    $86b2c7058cefd732$export$e94ee64b2671e155,
    $86b2c7058cefd732$export$e38f7b10db0e126a
]);
const $86b2c7058cefd732$export$ac2e9c88ba5d7cbb = (0, $jk22y.z).map((0, $jk22y.z).string(), (0, $jk22y.z).object({
    value: (0, $jk22y.z).union([
        (0, $jk22y.z).boolean(),
        (0, $jk22y.z).string(),
        (0, $jk22y.z).number(),
        (0, $jk22y.z).string().array(),
        (0, $jk22y.z).number().array()
    ])
}));
function $86b2c7058cefd732$var$pairs(arr, fn) {
    for(let i = 0; i < arr.length; i += 2){
        const key = arr[i];
        const val = arr[i + 1];
        if (typeof key !== 'string') throw new Error(`Expected a string while iterating pairs, got: ${arr[i]}`);
        fn(key, val);
    }
}
function $86b2c7058cefd732$export$c29ba52779f58587(minimal) {
    const map = new Map();
    minimal[0].forEach((boolean)=>map.set(boolean, {
            value: true
        }));
    $86b2c7058cefd732$var$pairs(minimal[1], (a, b)=>map.set(a, {
            value: b
        }));
    $86b2c7058cefd732$var$pairs(minimal[2], (a, b)=>map.set(a, {
            value: b
        }));
    $86b2c7058cefd732$var$pairs(minimal[3], (a, b)=>map.set(a, {
            value: b
        }));
    $86b2c7058cefd732$var$pairs(minimal[4], (a, b)=>map.set(a, {
            value: b
        }));
    return map;
}
function $86b2c7058cefd732$export$be5b69ecb011d7cc(standard) {
    const map = new Map();
    Object.entries(standard).forEach(([key, value])=>map.set(key, value));
    return map;
}
function $86b2c7058cefd732$export$460f06addafd9f86(map) {
    const minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    for (const [key, { value: value }] of map.entries())switch(typeof value){
        case 'boolean':
            if (value) minimal[0].push(key);
            break;
        case 'string':
            minimal[1].push(key, value);
            break;
        case 'number':
            minimal[2].push(key, value);
            break;
        default:
            if (!Array.isArray(value)) throw new Error(`Unexpected configuration value: ${value}`);
            const allStrings = value.every((x)=>typeof x === 'string');
            if (allStrings) {
                minimal[3].push(key, value);
                break;
            }
            const allNumbers = value.every((x)=>typeof x === 'number');
            if (allNumbers) {
                minimal[4].push(key, value);
                break;
            }
            throw new Error(`Unexpected configuration value: ${value}`);
    }
    return minimal;
}
function $86b2c7058cefd732$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}

});



parcelRegister("7PVsI", function(module, exports) {
"use strict";
var $5b49de9caedf90bf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5b49de9caedf90bf$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5b49de9caedf90bf$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5b49de9caedf90bf$var$__exportStar((parcelRequire("kD9nT")), module.exports);

$5b49de9caedf90bf$var$__exportStar((parcelRequire("9L77J")), module.exports);

$5b49de9caedf90bf$var$__exportStar((parcelRequire("1GGdr")), module.exports);

$5b49de9caedf90bf$var$__exportStar((parcelRequire("92kPv")), module.exports);

$5b49de9caedf90bf$var$__exportStar((parcelRequire("ajj2D")), module.exports);

});
parcelRegister("kD9nT", function(module, exports) {
"use strict";
var $f04ebab18e310fa8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useExperimentValue = module.exports.useFeatureGate = void 0;

var $4tluv = parcelRequire("4tluv");

const $f04ebab18e310fa8$var$feature_gate_js_client_1 = $f04ebab18e310fa8$var$__importDefault((parcelRequire("6Z4pn")));
const $f04ebab18e310fa8$var$useFeatureGate = (gateName, options = {})=>{
    const [gate, setGate] = (0, $4tluv.useState)(()=>$f04ebab18e310fa8$var$feature_gate_js_client_1.default.checkGate(gateName, options));
    (0, $4tluv.useEffect)(()=>{
        const onGateChange = (newValue)=>setGate(newValue);
        return $f04ebab18e310fa8$var$feature_gate_js_client_1.default.onGateUpdated(gateName, onGateChange, options);
    }, [
        gateName,
        options
    ]);
    return gate;
};
module.exports.useFeatureGate = $f04ebab18e310fa8$var$useFeatureGate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $f04ebab18e310fa8$var$useExperimentValue = (experimentName, parameterName, defaultValue, options = {})=>{
    const [experimentValue, setExperimentValue] = (0, $4tluv.useState)(()=>$f04ebab18e310fa8$var$feature_gate_js_client_1.default.getExperimentValue(experimentName, parameterName, defaultValue, options));
    (0, $4tluv.useEffect)(()=>{
        const onExperimentValueChange = (newValue)=>setExperimentValue(newValue);
        return $f04ebab18e310fa8$var$feature_gate_js_client_1.default.onExperimentValueUpdated(experimentName, parameterName, defaultValue, onExperimentValueChange, options);
    }, [
        experimentName,
        parameterName,
        defaultValue,
        options
    ]);
    return experimentValue;
};
module.exports.useExperimentValue = $f04ebab18e310fa8$var$useExperimentValue;

});
parcelRegister("6Z4pn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("lVHOI")).default);
$parcel$export(module.exports, "FeatureGateEnvironment", () => (parcelRequire("42xfx")).FeatureGateEnvironment);
$parcel$export(module.exports, "PerimeterType", () => (parcelRequire("42xfx")).PerimeterType);
$parcel$export(module.exports, "CLIENT_VERSION", () => (parcelRequire("BbIhg")).CLIENT_VERSION);
$parcel$export(module.exports, "DynamicConfig", () => (parcelRequire("fSvdU")).DynamicConfig);
$parcel$export(module.exports, "Layer", () => (parcelRequire("7wf33")).Layer);
$parcel$export(module.exports, "EvaluationReason", () => (parcelRequire("eVuiw")).EvaluationReason);
parcelRequire("lVHOI");
var $BbIhg = parcelRequire("BbIhg");
var $lVHOI = parcelRequire("lVHOI");
var $42xfx = parcelRequire("42xfx");

var $fSvdU = parcelRequire("fSvdU");

var $7wf33 = parcelRequire("7wf33");

var $eVuiw = parcelRequire("eVuiw");

});


parcelRegister("9L77J", function(module, exports) {
"use strict";
var $71ae07794790b978$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $4tluv = parcelRequire("4tluv");

const $71ae07794790b978$var$feature_gate_js_client_1 = $71ae07794790b978$var$__importDefault((parcelRequire("6Z4pn")));

var $fDj08 = parcelRequire("fDj08");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $71ae07794790b978$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $4tluv.useState)(!overrides && (0, $fDj08.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $4tluv.useRef)(options);
    (0, $4tluv.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (enabled) {
            if ((0, $fDj08.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $fDj08.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $71ae07794790b978$var$feature_gate_js_client_1.default.initializeCalled() ? $71ae07794790b978$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $71ae07794790b978$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $fDj08.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $fDj08.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $fDj08.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $fDj08.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $71ae07794790b978$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("fDj08", function(module, exports) {
"use strict";
var $b6193cc44a67ecdb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClientAlreadyInCorrectState = $b6193cc44a67ecdb$var$isClientAlreadyInCorrectState;
module.exports.pickChildToRender = $b6193cc44a67ecdb$var$pickChildToRender;
module.exports.toError = $b6193cc44a67ecdb$var$toError;
module.exports.applyOverrides = $b6193cc44a67ecdb$var$applyOverrides;
module.exports.clearOverrides = $b6193cc44a67ecdb$var$clearOverrides;

const $b6193cc44a67ecdb$var$react_1 = $b6193cc44a67ecdb$var$__importDefault((parcelRequire("4tluv")));

const $b6193cc44a67ecdb$var$feature_gate_js_client_1 = $b6193cc44a67ecdb$var$__importDefault((parcelRequire("6Z4pn")));
let $b6193cc44a67ecdb$var$hasWarnedAboutMissingOverrideSupport = false;
function $b6193cc44a67ecdb$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $b6193cc44a67ecdb$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($b6193cc44a67ecdb$var$feature_gate_js_client_1.default)) && ((_b = $b6193cc44a67ecdb$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($b6193cc44a67ecdb$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
function $b6193cc44a67ecdb$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $b6193cc44a67ecdb$var$react_1.default.createElement($b6193cc44a67ecdb$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $b6193cc44a67ecdb$var$react_1.default.createElement($b6193cc44a67ecdb$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
function $b6193cc44a67ecdb$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
function $b6193cc44a67ecdb$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$b6193cc44a67ecdb$var$feature_gate_js_client_1.default.overrideGate || !$b6193cc44a67ecdb$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$b6193cc44a67ecdb$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn('Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+');
            $b6193cc44a67ecdb$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $b6193cc44a67ecdb$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($b6193cc44a67ecdb$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $b6193cc44a67ecdb$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($b6193cc44a67ecdb$var$feature_gate_js_client_1.default, configName, values);
    });
}
function $b6193cc44a67ecdb$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $b6193cc44a67ecdb$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($b6193cc44a67ecdb$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $b6193cc44a67ecdb$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($b6193cc44a67ecdb$var$feature_gate_js_client_1.default, configName);
    });
}

});


parcelRegister("1GGdr", function(module, exports) {
"use strict";
var $13aa75dcaee8ff70$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithProvider = void 0;

var $4tluv = parcelRequire("4tluv");

const $13aa75dcaee8ff70$var$feature_gate_js_client_1 = $13aa75dcaee8ff70$var$__importDefault((parcelRequire("6Z4pn")));

var $fDj08 = parcelRequire("fDj08");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $13aa75dcaee8ff70$var$FeatureGatesInitializationWithProvider = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady, provider: provider })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $4tluv.useState)(!overrides && (0, $fDj08.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options and provider, so that we can use them within the following useEffect
    // without adding options and provider as dependencies.
    // This avoids the user updating every time an option or provider is attempted to be changed.
    const optionsRef = (0, $4tluv.useRef)(options);
    const providerRef = (0, $4tluv.useRef)(provider);
    (0, $4tluv.useEffect)(()=>{
        optionsRef.current = options;
        providerRef.current = provider;
    }, [
        options,
        provider
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (enabled) {
            if ((0, $fDj08.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $fDj08.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $13aa75dcaee8ff70$var$feature_gate_js_client_1.default.initializeCalled() ? $13aa75dcaee8ff70$var$feature_gate_js_client_1.default.updateUserWithProvider(identifiers, customAttributes) : $13aa75dcaee8ff70$var$feature_gate_js_client_1.default.initializeWithProvider(options, provider, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $fDj08.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $fDj08.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $fDj08.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $fDj08.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitializationWithProvider = $13aa75dcaee8ff70$var$FeatureGatesInitializationWithProvider;
module.exports.default = module.exports.FeatureGatesInitializationWithProvider;

});

parcelRegister("92kPv", function(module, exports) {
"use strict";
var $69447551ddb5d964$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $4tluv = parcelRequire("4tluv");

const $69447551ddb5d964$var$feature_gate_js_client_1 = $69447551ddb5d964$var$__importDefault((parcelRequire("6Z4pn")));

var $fDj08 = parcelRequire("fDj08");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $69447551ddb5d964$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $4tluv.useState)(!overrides && (0, $fDj08.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $4tluv.useRef)(options);
    (0, $4tluv.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (enabled) {
            if ((0, $fDj08.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $fDj08.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $69447551ddb5d964$var$feature_gate_js_client_1.default.initializeCalled() ? $69447551ddb5d964$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $69447551ddb5d964$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: 'client-default-key'
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.catch((err)=>(0, $fDj08.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $fDj08.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $fDj08.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $fDj08.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $69447551ddb5d964$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("ajj2D", function(module, exports) {
"use strict";
var $781a73007c8f7d89$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $4tluv = parcelRequire("4tluv");

const $781a73007c8f7d89$var$feature_gate_js_client_1 = $781a73007c8f7d89$var$__importDefault((parcelRequire("6Z4pn")));

var $fDj08 = parcelRequire("fDj08");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $781a73007c8f7d89$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $4tluv.useState)(!overrides && (0, $fDj08.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $4tluv.useRef)(options);
    (0, $4tluv.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $4tluv.useEffect)(()=>{
        if (enabled) {
            if ((0, $fDj08.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $fDj08.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $781a73007c8f7d89$var$feature_gate_js_client_1.default.initializeCalled() ? $781a73007c8f7d89$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $781a73007c8f7d89$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.catch((err)=>(0, $fDj08.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $fDj08.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $fDj08.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $fDj08.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $781a73007c8f7d89$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});


parcelRegister("3BHcm", function(module, exports) {
$parcel$export(module.exports, "default", () => $39616a33c5c2caf2$export$2e2bcd8739ae039);

var $elD7P = parcelRequire("elD7P");

var $9vwpZ = parcelRequire("9vwpZ");

var $hAU2w = parcelRequire("hAU2w");

var $7NCL6 = parcelRequire("7NCL6");

var $ll5qt = parcelRequire("ll5qt");
const $39616a33c5c2caf2$export$45f8278e99551e4d = 10000;
class $39616a33c5c2caf2$export$2e2bcd8739ae039 {
    constructor(providerOptions){
        this.lastUpdatedTimestamp = 0;
        this.providerOptions = providerOptions;
        this.featureGateUpdateHttpHandler = this.featureGateUpdateHttpHandler.bind(this);
        this.featureGateUpdateBroadcastHandler = this.featureGateUpdateBroadcastHandler.bind(this);
        this.refresh = new (0, $7NCL6.default)(providerOptions, this.featureGateUpdateHttpHandler);
        this.broadcast = new (0, $9vwpZ.default)(providerOptions.apiKey, this.featureGateUpdateBroadcastHandler);
        try {
            this.featureGatesDB = new (0, $hAU2w.default)();
            // Dont run on startup to prevent slowdown
            setTimeout(()=>this.featureGatesDB?.purgeStaleEntries(), $39616a33c5c2caf2$export$45f8278e99551e4d);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(`Error when trying to start DB, ${JSON.stringify(error)}`);
        }
    }
    setApplyUpdateCallback(applyUpdate) {
        this.applyUpdate = applyUpdate;
    }
    setClientVersion(clientVersion) {
        this.clientVersion = clientVersion;
        this.refresh.setClientVersion(clientVersion);
    }
    async setProfile(clientOptions, identifiers, customAttributes) {
        const { profileHash: profileHash, rulesetProfile: rulesetProfile } = await this.getProfileHashAndProfile(clientOptions, identifiers, customAttributes);
        if (this.currentProfileHash !== profileHash) this.lastUpdatedTimestamp = 0;
        this.currentProfileHash = profileHash;
        this.currentRulesetProfile = rulesetProfile;
        this.broadcast.updateUserContext(profileHash);
        this.refresh.updateProfile(profileHash, rulesetProfile, // We expect setProfile to be set 1. before calls to get* methods and 2. used to revert the user if updateUser* fails
        // For 1, we will set the timestamp to the current time as the get methods will cause a request if it is needed
        // For 2, it is an error case and with this code it would reset the next polling interval, delaying the next poll for new values
        Date.now());
        this.refresh.start();
    }
    async getExperimentValues() {
        if (!this.clientVersion) throw new Error('Client version has not been set');
        if (!this.currentRulesetProfile || !this.currentProfileHash) throw new Error('Profile has not been set');
        const profileHash = (0, $ll5qt.cloneObject)(this.currentProfileHash);
        const rulesetProfile = (0, $ll5qt.cloneObject)(this.currentRulesetProfile);
        // Attempt to get from the DB
        const dbValues = await this.featureGatesDB?.getExperimentValues(profileHash);
        const lastKnownUpdatedTimestamp = dbValues?.timestamp ?? 0;
        this.lastUpdatedTimestamp = lastKnownUpdatedTimestamp;
        if (dbValues) {
            this.refresh.setTimestamp(lastKnownUpdatedTimestamp);
            this.refresh.start();
            return (0, $ll5qt.getFrontendExperimentsResult)(dbValues.experimentValuesResponse);
        }
        let newLastUpdatedTimestamp = lastKnownUpdatedTimestamp;
        const experimentResult = await this.fetchExperimentValues(this.clientVersion, rulesetProfile).then((result)=>{
            newLastUpdatedTimestamp = Date.now();
            return result;
        }).finally(()=>{
            if (profileHash === this.currentProfileHash) {
                this.lastUpdatedTimestamp = newLastUpdatedTimestamp;
                this.refresh.setTimestamp(newLastUpdatedTimestamp);
                this.refresh.start();
            }
        });
        const featureGateState = {
            profileHash: profileHash,
            rulesetProfile: rulesetProfile,
            experimentValuesResponse: experimentResult,
            timestamp: newLastUpdatedTimestamp
        };
        // Should not process this update as getExperimentValues will only be called on initialize and update user,
        // and in those cases processing is handled elsewhere
        this.featureGateUpdateHttpHandler(featureGateState, false);
        return (0, $ll5qt.getFrontendExperimentsResult)(experimentResult);
    }
    async getClientSdkKey() {
        if (!this.clientVersion) throw new Error('Client version has not been set');
        if (!this.currentRulesetProfile) throw new Error('Profile has not been set');
        const { environment: environment, targetApp: targetApp, perimeter: perimeter } = this.currentRulesetProfile;
        const { apiKey: apiKey, initialFetchTimeout: initialFetchTimeout, useGatewayURL: useGatewayURL } = this.providerOptions;
        const fetcherOptions = {
            environment: environment,
            targetApp: targetApp,
            perimeter: perimeter,
            apiKey: apiKey,
            fetchTimeoutMs: initialFetchTimeout,
            useGatewayURL: useGatewayURL
        };
        const clientKeyFromDB = await this.featureGatesDB?.getClientSdkKey({
            targetApp: targetApp,
            environment: environment,
            perimeter: perimeter
        });
        if (clientKeyFromDB) return clientKeyFromDB.clientSdkKey;
        const { clientSdkKey: clientSdkKey } = await (0, $elD7P.default).fetchClientSdkKey(this.clientVersion, fetcherOptions);
        this.featureGatesDB?.setClientSdkKey({
            clientSdkKey: clientSdkKey,
            targetApp: targetApp,
            environment: environment,
            perimeter: perimeter,
            timestamp: Date.now()
        });
        return clientSdkKey;
    }
    getApiKey() {
        return this.providerOptions.apiKey;
    }
    async getProfileHashAndProfile(clientOptions, identifiers, customAttributes) {
        const rulesetProfile = this.getRulesetProfile(clientOptions, identifiers, customAttributes);
        const hashedProfile = await (0, $ll5qt.createHash)(JSON.stringify(rulesetProfile));
        return {
            profileHash: (0, $elD7P.EXPERIMENT_VALUES_API_VERSION) + '.' + hashedProfile,
            rulesetProfile: rulesetProfile
        };
    }
    getRulesetProfile(clientOptions, identifiers, customAttributes) {
        return {
            identifiers: identifiers,
            customAttributes: customAttributes,
            environment: clientOptions.environment,
            targetApp: clientOptions.targetApp,
            perimeter: clientOptions.perimeter
        };
    }
    async fetchExperimentValues(clientVersion, rulesetProfile) {
        const { identifiers: identifiers, customAttributes: customAttributes, environment: environment, targetApp: targetApp, perimeter: perimeter } = rulesetProfile;
        const { apiKey: apiKey, initialFetchTimeout: initialFetchTimeout, useGatewayURL: useGatewayURL } = this.providerOptions;
        const fetcherOptions = {
            environment: environment,
            targetApp: targetApp,
            perimeter: perimeter,
            apiKey: apiKey,
            fetchTimeoutMs: initialFetchTimeout,
            useGatewayURL: useGatewayURL
        };
        return await (0, $elD7P.default).fetchExperimentValues(clientVersion, fetcherOptions, identifiers, customAttributes);
    }
    featureGateUpdateHttpHandler(experimentValuesEntry, shouldProcessUpdate = true) {
        if (shouldProcessUpdate) this.processFeatureGateUpdate(experimentValuesEntry);
        this.featureGatesDB?.setExperimentValues(experimentValuesEntry);
        // broadcast the flag state to other tabs if the profile matches that of the current broadcast channel
        if (experimentValuesEntry.profileHash === this.currentProfileHash) this.broadcast.sendFeatureGateState(experimentValuesEntry);
    }
    featureGateUpdateBroadcastHandler(featureGateState) {
        // return if broadcasted feature gate state is stale
        if (featureGateState.timestamp < this.lastUpdatedTimestamp) return;
        this.processFeatureGateUpdate(featureGateState);
    }
    processFeatureGateUpdate(featureGateState) {
        if (this.currentProfileHash === featureGateState.profileHash) {
            this.lastUpdatedTimestamp = featureGateState.timestamp;
            this.refresh.setTimestamp(featureGateState.timestamp);
            if (!this.applyUpdate) // eslint-disable-next-line no-console
            console.warn('No apply update callback has been set. Cannot update experiment values.');
            else this.applyUpdate((0, $ll5qt.getFrontendExperimentsResult)(featureGateState.experimentValuesResponse));
        }
    }
}

});
parcelRegister("elD7P", function(module, exports) {
$parcel$export(module.exports, "EXPERIMENT_VALUES_API_VERSION", () => $bec045e637c78e53$export$1e164866fd37d1a9);
$parcel$export(module.exports, "default", () => $bec045e637c78e53$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ResponseError", () => (parcelRequire("kWQVp")).ResponseError);

var $42xfx = parcelRequire("42xfx");

var $kWQVp = parcelRequire("kWQVp");
const $bec045e637c78e53$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $bec045e637c78e53$var$PROD_BASE_URL = 'https://api.atlassian.com/flags';
const $bec045e637c78e53$var$STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
const $bec045e637c78e53$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $bec045e637c78e53$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $bec045e637c78e53$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $bec045e637c78e53$export$450bd8fb2a6d7ace = '/gateway/api/flags';
const $bec045e637c78e53$export$1e164866fd37d1a9 = 'v2';
class $bec045e637c78e53$export$2e2bcd8739ae039 {
    static async fetchClientSdkKey(clientVersion, fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(clientVersion, url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(clientVersion, fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest(clientVersion, `/api/${$bec045e637c78e53$export$1e164866fd37d1a9}/frontend/experimentValues`, 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $kWQVp.ResponseError)('Non 2xx response status received', response.status, JSON.stringify(body));
        }
        if (response.status === 204) throw new (0, $kWQVp.ResponseError)('Unexpected 204 response', response.status, '');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter = (0, $42xfx.PerimeterType).COMMERCIAL) {
        if (useGatewayUrl) return $bec045e637c78e53$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $42xfx.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $42xfx.FeatureGateEnvironment).Production:
                return $bec045e637c78e53$export$18c93900db9358a4;
            case (0, $42xfx.FeatureGateEnvironment).Staging:
                return $bec045e637c78e53$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $42xfx.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $42xfx.FeatureGateEnvironment).Development:
                return $bec045e637c78e53$export$f058dbf75c3bc647;
            case (0, $42xfx.FeatureGateEnvironment).Staging:
                return $bec045e637c78e53$var$STAGING_BASE_URL;
            default:
                return $bec045e637c78e53$var$PROD_BASE_URL;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(clientVersion, path, method, fetcherOptions, body) {
        const baseUrl = $bec045e637c78e53$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $bec045e637c78e53$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': clientVersion,
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
}

});
parcelRegister("kWQVp", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $854517019b002b31$export$286baf652d0b1206);
class $854517019b002b31$export$286baf652d0b1206 extends Error {
    constructor(message, status, body){
        super(message);
        this._status = status;
        this._body = body;
    }
    get status() {
        return this._status;
    }
    get body() {
        return this._body;
    }
}

});


parcelRegister("9vwpZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d0a1b81e034ed2b$export$2e2bcd8739ae039);
const $4d0a1b81e034ed2b$export$dce59ee845588a78 = 'gateData';
class $4d0a1b81e034ed2b$export$2e2bcd8739ae039 {
    constructor(apiKey, stateUpdateCallback){
        this.apiKey = apiKey;
        this.stateUpdateCallback = stateUpdateCallback;
    }
    updateUserContext(profileHash) {
        this.stop();
        this.setupChannel(profileHash);
    }
    sendFeatureGateState(featureGateState) {
        this.channel?.postMessage(featureGateState);
    }
    stop() {
        this.channel?.close();
    }
    setupChannel(profileHash) {
        try {
            // eslint-disable-next-line compat/compat
            const channel = new BroadcastChannel(this.createChannelName(profileHash));
            channel.onmessage = (e)=>{
                this.stateUpdateCallback(e.data);
            };
            this.channel = channel;
        } catch (error) {
        // This could fail due to BroadcastChannel not available.
        // In that case, we do nothing.
        }
    }
    createChannelName(profileHash) {
        return `${$4d0a1b81e034ed2b$export$dce59ee845588a78}.${this.apiKey}.${profileHash}`;
    }
}

});

parcelRegister("hAU2w", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f027a2ab2842238$export$2e2bcd8739ae039);

var $ejIno = parcelRequire("ejIno");

var $1t7HY = parcelRequire("1t7HY");
const $1f027a2ab2842238$export$5e224bda12b7734d = 604800000;
const $1f027a2ab2842238$export$324526f88ea0789d = 86400000;
class $1f027a2ab2842238$export$2e2bcd8739ae039 {
    constructor(){
        if (!window.indexedDB) throw new Error();
        this.db = this.startDB();
    }
    async startDB() {
        return new Promise(async (resolve, reject)=>{
            if (typeof window !== 'undefined') {
                const dbTimeout = window.setTimeout(()=>{
                    const message = 'IndexedDB timed out.';
                    // eslint-disable-next-line no-console
                    console.warn(message);
                    reject(new Error(message));
                }, (0, $ejIno.INDEXEDDB_TIMEOUT));
                /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how Feature Gates client is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ const request = window.indexedDB.open((0, $ejIno.FEATURE_GATES_DB_NAME), 1);
                request.onupgradeneeded = (event)=>{
                    if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                    const db = request.result;
                    const clientSdkKeyStore = db.createObjectStore((0, $ejIno.StoreName).CLIENT_SDK_KEY_STORE_NAME, {
                        keyPath: 'dbKey'
                    });
                    clientSdkKeyStore.createIndex((0, $ejIno.CLIENT_SDK_KEY_TIMESTAMP_INDEX), 'timestamp', {
                        unique: false
                    });
                    const experimentValuesStore = db.createObjectStore((0, $ejIno.StoreName).EXPERIMENT_VALUES_STORE_NAME, {
                        keyPath: 'profileHash'
                    });
                    experimentValuesStore.createIndex((0, $ejIno.EXPERIMENT_VALUES_TIMESTAMP_INDEX), 'timestamp', {
                        unique: false
                    });
                };
                try {
                    await (0, $1t7HY.requestToPromise)(request);
                    return resolve(request.result);
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('IndexedDB failed to initialise.', error);
                    reject(error);
                } finally{
                    window.clearTimeout(dbTimeout);
                }
            } else {
                const message = "IndexedDB failed to initialise. No 'window' object.";
                // eslint-disable-next-line no-console
                console.warn(message);
                reject(new Error(message));
            }
        });
    }
    async setExperimentValues(entry) {
        this.setItem((0, $ejIno.StoreName).EXPERIMENT_VALUES_STORE_NAME, entry.profileHash, entry);
    }
    async getExperimentValues(profileHash) {
        return this.getItem((0, $ejIno.StoreName).EXPERIMENT_VALUES_STORE_NAME, profileHash);
    }
    async setClientSdkKey(entry) {
        const dbKey = (0, $1t7HY.getClientSdkKeyDBKey)(entry);
        this.setItem((0, $ejIno.StoreName).CLIENT_SDK_KEY_STORE_NAME, dbKey, {
            ...entry,
            dbKey: dbKey
        });
    }
    async getClientSdkKey(entry) {
        return this.getItem((0, $ejIno.StoreName).CLIENT_SDK_KEY_STORE_NAME, (0, $1t7HY.getClientSdkKeyDBKey)(entry));
    }
    async purgeStaleEntries() {
        await Promise.all([
            this.purgeStaleExperimentValues(),
            this.purgeStaleClientSdkKeys()
        ]);
    }
    async purgeStaleExperimentValues() {
        this.purgeOldEntries((0, $ejIno.StoreName).EXPERIMENT_VALUES_STORE_NAME, (0, $ejIno.EXPERIMENT_VALUES_TIMESTAMP_INDEX), $1f027a2ab2842238$export$5e224bda12b7734d, (entry)=>entry.profileHash);
    }
    async purgeStaleClientSdkKeys() {
        this.purgeOldEntries((0, $ejIno.StoreName).CLIENT_SDK_KEY_STORE_NAME, (0, $ejIno.CLIENT_SDK_KEY_TIMESTAMP_INDEX), $1f027a2ab2842238$export$324526f88ea0789d, (entry)=>entry.dbKey);
    }
    async getObjectStoreAndTransaction(storeName, mode) {
        const transaction = (await this.db).transaction(storeName, mode);
        const objectStore = transaction.objectStore(storeName);
        return {
            transaction: transaction,
            objectStore: objectStore
        };
    }
    async deleteItem(objectStore, id) {
        try {
            await (0, $1t7HY.requestToPromise)(objectStore.delete(id));
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to delete item:', id, error);
            throw error;
        }
    }
    async getItem(storeName, key) {
        try {
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction(storeName, 'readonly');
            const request = objectStore.get(key);
            const event = await (0, $1t7HY.requestToPromise)(request);
            await (0, $1t7HY.commitTransaction)(transaction);
            return event.target.result;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(`Error when trying to get item in store ${storeName} for key ${key}`, error);
        }
        return null;
    }
    async setItem(storeName, key, value) {
        try {
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction(storeName, 'readwrite');
            const request = objectStore.put(value);
            await (0, $1t7HY.requestToPromise)(request);
            await (0, $1t7HY.commitTransaction)(transaction);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(`Error when trying to set item in store ${storeName} with key ${key}`, error);
        }
    }
    async purgeOldEntries(storename, timestampIndexKey, expiryPeriod, getKey) {
        const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction(storename, 'readwrite');
        try {
            objectStore.getAll();
            const timeIndex = objectStore.index(timestampIndexKey);
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now() - expiryPeriod);
            const request = timeIndex.getAll(upperBoundOpenKeyRange);
            const event = await (0, $1t7HY.requestToPromise)(request);
            const deletePromises = event.target.result.map((entry)=>this.deleteItem(objectStore, getKey(entry)));
            await (0, $1t7HY.commitTransaction)(transaction);
            await Promise.all(deletePromises);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Failed to delete items from indexeddb.', error);
            throw error;
        }
    }
}

});
parcelRegister("ejIno", function(module, exports) {
$parcel$export(module.exports, "FEATURE_GATES_DB_NAME", () => $7a3fb1b4e802f002$export$caa0390d514e457b);
$parcel$export(module.exports, "EXPERIMENT_VALUES_TIMESTAMP_INDEX", () => $7a3fb1b4e802f002$export$469d4c295729d34);
$parcel$export(module.exports, "CLIENT_SDK_KEY_TIMESTAMP_INDEX", () => $7a3fb1b4e802f002$export$3e70a6a23414e2ae);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $7a3fb1b4e802f002$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreName", () => $7a3fb1b4e802f002$export$79234e00edec7f22);
const $7a3fb1b4e802f002$export$caa0390d514e457b = 'feature-gates-client';
const $7a3fb1b4e802f002$export$469d4c295729d34 = 'experiment-values-timestamp-index';
const $7a3fb1b4e802f002$export$3e70a6a23414e2ae = 'client-sdk-key-timestamp-index';
const $7a3fb1b4e802f002$export$6d8635fed0e4b14d = 15000;
var $7a3fb1b4e802f002$export$79234e00edec7f22 = /*#__PURE__*/ function(StoreName) {
    StoreName["EXPERIMENT_VALUES_STORE_NAME"] = "experiment-values-store";
    StoreName["CLIENT_SDK_KEY_STORE_NAME"] = "client-sdk-key-store";
    return StoreName;
}({});

});

parcelRegister("1t7HY", function(module, exports) {
$parcel$export(module.exports, "getClientSdkKeyDBKey", () => $2f3a87e16e26d445$export$33d2e03312ce4747);
$parcel$export(module.exports, "requestToPromise", () => $2f3a87e16e26d445$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $2f3a87e16e26d445$export$feab8418f018df89);
const $2f3a87e16e26d445$export$33d2e03312ce4747 = (entry)=>`${entry.targetApp}.${entry.environment}.${entry.perimeter}`;
const $2f3a87e16e26d445$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $2f3a87e16e26d445$var$transactionToPromise = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $2f3a87e16e26d445$export$feab8418f018df89 = (transaction)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $2f3a87e16e26d445$var$transactionToPromise(transaction);
};

});


parcelRegister("7NCL6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d3cb9d6b0cc4144$export$2e2bcd8739ae039);

var $Hyfcf = parcelRequire("Hyfcf");

var $elD7P = parcelRequire("elD7P");
var $kWQVp = parcelRequire("kWQVp");

var $ll5qt = parcelRequire("ll5qt");
const $3d3cb9d6b0cc4144$export$e368b3f041583a9f = 300000;
const $3d3cb9d6b0cc4144$export$9f07cc6db84eac61 = {
    minWaitInterval: 300000,
    // 300 second = 5 mins
    maxWaitInterval: 1200000,
    // 1200 second = 20 mins
    backOffFactor: 2,
    backOffJitter: 0.1,
    // Jitter is upto 10% of wait time
    interval: 300000,
    // 300 second = 5 mins
    tabHiddenPollingFactor: 12,
    // for hidden tabs, use hiddenTabFactor * interval for polling = 1 hour (default)
    maxInstantRetryTimes: 0
};
const $3d3cb9d6b0cc4144$export$2b558311ac69763c = {
    ...$3d3cb9d6b0cc4144$export$9f07cc6db84eac61,
    minWaitInterval: 500,
    interval: 500,
    maxInstantRetryTimes: 1
};
class $3d3cb9d6b0cc4144$export$2e2bcd8739ae039 {
    constructor(providerOptions, onExperimentValuesUpdate){
        this.failureCount = 0;
        this.lastUpdateTimestamp = 0;
        this.hasIntervalBeenValidated = false;
        this.onExperimentValuesUpdate = onExperimentValuesUpdate;
        this.pollingConfig = {
            ...$3d3cb9d6b0cc4144$export$9f07cc6db84eac61,
            interval: providerOptions.pollingInterval ?? $3d3cb9d6b0cc4144$export$9f07cc6db84eac61.interval,
            maxInstantRetryTimes: 0 // Force this to 0 so this never reschedules instantly with cache
        };
        this.noCachePollingConfig = $3d3cb9d6b0cc4144$export$2b558311ac69763c;
        this.providerOptions = providerOptions;
        this.visibilityChangeHandler = this.visibilityChangeHandler.bind(this);
    }
    // start refresh by fetchAndReschedule
    start() {
        this.stop();
        this.bindVisibilityChange();
        this.fetchAndReschedule();
    }
    // cancel pending schedule
    stop() {
        if (this.timerId) {
            window.clearTimeout(this.timerId);
            this.timerId = undefined;
            this.unbindVisibilityChange();
        }
    }
    updateProfile(profileHash, rulesetProfile, lastUpdateTimestamp = 0) {
        this.profileHash = profileHash;
        this.rulesetProfile = rulesetProfile;
        this.lastUpdateTimestamp = this.adjustBasedOnStaleness(lastUpdateTimestamp);
        this.failureCount = 0;
    }
    // update version and timestamp
    setClientVersion(clientVersion) {
        this.clientVersion = clientVersion;
    }
    setTimestamp(lastUpdateTimestamp) {
        this.lastUpdateTimestamp = this.adjustBasedOnStaleness(lastUpdateTimestamp);
    }
    adjustBasedOnStaleness(timestamp) {
        return Date.now() - timestamp >= $3d3cb9d6b0cc4144$export$e368b3f041583a9f ? 0 : timestamp;
    }
    visibilityChangeHandler() {
        // cancel existing schedule
        window.clearTimeout(this.timerId);
        this.timerId = undefined;
        // get current tab hidden state (for unsupported browser isTabHidden() will return false), so
        // if isTabHidden true: create a new schedule with a longer interval
        // if isTabHidden false: do a fetchAndReschedule (conditional do a fetch, schedule with normal interval)
        if ($3d3cb9d6b0cc4144$export$2e2bcd8739ae039.isTabHidden()) this.schedule();
        else this.fetchAndReschedule();
    }
    static isTabHidden() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- visibilityState is read from the active document
        return document.visibilityState === 'hidden';
    }
    // bind tab visibility change callback
    bindVisibilityChange() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- page visibility listener is bound on document
        this.unbind = (0, $Hyfcf.bind)(document, {
            type: 'visibilitychange',
            listener: this.visibilityChangeHandler
        });
    }
    // unbind tab visibility change callback
    unbindVisibilityChange() {
        if (this.unbind) this.unbind();
    }
    // schedule a fetchAndReschedule
    schedule() {
        this.timerId = window.setTimeout(()=>{
            this.fetchAndReschedule();
        }, this.calculateInterval());
    }
    // conditional fetch ffs via fetcher, and schedule another fetchAndReschedule unless we have 400/401 from ffs
    fetchAndReschedule() {
        if (!this.clientVersion) throw new Error('Client version has not been set');
        if (!this.profileHash || !this.rulesetProfile) throw new Error('Profile has not been set');
        const fetchedProfileHash = this.profileHash;
        const fetchedRulesetProfile = this.rulesetProfile;
        const { environment: environment, targetApp: targetApp, perimeter: perimeter } = this.rulesetProfile;
        const { apiKey: apiKey, useGatewayURL: useGatewayURL } = this.providerOptions;
        // validate the polling interval is not too short based on the environment
        this.pollingConfig.interval = (0, $ll5qt.getValidatedPollingInterval)(this.pollingConfig.interval, environment, !this.hasIntervalBeenValidated);
        // set this to true after first validation to prevent multiple info logs
        this.hasIntervalBeenValidated = true;
        const fetcherOptions = {
            environment: environment,
            targetApp: targetApp,
            perimeter: perimeter,
            apiKey: apiKey,
            useGatewayURL: useGatewayURL
        };
        if (this.isFetchRequired()) (0, $elD7P.default).fetchExperimentValues(this.clientVersion, fetcherOptions, this.rulesetProfile.identifiers, this.rulesetProfile.customAttributes).then((resp)=>{
            if (fetchedProfileHash === this.profileHash) {
                this.failureCount = 0;
                this.onExperimentValuesUpdate({
                    profileHash: fetchedProfileHash,
                    rulesetProfile: fetchedRulesetProfile,
                    experimentValuesResponse: resp,
                    timestamp: Date.now()
                });
                this.schedule();
            }
        }).catch((err)=>{
            // 401 means client info or apiKey invalid, will have no retry
            // 400 means request body invalid, will have at most `maxInstantRetryTimes` instant retries
            // other 4xx or 5xx will do `maxInstantRetryTimes` instant retries and continue to do backoff retries
            if (err instanceof (0, $kWQVp.ResponseError) && [
                400,
                401
            ].includes(err.status)) {
                // no retry needed
                const message = `Feature flag service returned ${err.status}, "${err.body}". This request will not be retried until the profile data has been changed.`;
                // eslint-disable-next-line no-console
                console.error(message);
            } else {
                this.failureCount += 1;
                this.schedule();
            }
        });
        else this.schedule();
    }
    isFetchRequired() {
        return Date.now() - this.getPollingConfig().interval >= this.lastUpdateTimestamp;
    }
    // calculate wait interval based on failure count
    calculateInterval() {
        const { interval: interval, tabHiddenPollingFactor: tabHiddenPollingFactor, minWaitInterval: minWaitInterval, maxWaitInterval: maxWaitInterval, backOffFactor: backOffFactor, backOffJitter: backOffJitter, maxInstantRetryTimes: maxInstantRetryTimes } = this.getPollingConfig();
        if (maxInstantRetryTimes !== undefined && maxInstantRetryTimes !== 0 && maxInstantRetryTimes >= this.failureCount) return 0;
        if (this.failureCount === 0) return $3d3cb9d6b0cc4144$export$2e2bcd8739ae039.isTabHidden() ? interval * tabHiddenPollingFactor : interval;
        let ms = minWaitInterval * backOffFactor ** (this.failureCount - 1);
        if (backOffJitter) {
            const rand = Math.random();
            const deviation = Math.floor(rand * backOffJitter * ms);
            if (Math.floor(rand * 10) < 5) ms -= deviation;
            else ms += deviation;
        }
        return Number(Math.min(ms, maxWaitInterval));
    }
    getPollingConfig() {
        if (this.lastUpdateTimestamp === 0) return this.noCachePollingConfig;
        return this.pollingConfig;
    }
}

});
parcelRegister("ll5qt", function(module, exports) {
$parcel$export(module.exports, "getFrontendExperimentsResult", () => $65e180e65bce3ef8$export$ea331062506158bf);
$parcel$export(module.exports, "getValidatedPollingInterval", () => $65e180e65bce3ef8$export$5063c9cde7b925d3);
$parcel$export(module.exports, "createHash", () => $65e180e65bce3ef8$export$2fb37efbf6ae0c0e);
$parcel$export(module.exports, "cloneObject", () => $65e180e65bce3ef8$export$d30aea6baca0538b);

var $42xfx = parcelRequire("42xfx");
const $65e180e65bce3ef8$export$ea331062506158bf = (frontendExperimentsResponse)=>{
    const { clientSdkKey: clientSdkKey, experimentValues: experimentValues, customAttributes: customAttributesFromFetch } = frontendExperimentsResponse;
    return {
        clientSdkKey: clientSdkKey,
        experimentValues: experimentValues,
        customAttributesFromFetch: customAttributesFromFetch
    };
};
const $65e180e65bce3ef8$export$5063c9cde7b925d3 = (currentInterval, environment, logInfo)=>{
    const prodMinInterval = 60000;
    const nonProdMinInterval = 1000;
    let newInterval = currentInterval;
    if (currentInterval < prodMinInterval) {
        if (environment === (0, $42xfx.FeatureGateEnvironment).Production) {
            newInterval = prodMinInterval;
            if (logInfo) // eslint-disable-next-line no-console
            console.info(`options.pollingInterval needs to be greater than ${prodMinInterval}, interval has been set to minimum`);
        } else if (currentInterval < nonProdMinInterval) {
            newInterval = nonProdMinInterval;
            if (logInfo) // eslint-disable-next-line no-console
            console.info(`options.pollingInterval needs to be greater than ${nonProdMinInterval}, interval has been set to minimum`);
        } else if (logInfo) // eslint-disable-next-line no-console
        console.info(`options.pollingInterval needs to be greater than ${prodMinInterval} in Production`);
    }
    return newInterval;
};
const $65e180e65bce3ef8$export$2fb37efbf6ae0c0e = async (input)=>{
    const msgUint8 = new TextEncoder().encode(input); // encode as (utf-8) Uint8Array
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
    return hashHex;
};
const $65e180e65bce3ef8$export$d30aea6baca0538b = (obj)=>{
    const str = JSON.stringify(obj);
    return JSON.parse(str);
};

});



parcelRegister("2m1d3", function(module, exports) {
$parcel$export(module.exports, "QueryClient", () => $1b6e93077a044026$export$405d0624ed55a03f);
// src/queryClient.ts

var $1j5lT = parcelRequire("1j5lT");

var $hNHY6 = parcelRequire("hNHY6");

var $brcHR = parcelRequire("brcHR");

var $8qv0d = parcelRequire("8qv0d");

var $lzTt6 = parcelRequire("lzTt6");

var $cnq4V = parcelRequire("cnq4V");

var $91D3D = parcelRequire("91D3D");
var $1b6e93077a044026$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $hNHY6.QueryCache)();
        this.#mutationCache = config.mutationCache || new (0, $brcHR.MutationCache)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $8qv0d.focusManager).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $lzTt6.onlineManager).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = this.#queryCache.build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $1j5lT.resolveStaleTime)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = this.#queryCache.get(defaultedOptions.queryHash);
        const prevData = query?.state.data;
        const data = (0, $1j5lT.functionalUpdate)(updater, prevData);
        if (data === void 0) return void 0;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $cnq4V.notifyManager).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $cnq4V.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        return (0, $cnq4V.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $cnq4V.notifyManager).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $1j5lT.noop)).catch((0, $1j5lT.noop));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $cnq4V.notifyManager).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters?.refetchType === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: filters?.refetchType ?? filters?.type ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $cnq4V.notifyManager).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $1j5lT.noop));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $1j5lT.noop));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime((0, $1j5lT.resolveStaleTime)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $1j5lT.noop)).catch((0, $1j5lT.noop));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $91D3D.infiniteQueryBehavior)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $1j5lT.noop)).catch((0, $1j5lT.noop));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $91D3D.infiniteQueryBehavior)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $lzTt6.onlineManager).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return this.#queryCache;
    }
    getMutationCache() {
        return this.#mutationCache;
    }
    getDefaultOptions() {
        return this.#defaultOptions;
    }
    setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $1j5lT.hashKey)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $1j5lT.partialMatchKey)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $1j5lT.hashKey)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $1j5lT.partialMatchKey)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $1j5lT.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $1j5lT.skipToken)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};

});
parcelRegister("hNHY6", function(module, exports) {
$parcel$export(module.exports, "QueryCache", () => $cf591e7d78af8e50$export$5dde0cd941da8468);
// src/queryCache.ts

var $1j5lT = parcelRequire("1j5lT");

var $2Uo4O = parcelRequire("2Uo4O");

var $cnq4V = parcelRequire("cnq4V");

var $6MLVK = parcelRequire("6MLVK");
var $cf591e7d78af8e50$export$5dde0cd941da8468 = class extends (0, $6MLVK.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $1j5lT.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $2Uo4O.Query)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $cnq4V.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $1j5lT.matchQuery)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $1j5lT.matchQuery)(filters, query)) : queries;
    }
    notify(event) {
        (0, $cnq4V.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $cnq4V.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $cnq4V.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};

});

parcelRegister("brcHR", function(module, exports) {
$parcel$export(module.exports, "MutationCache", () => $853c12892747c428$export$1fcfd9a244434844);
// src/mutationCache.ts

var $cnq4V = parcelRequire("cnq4V");

var $h0PTG = parcelRequire("h0PTG");

var $1j5lT = parcelRequire("1j5lT");

var $6MLVK = parcelRequire("6MLVK");
var $853c12892747c428$export$1fcfd9a244434844 = class extends (0, $6MLVK.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    #mutations;
    #scopes;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, $h0PTG.Mutation)({
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.#mutations.add(mutation);
        const scope = $853c12892747c428$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = $853c12892747c428$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $853c12892747c428$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = this.#scopes.get(scope);
            const firstPendingMutation = mutationsWithSameScope?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = $853c12892747c428$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused);
            return foundMutation?.continue() ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $cnq4V.notifyManager).batch(()=>{
            this.#mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            this.#mutations.clear();
            this.#scopes.clear();
        });
    }
    getAll() {
        return Array.from(this.#mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $1j5lT.matchMutation)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $1j5lT.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $cnq4V.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $cnq4V.notifyManager).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $1j5lT.noop)))));
    }
};
function $853c12892747c428$var$scopeFor(mutation) {
    return mutation.options.scope?.id;
}

});

parcelRegister("91D3D", function(module, exports) {
$parcel$export(module.exports, "infiniteQueryBehavior", () => $69228111adce69ce$export$84470d1367601e8d);
// src/infiniteQueryBehavior.ts

var $1j5lT = parcelRequire("1j5lT");
function $69228111adce69ce$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $1j5lT.ensureQueryFn)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        client: context.client,
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $1j5lT.addToStart) : (0, $1j5lT.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $69228111adce69ce$var$getPreviousPageParam : $69228111adce69ce$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $69228111adce69ce$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $69228111adce69ce$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $69228111adce69ce$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $69228111adce69ce$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $69228111adce69ce$var$getNextPageParam(options, data) != null;
}
function $69228111adce69ce$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $69228111adce69ce$var$getPreviousPageParam(options, data) != null;
}

});


parcelRegister("7LJz7", function(module, exports) {
$parcel$export(module.exports, "createSyncStoragePersister", () => $5a8044845893dc3c$export$35561f995d4e487d);
function $5a8044845893dc3c$export$35561f995d4e487d({ storage: storage, key: key = "REACT_QUERY_OFFLINE_CACHE", throttleTime: throttleTime = 1000, serialize: serialize = JSON.stringify, deserialize: deserialize = JSON.parse, retry: retry }) {
    if (storage) {
        const trySave = (persistedClient)=>{
            try {
                storage.setItem(key, serialize(persistedClient));
                return;
            } catch (error) {
                return error;
            }
        };
        return {
            persistClient: $5a8044845893dc3c$var$throttle((persistedClient)=>{
                let client = persistedClient;
                let error = trySave(client);
                let errorCount = 0;
                while(error && client){
                    errorCount++;
                    client = retry == null ? void 0 : retry({
                        persistedClient: client,
                        error: error,
                        errorCount: errorCount
                    });
                    if (client) error = trySave(client);
                }
            }, throttleTime),
            restoreClient: ()=>{
                const cacheString = storage.getItem(key);
                if (!cacheString) return;
                return deserialize(cacheString);
            },
            removeClient: ()=>{
                storage.removeItem(key);
            }
        };
    }
    return {
        persistClient: $5a8044845893dc3c$var$noop,
        restoreClient: ()=>undefined,
        removeClient: $5a8044845893dc3c$var$noop
    };
}
function $5a8044845893dc3c$var$throttle(func, wait = 100) {
    let timer = null;
    let params;
    return function(...args) {
        params = args;
        if (timer === null) timer = setTimeout(()=>{
            func(...params);
            timer = null;
        }, wait);
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $5a8044845893dc3c$var$noop() {}

});

parcelRegister("wcH3l", function(module, exports) {
$parcel$export(module.exports, "useSuspenseQueries", () => $060cd5eb22ce2607$export$5d5d53208d49f2c9);


var $kLbLm = parcelRequire("kLbLm");

var $6RauK = parcelRequire("6RauK");
"use client";
function $060cd5eb22ce2607$export$5d5d53208d49f2c9(options, queryClient) {
    return (0, $kLbLm.useQueries)({
        ...options,
        queries: options.queries.map((query)=>{
            return {
                ...query,
                suspense: true,
                throwOnError: (0, $6RauK.defaultThrowOnError),
                enabled: true,
                placeholderData: void 0
            };
        })
    }, queryClient);
}

});
parcelRegister("kLbLm", function(module, exports) {
$parcel$export(module.exports, "useQueries", () => $f1d1524ef9e109ee$export$408667c6c87da1e5);

var $4tluv = parcelRequire("4tluv");

var $cnq4V = parcelRequire("cnq4V");
var $9iRj4 = parcelRequire("9iRj4");
var $djflQ = parcelRequire("djflQ");

var $4cZqh = parcelRequire("4cZqh");

var $gEvBY = parcelRequire("gEvBY");

var $3SsW6 = parcelRequire("3SsW6");

var $44O1u = parcelRequire("44O1u");

var $6RauK = parcelRequire("6RauK");

var $M8kp4 = parcelRequire("M8kp4");
"use client";
function $f1d1524ef9e109ee$export$408667c6c87da1e5({ queries: queries, ...options }, queryClient) {
    const client = (0, $4cZqh.useQueryClient)(queryClient);
    const isRestoring = (0, $gEvBY.useIsRestoring)();
    const errorResetBoundary = (0, $3SsW6.useQueryErrorResetBoundary)();
    const defaultedQueries = $4tluv.useMemo(()=>queries.map((opts)=>{
            const defaultedOptions = client.defaultQueryOptions(opts);
            defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
            return defaultedOptions;
        }), [
        queries,
        client,
        isRestoring
    ]);
    defaultedQueries.forEach((query)=>{
        (0, $6RauK.ensureSuspenseTimers)(query);
        (0, $44O1u.ensurePreventErrorBoundaryRetry)(query, errorResetBoundary);
    });
    (0, $44O1u.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $4tluv.useState(()=>new (0, $9iRj4.QueriesObserver)(client, defaultedQueries, options));
    const [optimisticResult, getCombinedResult, trackResult] = observer.getOptimisticResult(defaultedQueries, options.combine);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $4tluv.useSyncExternalStore($4tluv.useCallback((onStoreChange)=>shouldSubscribe ? observer.subscribe((0, $cnq4V.notifyManager).batchCalls(onStoreChange)) : (0, $M8kp4.noop), [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $4tluv.useEffect(()=>{
        observer.setQueries(defaultedQueries, options);
    }, [
        defaultedQueries,
        options,
        observer
    ]);
    const shouldAtLeastOneSuspend = optimisticResult.some((result, index)=>(0, $6RauK.shouldSuspend)(defaultedQueries[index], result));
    const suspensePromises = shouldAtLeastOneSuspend ? optimisticResult.flatMap((result, index)=>{
        const opts = defaultedQueries[index];
        if (opts) {
            const queryObserver = new (0, $djflQ.QueryObserver)(client, opts);
            if ((0, $6RauK.shouldSuspend)(opts, result)) return (0, $6RauK.fetchOptimistic)(opts, queryObserver, errorResetBoundary);
            else if ((0, $6RauK.willFetch)(result, isRestoring)) (0, $6RauK.fetchOptimistic)(opts, queryObserver, errorResetBoundary);
        }
        return [];
    }) : [];
    if (suspensePromises.length > 0) throw Promise.all(suspensePromises);
    const firstSingleResultWhichShouldThrow = optimisticResult.find((result, index)=>{
        const query = defaultedQueries[index];
        return query && (0, $44O1u.getHasError)({
            result: result,
            errorResetBoundary: errorResetBoundary,
            throwOnError: query.throwOnError,
            query: client.getQueryCache().get(query.queryHash),
            suspense: query.suspense
        });
    });
    if (firstSingleResultWhichShouldThrow?.error) throw firstSingleResultWhichShouldThrow.error;
    return getCombinedResult(trackResult());
}

});
parcelRegister("9iRj4", function(module, exports) {
$parcel$export(module.exports, "QueriesObserver", () => $6c5f250ebc139dd3$export$15352e437905ad4c);
// src/queriesObserver.ts

var $cnq4V = parcelRequire("cnq4V");

var $djflQ = parcelRequire("djflQ");

var $6MLVK = parcelRequire("6MLVK");

var $1j5lT = parcelRequire("1j5lT");
function $6c5f250ebc139dd3$var$difference(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $6c5f250ebc139dd3$var$replaceAt(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
var $6c5f250ebc139dd3$export$15352e437905ad4c = class extends (0, $6MLVK.Subscribable) {
    #client;
    #result;
    #queries;
    #options;
    #observers;
    #combinedResult;
    #lastCombine;
    #lastResult;
    #observerMatches = [];
    constructor(client, queries, options){
        super();
        this.#client = client;
        this.#options = options;
        this.#queries = [];
        this.#observers = [];
        this.#result = [];
        this.setQueries(queries);
    }
    onSubscribe() {
        if (this.listeners.size === 1) this.#observers.forEach((observer)=>{
            observer.subscribe((result)=>{
                this.#onUpdate(observer, result);
            });
        });
    }
    onUnsubscribe() {
        if (!this.listeners.size) this.destroy();
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#observers.forEach((observer)=>{
            observer.destroy();
        });
    }
    setQueries(queries, options) {
        this.#queries = queries;
        this.#options = options;
        (0, $cnq4V.notifyManager).batch(()=>{
            const prevObservers = this.#observers;
            const newObserverMatches = this.#findMatchingObservers(this.#queries);
            this.#observerMatches = newObserverMatches;
            newObserverMatches.forEach((match)=>match.observer.setOptions(match.defaultedQueryOptions));
            const newObservers = newObserverMatches.map((match)=>match.observer);
            const newResult = newObservers.map((observer)=>observer.getCurrentResult());
            const hasIndexChange = newObservers.some((observer, index)=>observer !== prevObservers[index]);
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            this.#observers = newObservers;
            this.#result = newResult;
            if (!this.hasListeners()) return;
            $6c5f250ebc139dd3$var$difference(prevObservers, newObservers).forEach((observer)=>{
                observer.destroy();
            });
            $6c5f250ebc139dd3$var$difference(newObservers, prevObservers).forEach((observer)=>{
                observer.subscribe((result)=>{
                    this.#onUpdate(observer, result);
                });
            });
            this.#notify();
        });
    }
    getCurrentResult() {
        return this.#result;
    }
    getQueries() {
        return this.#observers.map((observer)=>observer.getCurrentQuery());
    }
    getObservers() {
        return this.#observers;
    }
    getOptimisticResult(queries, combine) {
        const matches = this.#findMatchingObservers(queries);
        const result = matches.map((match)=>match.observer.getOptimisticResult(match.defaultedQueryOptions));
        return [
            result,
            (r)=>{
                return this.#combineResult(r ?? result, combine);
            },
            ()=>{
                return this.#trackResult(result, matches);
            }
        ];
    }
    #trackResult(result, matches) {
        return matches.map((match, index)=>{
            const observerResult = result[index];
            return !match.defaultedQueryOptions.notifyOnChangeProps ? match.observer.trackResult(observerResult, (accessedProp)=>{
                matches.forEach((m)=>{
                    m.observer.trackProp(accessedProp);
                });
            }) : observerResult;
        });
    }
    #combineResult(input, combine) {
        if (combine) {
            if (!this.#combinedResult || this.#result !== this.#lastResult || combine !== this.#lastCombine) {
                this.#lastCombine = combine;
                this.#lastResult = this.#result;
                this.#combinedResult = (0, $1j5lT.replaceEqualDeep)(this.#combinedResult, combine(input));
            }
            return this.#combinedResult;
        }
        return input;
    }
    #findMatchingObservers(queries) {
        const prevObserversMap = new Map(this.#observers.map((observer)=>[
                observer.options.queryHash,
                observer
            ]));
        const observers = [];
        queries.forEach((options)=>{
            const defaultedOptions = this.#client.defaultQueryOptions(options);
            const match = prevObserversMap.get(defaultedOptions.queryHash);
            if (match) observers.push({
                defaultedQueryOptions: defaultedOptions,
                observer: match
            });
            else observers.push({
                defaultedQueryOptions: defaultedOptions,
                observer: new (0, $djflQ.QueryObserver)(this.#client, defaultedOptions)
            });
        });
        return observers;
    }
    #onUpdate(observer, result) {
        const index = this.#observers.indexOf(observer);
        if (index !== -1) {
            this.#result = $6c5f250ebc139dd3$var$replaceAt(this.#result, index, result);
            this.#notify();
        }
    }
    #notify() {
        if (this.hasListeners()) {
            const previousResult = this.#combinedResult;
            const newTracked = this.#trackResult(this.#result, this.#observerMatches);
            const newResult = this.#combineResult(newTracked, this.#options?.combine);
            if (previousResult !== newResult) (0, $cnq4V.notifyManager).batch(()=>{
                this.listeners.forEach((listener)=>{
                    listener(this.#result);
                });
            });
        }
    }
};

});



parcelRegister("8iV6I", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $60bc4d7d5a13e9e6$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4tluv = parcelRequire("4tluv");

var $jAkMr = parcelRequire("jAkMr");

var $3X3Vo = parcelRequire("3X3Vo");

var $9H0BF = parcelRequire("9H0BF");

var $a4rov = parcelRequire("a4rov");

var $4eU0H = parcelRequire("4eU0H");

var $er86a = parcelRequire("er86a");

var $fDJaB = parcelRequire("fDJaB");
var $60bc4d7d5a13e9e6$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat"
};
function $60bc4d7d5a13e9e6$export$3b4e64e77073e307(_ref) {
    var children = _ref.children, xcss = _ref.xcss, _ref$height = _ref.height, height = _ref$height === void 0 ? (0, $3X3Vo.fg)('platform_dst_nav4_banner_default_height') ? 48 : 64 : _ref$height, _ref$skipLinkLabel = _ref.skipLinkLabel, skipLinkLabel = _ref$skipLinkLabel === void 0 ? 'Banner' : _ref$skipLinkLabel, testId = _ref.testId, providedId = _ref.id;
    var dangerouslyHoistSlotSizes = (0, $4tluv.useContext)((0, $4eU0H.DangerouslyHoistSlotSizes));
    var id = (0, $fDJaB.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 height.
   */ (0, $9H0BF.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0
    });
    return /*#__PURE__*/ $4tluv.createElement("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $jAkMr.default)([
            $60bc4d7d5a13e9e6$var$styles.root,
            xcss
        ]),
        "data-testid": testId
    }, /*#__PURE__*/ $4tluv.createElement((0, $er86a.HoistCssVarToLocalGrid), {
        variableName: (0, $a4rov.bannerMountedVar),
        value: height
    }), dangerouslyHoistSlotSizes && /*#__PURE__*/ // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    $4tluv.createElement((0, $er86a.DangerouslyHoistCssVarToDocumentRoot), {
        variableName: (0, $a4rov.UNSAFE_bannerVar),
        value: height
    }), children);
}

});


//# sourceMappingURL=OptionsPage.fe21f511.js.map
